export type Lang = "ES" | "EN" | "PT";

export const LANGS: Lang[] = ["ES", "EN", "PT"];

type Entry = { ES: string; EN: string; PT: string };
type Dict = Record<string, Entry>;

export const dict: Dict = {
  // Global Soccer Oracle / dual AI access
  comm_tab_match_ai: { ES: "Analista", EN: "Analyst", PT: "Analista" },
  comm_tab_global_oracle: { ES: "Global Oracle", EN: "Global Oracle", PT: "Global Oracle" },
  global_oracle_title: { ES: "Global Soccer Oracle", EN: "Global Soccer Oracle", PT: "Global Soccer Oracle" },
  global_oracle_badge_premium: { ES: "Premium", EN: "Premium", PT: "Premium" },
  global_oracle_trial_left: {
    ES: "Prueba: {n} restantes",
    EN: "Trial: {n} left",
    PT: "Teste: {n} restantes",
  },
  global_oracle_greeting: {
    ES: "Hola, soy el Global Soccer Oracle. Pregúntame sobre historia, ligas, récords, jugadores o comparaciones del fútbol mundial.",
    EN: "Hi, I'm the Global Soccer Oracle. Ask me about football history, leagues, records, players or worldwide comparisons.",
    PT: "Olá, sou o Global Soccer Oracle. Pergunte sobre história, ligas, recordes, jogadores ou comparações do futebol mundial.",
  },
  global_oracle_placeholder: {
    ES: "Pregunta sobre cualquier tema de fútbol mundial…",
    EN: "Ask anything about world football…",
    PT: "Pergunte sobre qualquer tema do futebol mundial…",
  },
  global_oracle_paywall_title: {
    ES: "Desbloquea el Global Soccer Oracle",
    EN: "Unlock the Global Soccer Oracle",
    PT: "Desbloqueie o Global Soccer Oracle",
  },
  global_oracle_paywall_trial_done: {
    ES: "Has usado tu prueba diaria",
    EN: "You've used today's free trial",
    PT: "Você usou seu teste diário",
  },
  global_oracle_paywall_desc: {
    ES: "Disfruta de 10 preguntas gratis del Global Soccer Oracle cada día. Mejora a Pro para 200 preguntas premium diarias.",
    EN: "Enjoy 10 free Global Soccer Oracle questions every day. Upgrade to Pro for 200 premium questions daily.",
    PT: "Aproveite 10 perguntas grátis do Global Soccer Oracle por dia. Faça upgrade para Pro e tenha 200 perguntas premium diárias.",
  },
  global_oracle_paywall_disabled: {
    ES: "Esta función está temporalmente deshabilitada.",
    EN: "This feature is temporarily disabled.",
    PT: "Este recurso está temporariamente desativado.",
  },
  global_oracle_feat_history: {
    ES: "Historia y récords mundiales",
    EN: "History and world records",
    PT: "História e recordes mundiais",
  },
  global_oracle_feat_leagues: {
    ES: "Champions, Premier, La Liga, Serie A, Bundesliga, Mundial",
    EN: "Champions, Premier, La Liga, Serie A, Bundesliga, World Cup",
    PT: "Champions, Premier, La Liga, Serie A, Bundesliga, Copa do Mundo",
  },
  global_oracle_feat_compare: {
    ES: "Comparaciones y rankings entre jugadores",
    EN: "Player comparisons and rankings",
    PT: "Comparações e rankings entre jogadores",
  },
  global_oracle_upgrade_cta: { ES: "Hacer upgrade", EN: "Upgrade now", PT: "Fazer upgrade" },
  go_admin_title: { ES: "Global Soccer Oracle", EN: "Global Soccer Oracle", PT: "Global Soccer Oracle" },
  go_admin_desc: {
    ES: "Configura el acceso premium al Oracle global y los límites por plan.",
    EN: "Configure premium access to the Global Oracle and per-plan limits.",
    PT: "Configure o acesso premium ao Global Oracle e limites por plano.",
  },
  go_admin_enable: { ES: "Habilitar Global Oracle", EN: "Enable Global Oracle", PT: "Ativar Global Oracle" },
  go_admin_sponsored: {
    ES: "Sponsored Premium incluye Global Oracle",
    EN: "Sponsored Premium includes Global Oracle",
    PT: "Sponsored Premium inclui Global Oracle",
  },
  go_admin_trial: { ES: "Preguntas de prueba/día (Free)", EN: "Trial questions per day (Free)", PT: "Perguntas de teste/dia (Free)" },
  go_admin_words_free: { ES: "Máx. palabras (Free)", EN: "Max words (Free)", PT: "Máx. palavras (Free)" },
  go_admin_words_pro: { ES: "Máx. palabras (Pro)", EN: "Max words (Pro)", PT: "Máx. palavras (Pro)" },
  go_admin_words_ent: { ES: "Máx. palabras (Enterprise)", EN: "Max words (Enterprise)", PT: "Máx. palavras (Enterprise)" },
  go_admin_words_sp: { ES: "Máx. palabras (Sponsored Premium)", EN: "Max words (Sponsored Premium)", PT: "Máx. palavras (Sponsored Premium)" },
  go_admin_qpd_pro: { ES: "Preguntas/día (Pro)", EN: "Questions per day (Pro)", PT: "Perguntas/dia (Pro)" },
  go_admin_qpd_sp: { ES: "Preguntas/día (Sponsored Premium)", EN: "Questions per day (Sponsored Premium)", PT: "Perguntas/dia (Sponsored Premium)" },
  go_admin_qpd_ent: { ES: "Preguntas/día (Enterprise, 0 = ilimitado)", EN: "Questions per day (Enterprise, 0 = unlimited)", PT: "Perguntas/dia (Enterprise, 0 = ilimitado)" },
  go_admin_save: { ES: "Guardar", EN: "Save", PT: "Salvar" },
  go_admin_saved: { ES: "Configuración guardada", EN: "Settings saved", PT: "Configurações salvas" },

  // Localization sweep — radar / banners / promos / widgets / share
  radar_hint_tap_focus: {
    ES: "Toca un jugador para enfocar · arrastra para girar 360°",
    EN: "Tap a player to focus · drag to rotate 360°",
    PT: "Toque em um jogador para focar · arraste para girar 360°",
  },
  radar_hint_drag_zoom: {
    ES: "Arrastra para 360° · rueda/pinch para zoom",
    EN: "Drag for 360° · wheel/pinch to zoom",
    PT: "Arraste para 360° · roda/pinça para zoom",
  },
  radar_close_focus: { ES: "Cerrar enfoque", EN: "Close focus", PT: "Fechar foco" },
  radar_rotate_left: { ES: "Rotar a la izquierda", EN: "Rotate left", PT: "Girar à esquerda" },
  radar_rotate_right: { ES: "Rotar a la derecha", EN: "Rotate right", PT: "Girar à direita" },
  radar_zoom_in: { ES: "Acercar", EN: "Zoom in", PT: "Aproximar" },
  radar_zoom_out: { ES: "Alejar", EN: "Zoom out", PT: "Afastar" },
  common_close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  common_previous: { ES: "Anterior", EN: "Previous", PT: "Anterior" },
  common_next: { ES: "Siguiente", EN: "Next", PT: "Próximo" },
  common_copy: { ES: "Copiar", EN: "Copy", PT: "Copiar" },
  common_loading: { ES: "Cargando…", EN: "Loading…", PT: "Carregando…" },
  // Geo banner
  geo_media_default: {
    ES: "Vive el Mundial 2026 desde {city} con datos Pro.",
    EN: "Experience World Cup 2026 from {city} with Pro data.",
    PT: "Viva a Copa do Mundo 2026 desde {city} com dados Pro.",
  },
  geo_media_cdmx: {
    ES: "Vive el España vs Argentina con VAR en tu bolsillo.",
    EN: "Experience Spain vs Argentina with VAR in your pocket.",
    PT: "Viva Espanha vs Argentina com o VAR no seu bolso.",
  },
  geo_media_miami: {
    ES: "Sigue a la selección desde Miami con datos Pro.",
    EN: "Follow your team from Miami with Pro data.",
    PT: "Acompanhe sua seleção desde Miami com dados Pro.",
  },
  geo_media_ny: {
    ES: "Vive cada jugada desde New York con el Radar Rayos X.",
    EN: "Live every play from New York with the X-Ray Radar.",
    PT: "Viva cada jogada desde Nova York com o Radar Raios X.",
  },
  geo_media_bog: {
    ES: "La pasión desde Bogotá: estadísticas premium en vivo.",
    EN: "Passion from Bogotá: premium live stats.",
    PT: "A paixão desde Bogotá: estatísticas premium ao vivo.",
  },
  geo_media_mad: {
    ES: "Tácticas profesionales desde Madrid en tu segunda pantalla.",
    EN: "Professional tactics from Madrid on your second screen.",
    PT: "Táticas profissionais desde Madrid na sua segunda tela.",
  },
  geo_betting_default: {
    ES: "Promoción responsable disponible en {city}. Sujeto a elegibilidad.",
    EN: "Responsible promotion available in {city}. Subject to eligibility.",
    PT: "Promoção responsável disponível em {city}. Sujeito à elegibilidade.",
  },
  geo_betting_cdmx: {
    ES: "Desde CDMX: promoción responsable disponible para este partido.",
    EN: "From CDMX: responsible promotion available for this match.",
    PT: "Desde CDMX: promoção responsável disponível para esta partida.",
  },
  geo_betting_miami: {
    ES: "Oferta responsable disponible desde Miami. Sujeto a elegibilidad.",
    EN: "Responsible offer available from Miami. Subject to eligibility.",
    PT: "Oferta responsável disponível desde Miami. Sujeito à elegibilidade.",
  },
  geo_betting_ny: {
    ES: "Promoción disponible desde New York. Aplican términos.",
    EN: "Promotion available from New York. Terms apply.",
    PT: "Promoção disponível desde Nova York. Aplicam-se termos.",
  },
  geo_betting_bog: {
    ES: "Oferta responsable disponible desde Bogotá.",
    EN: "Responsible offer available from Bogotá.",
    PT: "Oferta responsável disponível desde Bogotá.",
  },
  geo_betting_mad: {
    ES: "Promoción disponible desde Madrid. Sujeto a elegibilidad.",
    EN: "Promotion available from Madrid. Subject to eligibility.",
    PT: "Promoção disponível desde Madrid. Sujeito à elegibilidade.",
  },
  geo_cta_offer: { ES: "Ver oferta", EN: "View offer", PT: "Ver oferta" },
  geo_cta_more: { ES: "Saber más", EN: "Learn more", PT: "Saber mais" },
  geo_simulated: { ES: "SIMULADO", EN: "SIMULATED", PT: "SIMULADO" },
  geo_responsible: {
    ES: "Sujeto a elegibilidad. Juega responsable.",
    EN: "Subject to eligibility. Play responsibly.",
    PT: "Sujeito à elegibilidade. Jogue com responsabilidade.",
  },
  // Halftime carousel
  ht_label_media: { ES: "MEDIA", EN: "MEDIA", PT: "MEDIA" },
  ht_label_betting: { ES: "BETTING", EN: "BETTING", PT: "BETTING" },
  ht_label_halftime: { ES: "MEDIO TIEMPO", EN: "HALFTIME", PT: "INTERVALO" },
  ht_sponsor_title: { ES: "Patrocinador Oficial", EN: "Official Sponsor", PT: "Patrocinador Oficial" },
  ht_sponsor_body: {
    ES: "Descubre la nueva campaña de nuestros aliados durante el medio tiempo.",
    EN: "Discover our partners' new campaign during halftime.",
    PT: "Descubra a nova campanha dos nossos parceiros no intervalo.",
  },
  ht_sponsor_cta: { ES: "Ver patrocinador", EN: "View sponsor", PT: "Ver patrocinador" },
  ht_survey_title: { ES: "Tu Voz Cuenta", EN: "Your Voice Counts", PT: "Sua Voz Conta" },
  ht_survey_body: {
    ES: "Responde una encuesta rápida y gana puntos para tu próximo canje.",
    EN: "Take a quick survey and earn points for your next reward.",
    PT: "Responda a uma pesquisa rápida e ganhe pontos para o próximo resgate.",
  },
  ht_survey_cta: { ES: "Responder", EN: "Answer", PT: "Responder" },
  ht_trivia_title: { ES: "Trivia Mundialista", EN: "World Cup Trivia", PT: "Trivia da Copa" },
  ht_trivia_body: {
    ES: "Demuestra cuánto sabes del partido y desbloquea recompensas.",
    EN: "Show how much you know about the match and unlock rewards.",
    PT: "Mostre o quanto sabe da partida e desbloqueie recompensas.",
  },
  ht_trivia_cta: { ES: "Jugar trivia", EN: "Play trivia", PT: "Jogar trivia" },
  ht_coupon_title: { ES: "Cupón Halftime", EN: "Halftime Coupon", PT: "Cupom do Intervalo" },
  ht_coupon_body: {
    ES: "Activa tu cupón exclusivo durante el descanso del partido.",
    EN: "Activate your exclusive coupon during halftime.",
    PT: "Ative seu cupom exclusivo durante o intervalo da partida.",
  },
  ht_coupon_cta: { ES: "Canjear cupón", EN: "Redeem coupon", PT: "Resgatar cupom" },
  ht_offer_title: { ES: "Oferta Responsable", EN: "Responsible Offer", PT: "Oferta Responsável" },
  ht_offer_body: {
    ES: "Promoción disponible durante el medio tiempo. Sujeto a elegibilidad.",
    EN: "Promotion available during halftime. Subject to eligibility.",
    PT: "Promoção disponível durante o intervalo. Sujeito à elegibilidade.",
  },
  ht_offer_cta: { ES: "Ver promoción", EN: "View promotion", PT: "Ver promoção" },
  ht_stats_title: { ES: "Estadísticas del 1T", EN: "First Half Stats", PT: "Estatísticas do 1T" },
  ht_stats_body: {
    ES: "Posesión, tiros, xG y mapa de calor del primer tiempo.",
    EN: "Possession, shots, xG and heatmap from the first half.",
    PT: "Posse, finalizações, xG e mapa de calor do primeiro tempo.",
  },
  ht_stats_cta: { ES: "Ver estadísticas", EN: "View stats", PT: "Ver estatísticas" },
  ht_bonus_title: { ES: "Bono Responsable", EN: "Responsible Bonus", PT: "Bônus Responsável" },
  ht_bonus_body: {
    ES: "Promoción disponible. Aplican términos. Juega con responsabilidad.",
    EN: "Promotion available. Terms apply. Play responsibly.",
    PT: "Promoção disponível. Aplicam-se termos. Jogue com responsabilidade.",
  },
  ht_bonus_cta: { ES: "Ver términos", EN: "View terms", PT: "Ver termos" },
  ht_disclaimer: {
    ES: "Promoción simulada con fines demostrativos. Sujeto a términos, elegibilidad y jurisdicción. Juega con responsabilidad.",
    EN: "Simulated promotion for demo purposes. Subject to terms, eligibility and jurisdiction. Play responsibly.",
    PT: "Promoção simulada para fins demonstrativos. Sujeito a termos, elegibilidade e jurisdição. Jogue com responsabilidade.",
  },
  // Event timeline / VAR widget
  timeline_title: { ES: "LÍNEA DE TIEMPO", EN: "TIMELINE", PT: "LINHA DO TEMPO" },
  timeline_empty: {
    ES: "Eventos en vivo aparecerán aquí…",
    EN: "Live events will appear here…",
    PT: "Eventos ao vivo aparecerão aqui…",
  },
  ev_goal: { ES: "¡Gol!", EN: "Goal!", PT: "Gol!" },
  ev_shot: { ES: "Tiro al arco", EN: "Shot on goal", PT: "Chute ao gol" },
  ev_foul: { ES: "Falta peligrosa", EN: "Dangerous foul", PT: "Falta perigosa" },
  ev_prediction: { ES: "Predicción activa", EN: "Active prediction", PT: "Previsão ativa" },
  // Official match events (Real Data Phase 2)
  mev_prematch_empty: {
    ES: "Aún no hay eventos del partido",
    EN: "No match events yet",
    PT: "Ainda não há eventos do jogo",
  },
  mev_live_waiting: {
    ES: "Esperando eventos oficiales del partido…",
    EN: "Waiting for official match events…",
    PT: "Aguardando eventos oficiais do jogo…",
  },
  mev_finished_none: {
    ES: "No hay eventos oficiales disponibles",
    EN: "No official events available",
    PT: "Não há eventos oficiais disponíveis",
  },
  mev_source: { ES: "Fuente oficial", EN: "Official source", PT: "Fonte oficial" },
  mev_goal:            { ES: "Gol",                 EN: "Goal",                 PT: "Gol" },
  mev_penalty_goal:    { ES: "Gol de penal",        EN: "Penalty goal",         PT: "Gol de pênalti" },
  mev_penalty_missed:  { ES: "Penal fallado",       EN: "Penalty missed",       PT: "Pênalti perdido" },
  mev_goal_disallowed: { ES: "Gol anulado",         EN: "Goal disallowed",      PT: "Gol anulado" },
  mev_own_goal:        { ES: "Autogol",             EN: "Own goal",             PT: "Gol contra" },
  mev_yellow_card:     { ES: "Amarilla",            EN: "Yellow card",          PT: "Amarelo" },
  mev_red_card:        { ES: "Roja",                EN: "Red card",             PT: "Vermelho" },
  mev_second_yellow:   { ES: "Doble amarilla",      EN: "Second yellow",        PT: "Segundo amarelo" },
  mev_substitution:    { ES: "Cambio",              EN: "Substitution",         PT: "Substituição" },
  mev_var_review:      { ES: "Revisión VAR",        EN: "VAR review",           PT: "Revisão do VAR" },
  mev_var_goal:        { ES: "VAR: gol validado",   EN: "VAR: goal awarded",    PT: "VAR: gol validado" },
  mev_var_cancelled:   { ES: "VAR: gol anulado",    EN: "VAR: goal cancelled",  PT: "VAR: gol anulado" },
  mev_half_time:       { ES: "Medio tiempo",        EN: "Half time",            PT: "Intervalo" },
  mev_second_half:     { ES: "Segundo tiempo",      EN: "Second half",          PT: "Segundo tempo" },
  mev_extra_time:      { ES: "Tiempo extra",        EN: "Extra time",           PT: "Prorrogação" },
  mev_penalty_shootout:{ ES: "Tanda de penales",    EN: "Penalty shootout",     PT: "Disputa de pênaltis" },
  mev_full_time:       { ES: "Final",               EN: "Full time",            PT: "Fim de jogo" },
  mev_interruption:    { ES: "Interrupción",        EN: "Interruption",         PT: "Interrupção" },
  mev_unknown:         { ES: "Evento",              EN: "Event",                PT: "Evento" },
  var_title: { ES: "VAR · REVISIÓN TÁCTICA", EN: "VAR · TACTICAL REVIEW", PT: "VAR · REVISÃO TÁTICA" },
  var_active: { ES: "ACTIVA", EN: "ACTIVE", PT: "ATIVO" },
  var_idle: { ES: "EN ESPERA", EN: "STANDBY", PT: "EM ESPERA" },
  var_reason_freekick: { ES: "Falta en zona ofensiva", EN: "Foul in attacking zone", PT: "Falta em zona ofensiva" },
  var_decision_freekick: { ES: "Decisión probable: tiro libre", EN: "Likely decision: free kick", PT: "Decisão provável: tiro livre" },
  var_reason_box: { ES: "Contacto en el área", EN: "Contact in the box", PT: "Contato na área" },
  var_decision_pen: { ES: "Posible revisión de penal", EN: "Possible penalty review", PT: "Possível revisão de pênalti" },
  var_reason_through: { ES: "Pase en profundidad", EN: "Through ball", PT: "Passe em profundidade" },
  var_decision_offside: { ES: "Posible fuera de juego", EN: "Possible offside", PT: "Possível impedimento" },
  var_reason_idle: { ES: "Sin revisión activa", EN: "No active review", PT: "Sem revisão ativa" },
  var_decision_idle: { ES: "Juego en desarrollo", EN: "Match in progress", PT: "Jogo em andamento" },
  // Share sheet
  share_title: { ES: "Comparte la experiencia", EN: "Share the experience", PT: "Compartilhe a experiência" },
  share_link_label: { ES: "TU LINK", EN: "YOUR LINK", PT: "SEU LINK" },
  share_code_label: { ES: "Código", EN: "Code", PT: "Código" },
  share_referrals: { ES: "Tus referidos", EN: "Your referrals", PT: "Seus indicados" },
  share_remaining: {
    ES: "Te faltan {n} para desbloquear {tier}.",
    EN: "You need {n} more to unlock {tier}.",
    PT: "Faltam {n} para desbloquear {tier}.",
  },
  share_msg: {
    ES: "Estoy viviendo el Mundial 2026 con VerseSport™: radar táctico, predicciones en vivo y Nation Wars para defender tu bandera. Únete aquí:",
    EN: "I'm living the 2026 World Cup with VerseSport™: tactical radar, live predictions, and Nation Wars to defend your flag. Join here:",
    PT: "Estou vivendo a Copa do Mundo 2026 com VerseSport™: radar tático, previsões ao vivo e Nation Wars para defender sua bandeira. Junte-se aqui:",
  },
  share_copied: { ES: "Enlace copiado", EN: "Link copied", PT: "Link copiado" },
  share_copy_failed: { ES: "No se pudo copiar", EN: "Couldn't copy", PT: "Não foi possível copiar" },
  // i18n coverage admin panel
  i18n_panel_title: { ES: "Cobertura i18n", EN: "i18n Coverage", PT: "Cobertura i18n" },
  i18n_panel_desc: {
    ES: "Detección automática de claves faltantes y textos hardcoded en runtime.",
    EN: "Automatic detection of missing keys and hardcoded strings at runtime.",
    PT: "Detecção automática de chaves ausentes e textos hardcoded em tempo de execução.",
  },
  i18n_panel_keys: { ES: "Claves totales", EN: "Total keys", PT: "Chaves totais" },
  i18n_panel_missing: { ES: "Claves faltantes detectadas", EN: "Missing keys detected", PT: "Chaves ausentes detectadas" },
  i18n_panel_fallbacks: { ES: "Fallbacks usados", EN: "Fallbacks used", PT: "Fallbacks usados" },
  i18n_panel_hardcoded: { ES: "Textos hardcoded detectados", EN: "Hardcoded strings detected", PT: "Textos hardcoded detectados" },
  i18n_panel_coverage: { ES: "Cobertura ES/EN/PT", EN: "ES/EN/PT coverage", PT: "Cobertura ES/EN/PT" },
  i18n_panel_clear: { ES: "Limpiar", EN: "Clear", PT: "Limpar" },

  // Match Clock
  clock_phase_pre_match: { ES: "Pre-partido", EN: "Pre-Match", PT: "Pré-jogo" },
  clock_phase_first_half: { ES: "1er Tiempo", EN: "1st Half", PT: "1º Tempo" },
  clock_phase_halftime: { ES: "Entretiempo", EN: "Halftime", PT: "Intervalo" },
  clock_phase_second_half: { ES: "2do Tiempo", EN: "2nd Half", PT: "2º Tempo" },
  clock_phase_extra_time: { ES: "Tiempo Extra", EN: "Extra Time", PT: "Prorrogação" },
  clock_phase_penalties: { ES: "Penales", EN: "Penalties", PT: "Pênaltis" },
  clock_phase_full_time: { ES: "Final", EN: "Full Time", PT: "Encerrado" },
  clock_phase_suspended: { ES: "Suspendido", EN: "Suspended", PT: "Suspenso" },
  clock_kickoff_short: { ES: "0:00", EN: "0:00", PT: "0:00" },
  clock_suspended_short: { ES: "SUSP", EN: "SUSP", PT: "SUSP" },
  clock_remaining_pre: {
    ES: "El partido está por comenzar",
    EN: "Match about to start",
    PT: "A partida está prestes a começar",
  },
  clock_remaining_ht: {
    ES: "Descanso · 15 min aprox",
    EN: "Halftime · ~15 min",
    PT: "Intervalo · ~15 min",
  },
  clock_remaining_ft: {
    ES: "Partido finalizado",
    EN: "Match finished",
    PT: "Partida encerrada",
  },
  clock_remaining_pen: {
    ES: "Definición por penales",
    EN: "Penalty shootout",
    PT: "Disputa de pênaltis",
  },
  clock_remaining_et: {
    ES: "Tiempo extra en curso",
    EN: "Extra time in progress",
    PT: "Prorrogação em andamento",
  },
  clock_remaining_suspended: {
    ES: "Partido suspendido",
    EN: "Match suspended",
    PT: "Partida suspensa",
  },
  clock_remaining_first_half: {
    ES: "≈ {n} min para el descanso",
    EN: "≈ {n} min to halftime",
    PT: "≈ {n} min para o intervalo",
  },
  clock_remaining_second_half: {
    ES: "≈ {n} min restantes",
    EN: "≈ {n} min remaining",
    PT: "≈ {n} min restantes",
  },
  clock_remaining_half_end_soon: {
    ES: "≈ 2 min + tiempo añadido",
    EN: "≈ 2 min + stoppage time",
    PT: "≈ 2 min + acréscimos",
  },
  clock_remaining_match_end_soon: {
    ES: "El partido está por terminar",
    EN: "Match ending soon",
    PT: "A partida está terminando",
  },
  clock_remaining_stoppage_short: {
    ES: "Tiempo añadido",
    EN: "Stoppage time",
    PT: "Acréscimos",
  },

  // Match Clock Admin
  clock_admin_title: {
    ES: "Match Clock Experience",
    EN: "Match Clock Experience",
    PT: "Match Clock Experience",
  },
  clock_admin_subtitle: {
    ES: "Controla la visibilidad del reloj, tiempo restante y resaltado de momentos críticos.",
    EN: "Control the visibility of the clock, remaining time and critical-moment highlighting.",
    PT: "Controle a visibilidade do relógio, tempo restante e realce de momentos críticos.",
  },
  clock_admin_enable: {
    ES: "Activar Match Clock",
    EN: "Enable Match Clock",
    PT: "Ativar Match Clock",
  },
  clock_admin_remaining: {
    ES: "Mostrar tiempo restante",
    EN: "Show remaining time",
    PT: "Mostrar tempo restante",
  },
  clock_admin_progress: {
    ES: "Mostrar barra de progreso",
    EN: "Show progress bar",
    PT: "Mostrar barra de progresso",
  },
  clock_admin_critical: {
    ES: "Resaltar momentos críticos",
    EN: "Highlight critical moments",
    PT: "Realçar momentos críticos",
  },
  clock_admin_saved: {
    ES: "Configuración guardada",
    EN: "Settings saved",
    PT: "Configurações salvas",
  },

  // Production Readiness Center
  readiness_title: {
    ES: "Production Readiness Command Center",
    EN: "Production Readiness Command Center",
    PT: "Production Readiness Command Center",
  },
  readiness_global_score: {
    ES: "SCORE GLOBAL",
    EN: "GLOBAL SCORE",
    PT: "SCORE GLOBAL",
  },
  readiness_go_status: { ES: "ESTADO LANZAMIENTO", EN: "LAUNCH STATUS", PT: "STATUS DE LANÇAMENTO" },
  readiness_blockers: { ES: "BLOQUEADORES", EN: "BLOCKERS", PT: "BLOQUEADORES" },
  readiness_no_blockers: {
    ES: "Sin bloqueadores críticos",
    EN: "No critical blockers",
    PT: "Sem bloqueadores críticos",
  },
  readiness_blockers_listed: {
    ES: "Pendientes priorizados abajo",
    EN: "Priority items listed below",
    PT: "Pendências priorizadas abaixo",
  },
  readiness_priority_pending: {
    ES: "Pendientes priorizados",
    EN: "Priority pending items",
    PT: "Pendências priorizadas",
  },
  readiness_stress_title: {
    ES: "Stress Test Checklist",
    EN: "Stress Test Checklist",
    PT: "Stress Test Checklist",
  },
  readiness_recalc: { ES: "Recalcular", EN: "Recalculate", PT: "Recalcular" },
  readiness_last_run: { ES: "Última ejecución", EN: "Last run", PT: "Última execução" },
  readiness_approve: { ES: "Aprobar lanzamiento", EN: "Approve launch", PT: "Aprovar lançamento" },

  // Live / radar
  live: { ES: "EN VIVO", EN: "LIVE", PT: "AO VIVO" },
  radar_live: { ES: "RADAR 3D · EN VIVO", EN: "3D RADAR · LIVE", PT: "RADAR 3D · AO VIVO" },
  danger_zone: { ES: "⚠ ZONA DE PELIGRO", EN: "⚠ DANGER ZONE", PT: "⚠ ZONA DE PERIGO" },
  loading_radar: { ES: "Cargando radar 3D…", EN: "Loading 3D radar…", PT: "Carregando radar 3D…" },
  xray: { ES: "RAYOS X TÁCTICO", EN: "TACTICAL X-RAY", PT: "RAIO-X TÁTICO" },
  goal_prob: { ES: "Probabilidad de gol", EN: "Goal probability", PT: "Probabilidade de gol" },
  key_pass: { ES: "Pase clave probable", EN: "Key pass likely", PT: "Passe-chave provável" },
  def_risk: { ES: "Riesgo defensivo alto", EN: "High defensive risk", PT: "Alto risco defensivo" },

  // Participation
  participate_now: { ES: "Participar Ahora", EN: "Join Now", PT: "Participar Agora" },
  cta_answer_poll: { ES: "Responder encuesta", EN: "Answer poll", PT: "Responder enquete" },
  cta_make_prediction: { ES: "Hacer predicción", EN: "Make prediction", PT: "Fazer previsão" },
  cta_claim_prize: { ES: "Reclamar premio", EN: "Claim prize", PT: "Resgatar prêmio" },
  cta_play_trivia: { ES: "Jugar trivia", EN: "Play trivia", PT: "Jogar quiz" },
  cta_earn_points: { ES: "Predicciones", EN: "Predictions", PT: "Previsões" },
  cta_save_coupon: { ES: "Guardar cupón", EN: "Save coupon", PT: "Salvar cupom" },
  cta_open_promo: { ES: "Abrir promoción", EN: "Open promo", PT: "Abrir promoção" },
  cta_view_offer: { ES: "Ver oferta", EN: "View offer", PT: "Ver oferta" },
  thanks_participate: { ES: "¡Gracias por participar!", EN: "Thanks for joining!", PT: "Obrigado por participar!" },
  thanks_sub: {
    ES: "Tu voz se suma al pulso de la afición.",
    EN: "Your voice joins the pulse of fans.",
    PT: "Sua voz se soma ao pulso da torcida.",
  },

  // AI
  ai_subtitle: { ES: "Analista táctico · En vivo", EN: "Tactical analyst · Live", PT: "Analista tático · Ao vivo" },
  ai_placeholder: { ES: "Pregunta al analista táctico…", EN: "Ask the tactical analyst…", PT: "Pergunte ao analista tático…" },
  ai_no_reply: {
    ES: "El analista táctico no respondió. Intenta de nuevo.",
    EN: "The tactical analyst did not respond. Try again.",
    PT: "O analista tático não respondeu. Tente novamente.",
  },
  ai_rate_limit: {
    ES: "Demasiadas consultas, intenta de nuevo en un momento.",
    EN: "Too many requests, please try again shortly.",
    PT: "Muitas consultas, tente novamente em instantes.",
  },
  ai_credits: {
    ES: "Créditos de IA agotados. Revisa tu workspace.",
    EN: "AI credits exhausted. Check your workspace.",
    PT: "Créditos de IA esgotados. Verifique sua workspace.",
  },
  ai_network_error: {
    ES: "Error de red consultando al analista.",
    EN: "Network error contacting the analyst.",
    PT: "Erro de rede ao consultar o analista.",
  },
  ai_online: { ES: "online", EN: "online", PT: "online" },

  // Match AI — reading mode discipline (PR — reading discipline pass)
  chat_reading_mode: {
    ES: "Modo lectura · pausando live",
    EN: "Reading mode · live paused",
    PT: "Modo leitura · ao vivo pausado",
  },
  chat_new_signals_one: {
    ES: "1 nueva señal",
    EN: "1 new signal",
    PT: "1 novo sinal",
  },
  chat_new_signals_many: {
    ES: "{n} nuevas señales",
    EN: "{n} new signals",
    PT: "{n} novos sinais",
  },
  chat_back_to_live: {
    ES: "Volver al live",
    EN: "Back to live",
    PT: "Voltar ao ao vivo",
  },

  // Header
  guest_demo: { ES: "Invitado", EN: "Guest", PT: "Convidado" },
  rewards: { ES: "Recompensas", EN: "Rewards", PT: "Recompensas" },
  rewards_catalog: { ES: "Catálogo de recompensas", EN: "Rewards catalog", PT: "Catálogo de recompensas" },
  multi_match: { ES: "Multi-Partido", EN: "Multi-Match", PT: "Multi-Jogo" },
  multi_match_on: { ES: "Multi-Partido: ON", EN: "Multi-Match: ON", PT: "Multi-Jogo: ON" },
  multi_match_off: { ES: "Multi-Partido: OFF", EN: "Multi-Match: OFF", PT: "Multi-Jogo: OFF" },
  matches: { ES: "Partidos", EN: "Matches", PT: "Jogos" },
  profile: { ES: "Perfil", EN: "Profile", PT: "Perfil" },

  // Bottom nav
  nav_radar: { ES: "Radar", EN: "Radar", PT: "Radar" },
  nav_chat: { ES: "Chat", EN: "Chat", PT: "Chat" },
  nav_stats: { ES: "Stats", EN: "Stats", PT: "Stats" },
  nav_profile: { ES: "Perfil", EN: "Profile", PT: "Perfil" },
  nav_advanced: { ES: "Insights Pro", EN: "Insights Pro", PT: "Insights Pro" },

  // Last touch + rewards center + vouchers
  last_touch_label: { ES: "Último toque:", EN: "Last touch:", PT: "Último toque:" },
  my_rewards_title: { ES: "Mis Premios", EN: "My Rewards", PT: "Meus Prêmios" },
  my_rewards_active: { ES: "Activos", EN: "Active", PT: "Ativos" },
  my_rewards_history: { ES: "Historial", EN: "History", PT: "Histórico" },
  my_rewards_empty_active: { ES: "Aún no tienes premios activos. Canjea puntos para empezar.", EN: "No active rewards yet. Redeem points to begin.", PT: "Nenhum prêmio ativo. Resgate pontos para começar." },
  my_rewards_empty_history: { ES: "Sin historial todavía.", EN: "No history yet.", PT: "Sem histórico ainda." },
  my_rewards_footer: { ES: "Muestra tu QR o código en el comercio para canjear.", EN: "Show your QR or code at the store to redeem.", PT: "Mostre seu QR ou código no parceiro para resgatar." },
  voucher_status_redeemed: { ES: "Canjeado", EN: "Redeemed", PT: "Resgatado" },
  voucher_status_expired: { ES: "Expirado", EN: "Expired", PT: "Expirado" },
  voucher_code_copied: { ES: "Código copiado", EN: "Code copied", PT: "Código copiado" },
  voucher_code_copy_failed: { ES: "No se pudo copiar el código", EN: "Could not copy code", PT: "Não foi possível copiar" },
  voucher_action_pdf: { ES: "PDF", EN: "PDF", PT: "PDF" },
  voucher_action_email: { ES: "Email", EN: "Email", PT: "Email" },
  voucher_action_whatsapp: { ES: "WhatsApp", EN: "WhatsApp", PT: "WhatsApp" },
  voucher_email_resent: { ES: "Voucher reenviado por email", EN: "Voucher email resent", PT: "Voucher reenviado por email" },
  voucher_email_no_recipient: { ES: "Agrega tu email para recibir el voucher", EN: "Add your email to receive the voucher", PT: "Adicione seu email para receber o voucher" },
  voucher_email_failed: { ES: "No se pudo enviar el email", EN: "Could not send email", PT: "Não foi possível enviar email" },
  voucher_email_pending_config: { ES: "Entrega de email pendiente de configuración del dominio.", EN: "Email delivery pending domain configuration.", PT: "Entrega de email pendente da configuração do domínio." },
  res_title: { ES: "Estado de Email de Recompensas", EN: "Reward Email Status", PT: "Status de Email de Recompensas" },
  res_subtitle: { ES: "Controla la entrega real de vouchers por email. Mantén deshabilitado hasta verificar el dominio oficial.", EN: "Controls real voucher email delivery. Keep disabled until the official domain is verified.", PT: "Controla a entrega real de vouchers por email. Mantenha desativado até verificar o domínio oficial." },
  res_domain_configured: { ES: "Dominio configurado", EN: "Domain configured", PT: "Domínio configurado" },
  res_delivery_enabled: { ES: "Envío activo", EN: "Delivery enabled", PT: "Envio ativo" },
  res_pending_count: { ES: "Emails en espera", EN: "Pending emails", PT: "Emails pendentes" },
  res_pending_domain: { ES: "Configura un dominio antes de activar la entrega real.", EN: "Configure a domain before enabling real delivery.", PT: "Configure um domínio antes de ativar a entrega real." },
  res_mark_domain_set: { ES: "Marcar dominio configurado", EN: "Mark domain configured", PT: "Marcar domínio configurado" },
  res_mark_domain_unset: { ES: "Marcar dominio sin configurar", EN: "Mark domain unconfigured", PT: "Marcar domínio não configurado" },
  res_enable_delivery: { ES: "Activar entrega real", EN: "Enable real delivery", PT: "Ativar entrega real" },
  res_disable_delivery: { ES: "Desactivar entrega real", EN: "Disable real delivery", PT: "Desativar entrega real" },
  res_flag_updated: { ES: "Configuración actualizada", EN: "Setting updated", PT: "Configuração atualizada" },
  voucher_pdf_failed: { ES: "No se pudo generar el PDF", EN: "Could not generate PDF", PT: "Não foi possível gerar PDF" },
  vvp_title: { ES: "Validar Voucher", EN: "Validate Voucher", PT: "Validar Voucher" },
  vvp_acting_as: { ES: "Validando como", EN: "Validating as", PT: "Validando como" },
  vvp_need_login: { ES: "Inicia sesión para validar vouchers.", EN: "Sign in to validate vouchers.", PT: "Entre para validar vouchers." },
  vvp_no_access: { ES: "Tu cuenta no tiene permisos de validador.", EN: "Your account has no validator permissions.", PT: "Sua conta não tem permissões de validador." },
  vvp_start_scan: { ES: "Escanear QR", EN: "Scan QR", PT: "Escanear QR" },
  vvp_stop_scan: { ES: "Detener escáner", EN: "Stop scanner", PT: "Parar scanner" },
  vvp_or: { ES: "o ingresa el código manualmente", EN: "or enter code manually", PT: "ou digite o código" },
  vvp_lookup: { ES: "Buscar", EN: "Lookup", PT: "Buscar" },
  vvp_code: { ES: "Código", EN: "Code", PT: "Código" },
  vvp_expires: { ES: "Expira", EN: "Expires", PT: "Expira" },
  vvp_redeem: { ES: "Redimir", EN: "Redeem", PT: "Resgatar" },
  vvp_reject: { ES: "Rechazar", EN: "Reject", PT: "Rejeitar" },
  vvp_redeemed: { ES: "Voucher redimido", EN: "Voucher redeemed", PT: "Voucher resgatado" },
  vvp_rejected: { ES: "Voucher rechazado", EN: "Voucher rejected", PT: "Voucher rejeitado" },
  vvp_err_not_found: { ES: "Voucher no encontrado", EN: "Voucher not found", PT: "Voucher não encontrado" },
  vvp_err_expired: { ES: "Voucher expirado", EN: "Voucher expired", PT: "Voucher expirado" },
  vvp_err_already_redeemed: { ES: "Ya fue redimido", EN: "Already redeemed", PT: "Já foi resgatado" },
  vvp_err_cancelled: { ES: "Voucher cancelado", EN: "Voucher cancelled", PT: "Voucher cancelado" },
  vvp_err_partner_mismatch: { ES: "Este voucher pertenece a otro comercio", EN: "Voucher belongs to another partner", PT: "Voucher de outro parceiro" },
  vvp_err_geo_mismatch: { ES: "Ubicación no autorizada", EN: "Unauthorized location", PT: "Localização não autorizada" },
  vvp_err_race_lost: { ES: "El voucher fue redimido en paralelo", EN: "Voucher was redeemed concurrently", PT: "Voucher resgatado em paralelo" },
  vvp_err_unknown: { ES: "Error desconocido", EN: "Unknown error", PT: "Erro desconhecido" },
  rvm_action_resend: { ES: "Reenviar email", EN: "Resend email", PT: "Reenviar email" },
  rvm_action_cancel: { ES: "Cancelar", EN: "Cancel", PT: "Cancelar" },
  rvm_action_extend: { ES: "+30 días", EN: "+30 days", PT: "+30 dias" },
  rvm_action_force: { ES: "Forzar redención", EN: "Force redeem", PT: "Forçar resgate" },
  voucher_expires_on: { ES: "Expira el", EN: "Expires on", PT: "Expira em" },
  voucher_instructions: { ES: "Presenta este QR al vendedor. El código solo puede usarse una vez.", EN: "Show this QR to the merchant. The code can only be used once.", PT: "Apresente este QR ao parceiro. O código só pode ser usado uma vez." },
  copy: { ES: "Copiar", EN: "Copy", PT: "Copiar" },

  // Dynamic prediction templates
  pred_default_player: { ES: "el jugador", EN: "the player", PT: "o jogador" },
  pred_goal_1: { ES: "🔥 ¿Habrá gol en los próximos 3 minutos?", EN: "🔥 Goal in the next 3 minutes?", PT: "🔥 Vai sair gol nos próximos 3 minutos?" },
  pred_goal_2: { ES: "⚡ {player} entra al área. ¿Se viene el gol?", EN: "⚡ {player} enters the box. Goal coming?", PT: "⚡ {player} entra na área. Vem gol aí?" },
  pred_goal_3: { ES: "🎯 ¿Anotará {team} antes del minuto siguiente?", EN: "🎯 Will {team} score before the next minute?", PT: "🎯 {team} marca antes do próximo minuto?" },
  pred_goal_4: { ES: "🚀 Momento decisivo. ¿Gol o no gol?", EN: "🚀 Decisive moment. Goal or no goal?", PT: "🚀 Momento decisivo. Gol ou nada?" },
  pred_goal_5: { ES: "⭐ ¿Será {player} el héroe del minuto?", EN: "⭐ Will {player} be the hero of the minute?", PT: "⭐ {player} será o herói do minuto?" },
  pred_corner_1: { ES: "🚩 ¿Habrá córner en los próximos 2 minutos?", EN: "🚩 Corner in the next 2 minutes?", PT: "🚩 Escanteio nos próximos 2 minutos?" },
  pred_corner_2: { ES: "⚡ Presión máxima. ¿Llega el córner?", EN: "⚡ Max pressure. Corner incoming?", PT: "⚡ Pressão máxima. Vem escanteio?" },
  pred_corner_3: { ES: "🎯 ¿El próximo balón parado será córner?", EN: "🎯 Will the next set piece be a corner?", PT: "🎯 A próxima bola parada será escanteio?" },
  pred_corner_4: { ES: "🔥 ¿{team} forzará un córner ya?", EN: "🔥 Will {team} force a corner now?", PT: "🔥 {team} vai forçar um escanteio já?" },
  pred_card_1: { ES: "🟨 ¿Caerá tarjeta en los próximos 90 segundos?", EN: "🟨 Card in the next 90 seconds?", PT: "🟨 Vem cartão nos próximos 90 segundos?" },
  pred_card_2: { ES: "⚠️ Tensión alta. ¿Amarilla en camino?", EN: "⚠️ High tension. Yellow incoming?", PT: "⚠️ Tensão alta. Amarelo a caminho?" },
  pred_card_3: { ES: "🟥 ¿Se viene tarjeta para {player}?", EN: "🟥 Card coming for {player}?", PT: "🟥 Vem cartão para {player}?" },
  pred_card_4: { ES: "👀 ¿El árbitro sacará la tarjeta?", EN: "👀 Will the ref show the card?", PT: "👀 O árbitro vai mostrar o cartão?" },
  pred_var_1: { ES: "📺 ¿Habrá revisión del VAR pronto?", EN: "📺 VAR review coming up?", PT: "📺 Vai ter revisão do VAR?" },
  pred_var_2: { ES: "🔍 Jugada dudosa. ¿Llamará el VAR?", EN: "🔍 Dubious play. Will VAR step in?", PT: "🔍 Lance duvidoso. O VAR vai entrar?" },
  pred_var_3: { ES: "⚖️ ¿El VAR cambiará la decisión?", EN: "⚖️ Will VAR change the call?", PT: "⚖️ O VAR muda a decisão?" },
  pred_sub_1: { ES: "🔄 ¿Habrá cambio en los próximos 5 minutos?", EN: "🔄 Substitution in the next 5 minutes?", PT: "🔄 Substituição nos próximos 5 minutos?" },
  pred_sub_2: { ES: "🆕 ¿Sale {player} ya?", EN: "🆕 Will {player} come off now?", PT: "🆕 {player} sai agora?" },
  pred_sub_3: { ES: "👥 ¿Cambio decisivo del DT?", EN: "👥 Decisive sub from the coach?", PT: "👥 Substituição decisiva do técnico?" },
  pred_shot_1: { ES: "🎯 ¿Tiro al arco en 30 segundos?", EN: "🎯 Shot on goal in 30 seconds?", PT: "🎯 Chute ao gol em 30 segundos?" },
  pred_shot_2: { ES: "💥 ¿{player} disparará al arco?", EN: "💥 Will {player} fire on goal?", PT: "💥 {player} vai chutar ao gol?" },
  pred_shot_3: { ES: "🚀 ¿El próximo tiro será peligroso?", EN: "🚀 Will the next shot be dangerous?", PT: "🚀 O próximo chute será perigoso?" },
  pred_shot_4: { ES: "🔥 ¿Atajará el portero el siguiente tiro?", EN: "🔥 Will the keeper save the next shot?", PT: "🔥 O goleiro vai defender o próximo chute?" },
  pred_pen_1: { ES: "⚪ ¿Habrá penalti en esta jugada?", EN: "⚪ Penalty on this play?", PT: "⚪ Vai ter pênalti nessa jogada?" },
  pred_pen_2: { ES: "🎯 ¿{player} convertirá el penal?", EN: "🎯 Will {player} convert the penalty?", PT: "🎯 {player} converte o pênalti?" },
  pred_pen_3: { ES: "🥅 ¿Atajará el portero el penal?", EN: "🥅 Will the keeper save the penalty?", PT: "🥅 O goleiro defende o pênalti?" },
  pred_mvp_1: { ES: "🏆 ¿Será {player} el MVP del partido?", EN: "🏆 Will {player} be the match MVP?", PT: "🏆 {player} será o MVP da partida?" },
  pred_mvp_2: { ES: "⭐ ¿Quién dejará huella esta noche?", EN: "⭐ Who will leave their mark tonight?", PT: "⭐ Quem vai marcar a noite?" },
  pred_mvp_3: { ES: "🌟 ¿Aparecerá una figura inesperada?", EN: "🌟 Will an unexpected star emerge?", PT: "🌟 Vai surgir uma figura inesperada?" },
  pred_partial_1: { ES: "📊 ¿Cómo terminará el primer tiempo?", EN: "📊 How will the first half end?", PT: "📊 Como termina o primeiro tempo?" },
  pred_partial_2: { ES: "⏱️ ¿Habrá más goles antes del descanso?", EN: "⏱️ More goals before half-time?", PT: "⏱️ Mais gols antes do intervalo?" },
  pred_partial_3: { ES: "📈 ¿Quién dominará los próximos 10 minutos?", EN: "📈 Who will dominate the next 10 minutes?", PT: "📈 Quem vai dominar os próximos 10 minutos?" },
  pred_comeback_1: { ES: "🔥 ¿Habrá remontada en este partido?", EN: "🔥 Will there be a comeback?", PT: "🔥 Vai ter virada nesta partida?" },
  pred_comeback_2: { ES: "⚡ ¿{team} logrará empatar?", EN: "⚡ Will {team} equalize?", PT: "⚡ {team} consegue empatar?" },
  pred_comeback_3: { ES: "🏆 Momento decisivo. ¿Quién será el héroe?", EN: "🏆 Decisive moment. Who will be the hero?", PT: "🏆 Momento decisivo. Quem será o herói?" },

  // Reward voucher manager (admin)
  rvm_title: { ES: "Gestión de Premios y Vouchers", EN: "Rewards & Voucher Operations", PT: "Gestão de Prêmios e Vouchers" },
  rvm_kpi_issued: { ES: "Emitidos", EN: "Issued", PT: "Emitidos" },
  rvm_kpi_redeemed: { ES: "Canjeados", EN: "Redeemed", PT: "Resgatados" },
  rvm_kpi_rate: { ES: "Tasa de redención", EN: "Redemption rate", PT: "Taxa de resgate" },
  rvm_kpi_expired: { ES: "Expirados", EN: "Expired", PT: "Expirados" },
  rvm_th_code: { ES: "Código", EN: "Code", PT: "Código" },
  rvm_th_partner: { ES: "Socio", EN: "Partner", PT: "Parceiro" },
  rvm_th_status: { ES: "Estado", EN: "Status", PT: "Estado" },
  rvm_th_issued: { ES: "Emisión", EN: "Issued", PT: "Emissão" },
  rvm_th_expires: { ES: "Expira", EN: "Expires", PT: "Expira" },
  rvm_no_vouchers: { ES: "Aún no se han emitido vouchers.", EN: "No vouchers issued yet.", PT: "Nenhum voucher emitido ainda." },

  // Common
  close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  back: { ES: "Volver", EN: "Back", PT: "Voltar" },
  open_now: { ES: "Ver ahora", EN: "Open now", PT: "Ver agora" },
  ignore: { ES: "Ignorar", EN: "Ignore", PT: "Ignorar" },
  loading: { ES: "Cargando…", EN: "Loading…", PT: "Carregando…" },
  focus_mode_title: { ES: "Modo Concentración", EN: "Focus Mode", PT: "Modo Concentração" },
  focus_mode_on_tap_disable: { ES: "Modo Concentración activado • Toca para desactivar", EN: "Focus Mode is ON • Tap to disable", PT: "Modo Concentração ativo • Toque para desativar" },
  focus_mode_enable: { ES: "Activar Modo Concentración", EN: "Enable Focus Mode", PT: "Ativar Modo Concentração" },
  focus_channels_label: { ES: "Canales a silenciar cuando esté activo", EN: "Channels to suppress when active", PT: "Canais a silenciar quando ativo" },
  focus_prefs_hint: { ES: "Las preferencias se guardan en este dispositivo. Modo limpio de gol y supresión por teclado siempre activos.", EN: "Preferences saved on this device. Goal clean mode and keyboard suppression are always on.", PT: "Preferências salvas neste dispositivo. Modo limpo de gol e supressão por teclado sempre ativos." },
  focus_ch_ads: { ES: "Anuncios", EN: "Ads", PT: "Anúncios" },
  focus_ch_polls: { ES: "Encuestas", EN: "Polls", PT: "Enquetes" },
  focus_ch_community: { ES: "Comunidad", EN: "Community", PT: "Comunidade" },
  focus_ch_ai: { ES: "IA", EN: "AI", PT: "IA" },
  focus_ch_rewards: { ES: "Recompensas", EN: "Rewards", PT: "Recompensas" },
  focus_ch_betting: { ES: "Predicciones", EN: "Betting", PT: "Apostas" },
  focus_ch_help: { ES: "Ayuda", EN: "Help", PT: "Ajuda" },
  focus_ch_halftime: { ES: "Entretiempo", EN: "Halftime", PT: "Intervalo" },
  focus_ch_retention: { ES: "Retención", EN: "Retention", PT: "Retenção" },
  focus_ch_ctas: { ES: "Botones flotantes", EN: "Floating CTAs", PT: "Botões flutuantes" },
  clean_screen_title: { ES: "Pantalla Limpia Temporal", EN: "Temporary Clean Screen", PT: "Tela Limpa Temporária" },
  clean_screen_desc: { ES: "Minimiza temporalmente los elementos persistentes. Vuelven solos al terminar.", EN: "Temporarily minimize persistent elements. Everything returns automatically.", PT: "Minimiza temporariamente elementos persistentes. Tudo volta sozinho." },
  clean_screen_active_for: { ES: "Modo Pantalla Limpia activado por {n} min", EN: "Clean Screen Mode active for {n} min", PT: "Modo Tela Limpa ativo por {n} min" },
  clean_screen_end_now: { ES: "Terminar ahora", EN: "End now", PT: "Encerrar agora" },
  clean_screen_auto_return: { ES: "Volverá a aparecer automáticamente.", EN: "Will reappear automatically.", PT: "Voltará a aparecer automaticamente." },
  temporary_hide: { ES: "Ocultar temporalmente", EN: "Hide temporarily", PT: "Ocultar temporariamente" },
  temporary_hide_back_soon: { ES: "Volverá a aparecer automáticamente", EN: "Will reappear automatically", PT: "Voltará a aparecer automaticamente" },
  current_mode: { ES: "Modo actual", EN: "Current Mode", PT: "Modo atual" },
  active: { ES: "Activo", EN: "Active", PT: "Ativo" },
  save_for_later: { ES: "Guardar para después", EN: "Save for Later", PT: "Salvar para depois" },
  buy_now: { ES: "Comprar ahora", EN: "Buy Now", PT: "Comprar agora" },
  poll_center: { ES: "Centro de Encuestas", EN: "Poll Center", PT: "Central de Enquetes" },
  partner_portal: { ES: "Portal de Socios", EN: "Partner Portal", PT: "Portal de Parceiros" },
  executive_command_center: { ES: "Centro de Comando Ejecutivo", EN: "Executive Command Center", PT: "Centro de Comando Executivo" },
  yes: { ES: "Sí", EN: "Yes", PT: "Sim" },
  no: { ES: "No", EN: "No", PT: "Não" },
  email_optional: { ES: "Email (opcional)", EN: "Email (optional)", PT: "E-mail (opcional)" },
  query: { ES: "Consultar", EN: "Look up", PT: "Consultar" },

  // Audio sync
  sync_idle: { ES: "Sincronizar TV (opcional)", EN: "Sync with TV (optional)", PT: "Sincronizar TV (opcional)" },
  sync_listening: { ES: "Escuchando…", EN: "Listening…", PT: "Ouvindo…" },
  sync_syncing: { ES: "Sincronizando…", EN: "Syncing…", PT: "Sincronizando…" },
  sync_synced: { ES: "SYNC ±0.3s", EN: "SYNC ±0.3s", PT: "SYNC ±0.3s" },
  tv_sync_searching: { ES: "Buscando transmisión…", EN: "Searching broadcast…", PT: "Buscando transmissão…" },
  tv_sync_detecting: { ES: "Detectando TV…", EN: "Detecting TV…", PT: "Detectando TV…" },
  tv_sync_analyzing: { ES: "Analizando audio…", EN: "Analyzing audio…", PT: "Analisando áudio…" },
  tv_sync_synced: { ES: "Sincronizado ✓", EN: "Synced ✓", PT: "Sincronizado ✓" },
  tv_sync_retry: { ES: "Reintentar sincronización", EN: "Retry sync", PT: "Repetir sincronização" },
  tv_sync_failed: { ES: "No se pudo sincronizar", EN: "Could not sync", PT: "Não foi possível sincronizar" },
  tv_sync_advantage_suffix: { ES: "de ventaja", EN: "ahead", PT: "de vantagem" },
  community_live_now: { ES: "En vivo", EN: "Live now", PT: "Ao vivo" },
  sync_aria: {
    ES: "Sincronizar con TV (opcional, mejora la precisión)",
    EN: "Sync with TV (optional, improves accuracy)",
    PT: "Sincronizar com TV (opcional, melhora a precisão)",
  },
  sync_title: {
    ES: "Audio Sync es opcional y solo escucha unos segundos. La app funciona sin micrófono.",
    EN: "Audio Sync is optional and only listens for a few seconds. The app works without a mic.",
    PT: "Audio Sync é opcional e escuta apenas alguns segundos. O app funciona sem microfone.",
  },
  sync_manual: { ES: "Sincronización manual", EN: "Manual sync", PT: "Sincronização manual" },
  sync_toast_title: { ES: "🔴 SYNC TV · ±0.3s", EN: "🔴 SYNC TV · ±0.3s", PT: "🔴 SYNC TV · ±0.3s" },
  sync_toast_desc: {
    ES: "Sincronizado con Univision TV",
    EN: "Synced with Univision TV",
    PT: "Sincronizado com Univision TV",
  },

  // Predictions
  prediction_badge: { ES: "✦ PREDICCIÓN DEL PARTIDO", EN: "✦ MATCH PREDICTION", PT: "✦ PREVISÃO DA PARTIDA" },
  prediction_default_q: {
    ES: "¿Habrá gol en los próximos 2 minutos?",
    EN: "Will there be a goal in the next 2 minutes?",
    PT: "Haverá gol nos próximos 2 minutos?",
  },
  prediction_registered: { ES: "¡Predicción registrada!", EN: "Prediction recorded!", PT: "Previsão registrada!" },
  prediction_voted_yes: { ES: "Votaste: Sí · habrá gol", EN: "You voted: Yes · goal coming", PT: "Você votou: Sim · vem gol" },
  prediction_voted_no: { ES: "Votaste: No · sin gol", EN: "You voted: No · no goal", PT: "Você votou: Não · sem gol" },
  community_result: { ES: "Resultado de la comunidad", EN: "Community result", PT: "Resultado da comunidade" },

  // Edge alerts
  alert_danger: { ES: "⚡ Peligro inminente", EN: "⚡ Imminent danger", PT: "⚡ Perigo iminente" },
  alert_box: { ES: "🎯 Balón en el área", EN: "🎯 Ball in the box", PT: "🎯 Bola na área" },
  alert_xg: { ES: "🔥 Oportunidad clara", EN: "🔥 Clear chance", PT: "🔥 Oportunidade clara" },
  alert_sprint: { ES: "💨 Sprint ofensivo", EN: "💨 Offensive sprint", PT: "💨 Sprint ofensivo" },
  alert_freekick: { ES: "⚽ Tiro libre peligroso", EN: "⚽ Dangerous free kick", PT: "⚽ Falta perigosa" },
  alert_danger_d: { ES: "Balón en el último tercio", EN: "Ball in the final third", PT: "Bola no terço final" },
  alert_box_d: { ES: "Posible llegada de gol", EN: "Goal threat building", PT: "Possível chegada de gol" },
  alert_xg_d: { ES: "Probabilidad de gol elevada", EN: "High goal probability", PT: "Alta probabilidade de gol" },
  alert_sprint_d: { ES: "Ataque acelerado en marcha", EN: "Counter underway", PT: "Ataque acelerado em curso" },
  alert_freekick_d: { ES: "Zona de remate directo", EN: "Direct shot zone", PT: "Zona de remate direto" },

  // Plan / mi-plan
  my_plan: { ES: "MI PLAN", EN: "MY PLAN", PT: "MEU PLANO" },
  current_plan: { ES: "PLAN ACTUAL", EN: "CURRENT PLAN", PT: "PLANO ATUAL" },
  plan_source: { ES: "Origen", EN: "Source", PT: "Origem" },
  plan_expires: { ES: "Expira", EN: "Expires", PT: "Expira" },
  plan_resolving: { ES: "Resolviendo plan…", EN: "Resolving plan…", PT: "Resolvendo plano…" },
  benefit_premium: { ES: "Premium habilitado", EN: "Premium enabled", PT: "Premium habilitado" },
  benefit_predictions: { ES: "Predicciones avanzadas", EN: "Advanced predictions", PT: "Previsões avançadas" },
  benefit_history: { ES: "Analogías históricas", EN: "Historical analogs", PT: "Análogos históricos" },
  benefit_decisive: { ES: "Comentarios decisivos", EN: "Decisive commentary", PT: "Comentários decisivos" },
  benefit_rewards: { ES: "Rewards premium", EN: "Premium rewards", PT: "Recompensas premium" },
  benefit_adfree: { ES: "Sin anuncios", EN: "Ad-free", PT: "Sem anúncios" },
  benefit_enterprise: { ES: "Módulos Enterprise", EN: "Enterprise modules", PT: "Módulos Enterprise" },
  benefit_ai_unlimited: { ES: "IA: Ilimitado", EN: "AI: Unlimited", PT: "IA: Ilimitado" },
  benefit_ai_quota: { ES: "IA: {n} msg/día", EN: "AI: {n} msg/day", PT: "IA: {n} msg/dia" },

  // SEO
  seo_title: { ES: "VerseSport™ · Mundial en Vivo", EN: "VerseSport™ · Live World Cup", PT: "VerseSport™ · Copa ao Vivo" },
  seo_description: {
    ES: "VerseSport™: experiencia premium de segunda pantalla para el Mundial 2026 con Radar 3D, IA táctica en vivo y predicciones interactivas.",
    EN: "VerseSport™: premium second-screen experience for the 2026 World Cup with 3D Radar, live tactical AI and interactive predictions.",
    PT: "VerseSport™: experiência premium de segunda tela para a Copa 2026 com Radar 3D, IA tática ao vivo e previsões interativas.",
  },

  // ===== Admin / Executive Command Center =====
  admin_title: { ES: "EXECUTIVE COMMAND CENTER", EN: "EXECUTIVE COMMAND CENTER", PT: "EXECUTIVE COMMAND CENTER" },
  admin_subtitle: { ES: "VERSESPORT™ · UNIVISION · WAR ROOM", EN: "VERSESPORT™ · UNIVISION · WAR ROOM", PT: "VERSESPORT™ · UNIVISION · WAR ROOM" },
  admin_back: { ES: "Volver", EN: "Back", PT: "Voltar" },
  admin_media_mode: { ES: "MEDIA MODE", EN: "MEDIA MODE", PT: "MEDIA MODE" },
  admin_betting_mode: { ES: "BETTING MODE", EN: "BETTING MODE", PT: "BETTING MODE" },
  admin_monetization_engines: { ES: "Motores de monetización:", EN: "Monetization engines:", PT: "Motores de monetização:" },
  admin_monetization_desc: {
    ES: "Los principales motores de monetización son Gamification, Advertising, First-Party Data y Mirror Audit.",
    EN: "The core monetization engines are Gamification, Advertising, First-Party Data and Mirror Audit.",
    PT: "Os principais motores de monetização são Gamification, Advertising, First-Party Data e Mirror Audit.",
  },
  admin_competitive_diff: { ES: "Diferenciadores competitivos", EN: "Competitive differentiators", PT: "Diferenciais competitivos" },
  admin_diff_radar: { ES: "Radar 3D inmersivo.", EN: "Immersive 3D Radar.", PT: "Radar 3D imersivo." },
  admin_diff_ai: { ES: "IA táctica en tiempo real.", EN: "Real-time tactical AI.", PT: "IA tática em tempo real." },
  admin_diff_gamification: { ES: "Gamificación y recompensas.", EN: "Gamification and rewards.", PT: "Gamificação e recompensas." },
  admin_diff_ads: { ES: "Publicidad contextual.", EN: "Contextual advertising.", PT: "Publicidade contextual." },
  admin_diff_data: { ES: "First-party data.", EN: "First-party data.", PT: "First-party data." },
  admin_diff_audit: { ES: "Auditoría antifraude.", EN: "Anti-fraud audit.", PT: "Auditoria antifraude." },
  kpi_sessions: { ES: "Sesiones", EN: "Sessions", PT: "Sessões" },
  kpi_predictions: { ES: "Predicciones", EN: "Predictions", PT: "Previsões" },
  kpi_votes: { ES: "Votos", EN: "Votes", PT: "Votos" },
  kpi_chat_ai: { ES: "Chat IA", EN: "AI Chat", PT: "Chat IA" },
  kpi_goals: { ES: "Goles", EN: "Goals", PT: "Gols" },
  admin_live_feed: { ES: "LIVE EVENT FEED · audit_master", EN: "LIVE EVENT FEED · audit_master", PT: "LIVE EVENT FEED · audit_master" },
  admin_loading: { ES: "Cargando…", EN: "Loading…", PT: "Carregando…" },
  admin_events_count: { ES: "{n} eventos · refresh 8s", EN: "{n} events · refresh 8s", PT: "{n} eventos · atualização 8s" },
  admin_th_time: { ES: "Hora", EN: "Time", PT: "Hora" },
  admin_th_event: { ES: "Evento", EN: "Event", PT: "Event" },
  admin_th_tenant: { ES: "Tenant", EN: "Tenant", PT: "Tenant" },
  admin_th_data: { ES: "Data", EN: "Data", PT: "Data" },
  admin_no_events: {
    ES: "Sin eventos todavía. Abre la app y interactúa para ver el feed.",
    EN: "No events yet. Open the app and interact to see the feed.",
    PT: "Sem eventos ainda. Abra o app e interaja para ver o feed.",
  },
  admin_footer: {
    ES: "Executive War Room · Datos reales de audit_master combinados con simulaciones marcadas · VerseSport™",
    EN: "Executive War Room · Real audit_master data combined with flagged simulations · VerseSport™",
    PT: "Executive War Room · Dados reais de audit_master combinados com simulações marcadas · VerseSport™",
  },

  // ===== Live commentary engine =====
  lc_goal: { ES: "¡GOL! {player} define la jugada y el marcador cambia.", EN: "GOAL! {player} finishes the play and the score changes.", PT: "GOL! {player} finaliza a jogada e o placar muda." },
  lc_shot_1: { ES: "{player} encuentra espacio en el área, xG instantáneo en zona caliente.", EN: "{player} finds space in the box, instant xG spikes in the hot zone.", PT: "{player} encontra espaço na área, xG instantâneo em zona quente." },
  lc_shot_2: { ES: "{player} amenaza con remate de alto peligro frente al arco.", EN: "{player} threatens with a high-danger shot in front of goal.", PT: "{player} ameaça com chute de alto perigo em frente ao gol." },
  lc_shot_3: { ES: "{player} aparece como hombre libre en el área chica.", EN: "{player} arrives unmarked in the six-yard box.", PT: "{player} aparece livre na pequena área." },
  lc_freekick: { ES: "Tiro libre peligroso. {player} se acomoda para el envío al área.", EN: "Dangerous free kick. {player} sets up to deliver into the box.", PT: "Falta perigosa. {player} se prepara para o cruzamento na área." },
  lc_danger_1: { ES: "{player} recibe entre líneas y arrastra defensores.", EN: "{player} receives between the lines and pulls defenders.", PT: "{player} recebe entre linhas e arrasta defensores." },
  lc_danger_2: { ES: "{player} progresa por el carril y obliga a la defensa a retroceder.", EN: "{player} progresses down the channel and forces the defense back.", PT: "{player} progride pelo corredor e obriga a defesa a recuar." },
  lc_danger_3: { ES: "{player} encara con velocidad en el último tercio.", EN: "{player} drives with pace in the final third.", PT: "{player} encara com velocidade no último terço." },
  lc_pressure: { ES: "{team} presiona con {n} hombres en campo rival.", EN: "{team} presses with {n} men in the opposition half.", PT: "{team} pressiona com {n} homens no campo adversário." },
  lc_stat_1: { ES: "Posesión disputada en mitad de cancha al minuto {minute}.", EN: "Possession contested at midfield in minute {minute}.", PT: "Posse disputada no meio-campo no minuto {minute}." },
  lc_stat_2: { ES: "La línea defensiva se mantiene alta buscando offside.", EN: "The defensive line stays high looking for offside.", PT: "A linha defensiva mantém-se alta buscando impedimento." },
  lc_stat_3: { ES: "Cambio de ritmo: el balón circula con velocidad por el medio.", EN: "Tempo shift: the ball circulates at pace through midfield.", PT: "Mudança de ritmo: a bola circula em velocidade pelo meio." },
  lc_stat_4: { ES: "Ambos equipos ajustan presión tras la jugada anterior.", EN: "Both teams adjust their press after the previous play.", PT: "Ambas as equipes ajustam a pressão após a jogada anterior." },
  lc_attacker_default: { ES: "el atacante", EN: "the attacker", PT: "o atacante" },
  lc_role_fwd: { ES: "el delantero", EN: "the forward", PT: "o atacante" },
  lc_role_mid: { ES: "el mediocampista", EN: "the midfielder", PT: "o meio-campista" },
  lc_role_def: { ES: "el defensor", EN: "the defender", PT: "o defensor" },
  lc_role_player: { ES: "el jugador", EN: "the player", PT: "o jogador" },
  team_mex: { ES: "España", EN: "Spain", PT: "Espanha" },
  team_arg: { ES: "Argentina", EN: "Argentina", PT: "Argentina" },

  // ===== Decisive moment commentary =====
  dm_star_overperf: {
    ES: "{player} está generando {pct}% más peligro que su promedio.",
    EN: "{player} is generating {pct}% more danger than their average.",
    PT: "{player} está gerando {pct}% mais perigo que sua média.",
  },
  dm_high_pressure_late: {
    ES: "La presión alta sostenida en los últimos 15 minutos correlaciona con 47% de victorias.",
    EN: "Sustained high pressure in the last 15 minutes correlates with a 47% win rate.",
    PT: "A pressão alta sustentada nos últimos 15 minutos correlaciona com 47% de vitórias.",
  },

  // ===== Historical analog engine =====
  ha_comeback_one: {
    ES: "31% de remontada cuando un equipo va abajo por 1 después del minuto 70.",
    EN: "31% comeback rate when a team trails by 1 after the 70th minute.",
    PT: "31% de virada quando um time está atrás por 1 após o minuto 70.",
  },
  ha_comeback_two: {
    ES: "Solo 8% de remontadas históricas cuando se va abajo por 2 goles.",
    EN: "Only 8% historical comeback rate when trailing by 2 goals.",
    PT: "Apenas 8% de viradas históricas quando se está atrás por 2 gols.",
  },
  ha_draw_late: {
    ES: "62% de los partidos terminan empatados tras un gol del empate después del 80'.",
    EN: "62% of matches end in a draw after an equalizer past the 80th minute.",
    PT: "62% das partidas terminam empatadas após um gol de empate depois do 80'.",
  },
  ha_high_press: {
    ES: "47% de victorias para el equipo que sostiene presión alta los últimos 15 minutos.",
    EN: "47% win rate for teams sustaining high pressure in the last 15 minutes.",
    PT: "47% de vitórias para a equipe que sustenta pressão alta nos últimos 15 minutos.",
  },
  ha_red_card: {
    ES: "Solo 18% gana después de recibir una tarjeta roja en la segunda mitad.",
    EN: "Only 18% win after receiving a red card in the second half.",
    PT: "Apenas 18% vence após receber um cartão vermelho no segundo tempo.",
  },
  ha_late_goal: {
    ES: "39% de los partidos registran al menos un gol en los últimos 10 minutos.",
    EN: "39% of matches see at least one goal in the final 10 minutes.",
    PT: "39% das partidas registram pelo menos um gol nos últimos 10 minutos.",
  },

  // ===== Sports Oracle =====
  oracle_next_goal_headline: {
    ES: "{team} con {pct}% de probabilidad en su próxima jugada",
    EN: "{team} at {pct}% probability on their next play",
    PT: "{team} com {pct}% de probabilidade na próxima jogada",
  },
  oracle_next_goal_detail: {
    ES: "xG estimado {xg}%, {def} defensores cerca, momentum {mom}%.",
    EN: "Estimated xG {xg}%, {def} defenders nearby, momentum {mom}%.",
    PT: "xG estimado {xg}%, {def} defensores próximos, momentum {mom}%.",
  },
  oracle_final_headline: {
    ES: "MEX {mex}% · Empate {draw}% · ARG {arg}%",
    EN: "MEX {mex}% · Draw {draw}% · ARG {arg}%",
    PT: "MEX {mex}% · Empate {draw}% · ARG {arg}%",
  },
  oracle_final_detail: {
    ES: "Quedan ~{rem} minutos. Diferencia actual {diff}.",
    EN: "~{rem} minutes remaining. Current goal diff {diff}.",
    PT: "Faltam ~{rem} minutos. Diferença atual {diff}.",
  },
  oracle_mvp_headline: { ES: "MVP probable: {player}", EN: "Likely MVP: {player}", PT: "Provável MVP: {player}" },
  oracle_mvp_default: { ES: "Delantero principal", EN: "Lead striker", PT: "Atacante principal" },
  oracle_mvp_detail: {
    ES: "Posición avanzada y participación en el último tercio. Score combinado de ataque y presión.",
    EN: "Advanced position and final-third involvement. Combined attack and pressing score.",
    PT: "Posição avançada e participação no último terço. Pontuação combinada de ataque e pressão.",
  },
  oracle_topscorer_headline: { ES: "Mayor probabilidad de gol: {player}", EN: "Highest goal probability: {player}", PT: "Maior probabilidade de gol: {player}" },
  oracle_topscorer_default: { ES: "Delantero adelantado", EN: "Advanced forward", PT: "Atacante adiantado" },
  oracle_topscorer_detail: {
    ES: "Está en zona de remate y con buen ángulo respecto al arco.",
    EN: "Located in shooting range with a good angle to goal.",
    PT: "Está em zona de chute e com bom ângulo em relação ao gol.",
  },
  oracle_assist_headline: { ES: "Posible asistencia clave: {player}", EN: "Possible key assist: {player}", PT: "Possível assistência-chave: {player}" },
  oracle_assist_default: { ES: "Mediocampista creativo", EN: "Creative midfielder", PT: "Meio-campista criativo" },
  oracle_assist_detail: {
    ES: "Probabilidad de pase clave {pct}% según posición y momentum.",
    EN: "Key pass probability {pct}% based on position and momentum.",
    PT: "Probabilidade de passe-chave {pct}% conforme posição e momentum.",
  },
  oracle_under_headline: { ES: "Por debajo de su promedio: {player}", EN: "Below average: {player}", PT: "Abaixo da média: {player}" },
  oracle_under_default: { ES: "Jugador con alta fatiga", EN: "High-fatigue player", PT: "Jogador com alta fadiga" },
  oracle_under_detail: {
    ES: "Fatiga {pct}% — recomienda observar posible cambio.",
    EN: "Fatigue {pct}% — watch for a possible substitution.",
    PT: "Fadiga {pct}% — observe possível substituição.",
  },
  oracle_comeback_headline: { ES: "Probabilidad de remontada: {pct}%", EN: "Comeback probability: {pct}%", PT: "Probabilidade de virada: {pct}%" },
  oracle_default_headline: { ES: "Análisis disponible", EN: "Analysis available", PT: "Análise disponível" },
  oracle_default_detail: {
    ES: "Pregunta sobre próximo gol, resultado, MVP, asistente o remontada.",
    EN: "Ask about next goal, result, MVP, assister or comeback.",
    PT: "Pergunte sobre próximo gol, resultado, MVP, assistente ou virada.",
  },

  // ===== Admin Subpanels Phase 3 =====
  // RevenueTicker
  rt_title: { ES: "✦ REVENUE TICKER · SIMULATED · TODAY", EN: "✦ REVENUE TICKER · SIMULATED · TODAY", PT: "✦ REVENUE TICKER · SIMULADO · HOJE" },
  rt_subtitle: { ES: "Total streams · sesión actual", EN: "Total streams · current session", PT: "Total streams · sessão atual" },
  rt_advertising: { ES: "Advertising", EN: "Advertising", PT: "Publicidade" },
  rt_sponsorship: { ES: "Sponsorship", EN: "Sponsorship", PT: "Patrocínio" },
  rt_premium: { ES: "Premium Subs", EN: "Premium Subs", PT: "Assinaturas Premium" },
  rt_affiliate: { ES: "Affiliate", EN: "Affiliate", PT: "Afiliados" },

  // GeoHeatmap
  geo_title: { ES: "HEATMAP GEOGRÁFICO", EN: "GEOGRAPHIC HEATMAP", PT: "MAPA DE CALOR GEOGRÁFICO" },

  // BusinessAlerts
  ba_title: { ES: "BUSINESS ALERTS & OPPORTUNITIES", EN: "BUSINESS ALERTS & OPPORTUNITIES", PT: "ALERTAS E OPORTUNIDADES DE NEGÓCIO" },
  ba_active: { ES: "{n} activas · auto-rotación", EN: "{n} active · auto-rotation", PT: "{n} ativas · rotação automática" },
  ba_dismiss: { ES: "Descartar", EN: "Dismiss", PT: "Descartar" },
  ba_empty: { ES: "Sin alertas activas. El sistema seguirá monitoreando.", EN: "No active alerts. The system keeps monitoring.", PT: "Sem alertas ativos. O sistema continuará monitorando." },
  ba_lbl_opportunity: { ES: "OPORTUNIDAD", EN: "OPPORTUNITY", PT: "OPORTUNIDADE" },
  ba_lbl_alert: { ES: "ALERTA", EN: "ALERT", PT: "ALERTA" },
  ba_lbl_critical: { ES: "CRÍTICO", EN: "CRITICAL", PT: "CRÍTICO" },
  ba_lbl_insight: { ES: "INSIGHT", EN: "INSIGHT", PT: "INSIGHT" },
  ba_a1_t: { ES: "Oportunidad: snacks en Chicago", EN: "Opportunity: snacks in Chicago", PT: "Oportunidade: snacks em Chicago" },
  ba_a1_b: { ES: "40% de los fans en Chicago preguntan por snacks. Activar campaña de patrocinador regional ahora.", EN: "40% of Chicago fans are asking about snacks. Activate a regional sponsor campaign now.", PT: "40% dos fãs em Chicago perguntam por snacks. Ative campanha de patrocinador regional agora." },
  ba_a1_cta: { ES: "Activar campaña", EN: "Activate campaign", PT: "Ativar campanha" },
  ba_a2_t: { ES: "Conversión +15% tras tiro libre", EN: "+15% conversion after free kick", PT: "+15% de conversão após cobrança de falta" },
  ba_a2_b: { ES: "Los registros aumentaron 15% tras el último tiro libre. Replicar copy en el próximo highlight.", EN: "Signups grew 15% after the last free kick. Replicate copy in the next highlight.", PT: "Os cadastros cresceram 15% após a última falta. Replique o copy no próximo highlight." },
  ba_a3_t: { ES: "Sentimiento positivo +22% post-gol", EN: "Positive sentiment +22% post-goal", PT: "Sentimento positivo +22% pós-gol" },
  ba_a3_b: { ES: "Momento editorial óptimo: lanzar encuesta de marca en los próximos 90 segundos.", EN: "Optimal editorial moment: launch a brand survey in the next 90 seconds.", PT: "Momento editorial ótimo: lance uma pesquisa de marca nos próximos 90 segundos." },
  ba_a4_t: { ES: "Discrepancia financiera 7%", EN: "7% financial discrepancy", PT: "Discrepância financeira de 7%" },
  ba_a4_b: { ES: "Ingresos esperados vs reportados muestran -7% en BetMGM. Revisar tracking de afiliado.", EN: "Expected vs reported revenue shows -7% on BetMGM. Review the affiliate tracking.", PT: "Receita esperada vs reportada mostra -7% no BetMGM. Revise o tracking do afiliado." },
  ba_a4_cta: { ES: "Auditar afiliado", EN: "Audit affiliate", PT: "Auditar afiliado" },
  ba_a5_t: { ES: "Texas: alta intención de compra", EN: "Texas: high purchase intent", PT: "Texas: alta intenção de compra" },
  ba_a5_b: { ES: "El segmento 25-34 en Texas muestra +31% intención de compra. Recomendado: inventario premium.", EN: "The 25-34 segment in Texas shows +31% purchase intent. Recommended: premium inventory.", PT: "O segmento 25-34 no Texas mostra +31% de intenção de compra. Recomendado: inventário premium." },
  ba_a6_t: { ES: "Sphere AI: consultas tácticas +41%", EN: "Sphere AI: tactical queries +41%", PT: "Sphere AI: consultas táticas +41%" },
  ba_a6_b: { ES: "Crece el uso del chat IA. Oportunidad de monetizar como feature premium.", EN: "AI chat usage is growing. Opportunity to monetize as a premium feature.", PT: "O uso do chat IA cresce. Oportunidade de monetizar como feature premium." },
  ba_a7_t: { ES: "AdTech: CTR de bebidas +28%", EN: "AdTech: beverages CTR +28%", PT: "AdTech: CTR de bebidas +28%" },
  ba_a7_b: { ES: "La campaña de bebidas supera el CTR promedio en 28%. Recomendado: aumentar peso de prioridad y activar trigger en próximo córner.", EN: "The beverage campaign beats average CTR by 28%. Recommended: raise priority weight and trigger on next corner.", PT: "A campanha de bebidas supera o CTR médio em 28%. Recomendado: aumentar prioridade e disparar no próximo escanteio." },
  ba_a7_cta: { ES: "Optimizar campaña", EN: "Optimize campaign", PT: "Otimizar campanha" },
  ba_a8_t: { ES: "AdTech: snacks dominan halftime", EN: "AdTech: snacks dominate halftime", PT: "AdTech: snacks dominam o intervalo" },
  ba_a8_b: { ES: "62% de las respuestas patrocinadas en entretiempo mencionan snacks. Empujar inventario halftime a marcas de snacks.", EN: "62% of sponsored halftime responses mention snacks. Push halftime inventory to snack brands.", PT: "62% das respostas patrocinadas no intervalo mencionam snacks. Empurre inventário de intervalo para marcas de snacks." },

  // AiInsights
  ai_panel_title: { ES: "AI INSIGHTS · SPHERE INTELLIGENCE", EN: "AI INSIGHTS · SPHERE INTELLIGENCE", PT: "AI INSIGHTS · SPHERE INTELLIGENCE" },
  ai_refresh: { ES: "Refrescar", EN: "Refresh", PT: "Atualizar" },
  ai_cat_engagement: { ES: "Engagement", EN: "Engagement", PT: "Engajamento" },
  ai_cat_brand: { ES: "Marca", EN: "Brand", PT: "Marca" },
  ai_cat_audit: { ES: "Audit", EN: "Audit", PT: "Auditoria" },
  ai_cat_predictions: { ES: "Predicciones", EN: "Predictions", PT: "Previsões" },
  ai_cat_geo: { ES: "Geo", EN: "Geo", PT: "Geo" },
  ai_cat_chat: { ES: "IA Chat", EN: "AI Chat", PT: "Chat IA" },
  ai_ins_1: { ES: "Texas lidera engagement con 92% de retención — recomienda push de patrocinio regional.", EN: "Texas leads engagement at 92% retention — recommend regional sponsorship push.", PT: "Texas lidera engajamento com 92% de retenção — recomende push de patrocínio regional." },
  ai_ins_2: { ES: "La campaña de bebidas supera el promedio en 23%, especialmente entre 25-34 años.", EN: "The beverage campaign beats the average by 23%, especially in the 25-34 segment.", PT: "A campanha de bebidas supera a média em 23%, especialmente entre 25-34 anos." },
  ai_ins_3: { ES: "Detectada discrepancia del 12% en conversiones de BetMGM — revisar tracking.", EN: "Detected 12% discrepancy in BetMGM conversions — review tracking.", PT: "Detectada discrepância de 12% nas conversões do BetMGM — revise o tracking." },
  ai_ins_4: { ES: "Sentimiento positivo subió 18% tras el minuto 50 — momento ideal para encuesta editorial.", EN: "Positive sentiment rose 18% after minute 50 — ideal time for editorial survey.", PT: "Sentimento positivo subiu 18% após o minuto 50 — momento ideal para pesquisa editorial." },
  ai_ins_5: { ES: "Miami y Los Angeles concentran el 38% del tráfico móvil — priorizar creatividades verticales.", EN: "Miami and Los Angeles concentrate 38% of mobile traffic — prioritize vertical creative.", PT: "Miami e Los Angeles concentram 38% do tráfego mobile — priorize criativos verticais." },
  ai_ins_6: { ES: "Consultas tácticas crecieron 41% — considera promocionar Sphere AI como feature premium.", EN: "Tactical queries grew 41% — consider promoting Sphere AI as a premium feature.", PT: "Consultas táticas cresceram 41% — considere promover Sphere AI como feature premium." },

  // Executive Narrative
  en_label: { ES: "EXECUTIVE NARRATIVE", EN: "EXECUTIVE NARRATIVE", PT: "NARRATIVA EXECUTIVA" },
  en_live: { ES: "EN VIVO", EN: "LIVE", PT: "AO VIVO" },
  en_n1: { ES: "La audiencia en Texas crece rápidamente y muestra alta intención de compra. Recomendado: activar inventario premium regional.", EN: "Texas audience is growing fast with high purchase intent. Recommended: activate regional premium inventory.", PT: "A audiência no Texas cresce rapidamente com alta intenção de compra. Recomendado: ativar inventário premium regional." },
  en_n2: { ES: "La campaña de bebidas supera el promedio de conversión en +23%. Patrocinador listo para upsell.", EN: "The beverage campaign beats average conversion by +23%. Sponsor ready for upsell.", PT: "A campanha de bebidas supera a conversão média em +23%. Patrocinador pronto para upsell." },
  en_n3: { ES: "El sentimiento positivo impulsa la disposición a compra de inventario premium en los próximos 10 minutos.", EN: "Positive sentiment drives willingness to buy premium inventory in the next 10 minutes.", PT: "O sentimento positivo impulsiona a disposição de comprar inventário premium nos próximos 10 minutos." },
  en_n4: { ES: "Miami y Los Angeles concentran 38% del tráfico móvil. Priorizar creatividades verticales y push de patrocinio.", EN: "Miami and Los Angeles concentrate 38% of mobile traffic. Prioritize vertical creative and sponsorship push.", PT: "Miami e Los Angeles concentram 38% do tráfego mobile. Priorize criativos verticais e push de patrocínio." },
  en_n5: { ES: "Las consultas tácticas en el chat IA crecieron +41%. Oportunidad de promocionar Sphere AI como feature premium.", EN: "AI chat tactical queries grew +41%. Opportunity to promote Sphere AI as a premium feature.", PT: "As consultas táticas no chat IA cresceram +41%. Oportunidade de promover Sphere AI como feature premium." },
  en_n6: { ES: "El minuto 50 marca un pico de engagement. Próximo slot ideal para encuesta editorial y patrocinio.", EN: "Minute 50 marks an engagement peak. Next ideal slot for editorial survey and sponsorship.", PT: "O minuto 50 marca um pico de engajamento. Próximo slot ideal para pesquisa editorial e patrocínio." },

  // ApiHealth
  api_title: { ES: "DATA FEED HEALTH", EN: "DATA FEED HEALTH", PT: "SAÚDE DO FEED DE DADOS" },
  api_tip_what: { ES: "Estado del proveedor de datos en vivo (Sportradar, API-Football o Demo).", EN: "Live data provider status (Sportradar, API-Football or Demo).", PT: "Status do provedor de dados ao vivo (Sportradar, API-Football ou Demo)." },
  api_tip_why: { ES: "Una latencia alta o pérdida de realtime degrada predicciones y monetización en tiempo real.", EN: "High latency or realtime loss degrades predictions and real-time monetization.", PT: "Alta latência ou perda de realtime degrada previsões e monetização em tempo real." },
  api_tip_impact: { ES: "Cada 100ms extra reducen ~3% el engagement de second screen.", EN: "Every extra 100ms cuts second-screen engagement by ~3%.", PT: "Cada 100ms extra reduz ~3% o engajamento da segunda tela." },
  api_provider: { ES: "Proveedor", EN: "Provider", PT: "Provedor" },
  api_latency: { ES: "Latencia", EN: "Latency", PT: "Latência" },
  api_sync: { ES: "Sincronización", EN: "Synchronization", PT: "Sincronização" },
  api_realtime: { ES: "Realtime", EN: "Realtime", PT: "Realtime" },
  api_optimal: { ES: "Óptima", EN: "Optimal", PT: "Ótima" },
  api_slow: { ES: "Lenta", EN: "Slow", PT: "Lenta" },
  api_critical: { ES: "Crítica", EN: "Critical", PT: "Crítica" },
  api_active: { ES: "Activo", EN: "Active", PT: "Ativo" },
  api_down: { ES: "Caído", EN: "Down", PT: "Fora" },
  api_ago_s: { ES: "hace {s}s", EN: "{s}s ago", PT: "há {s}s" },
  api_ago_m: { ES: "hace {m}m", EN: "{m}m ago", PT: "há {m}m" },

  // MetricsGlossary
  mg_title: { ES: "EXECUTIVE METRICS GLOSSARY", EN: "EXECUTIVE METRICS GLOSSARY", PT: "GLOSSÁRIO DE MÉTRICAS EXECUTIVAS" },
  mg_impact: { ES: "Impacto", EN: "Impact", PT: "Impacto" },

  // AffiliateAuditCenter
  aac_title: { ES: "AFFILIATE AUDIT CENTER", EN: "AFFILIATE AUDIT CENTER", PT: "CENTRAL DE AUDITORIA DE AFILIADOS" },
  aac_subtitle: { ES: "Comparativa esperado vs. reportado", EN: "Expected vs. reported comparison", PT: "Comparativo esperado vs. reportado" },
  aac_partner: { ES: "Partner", EN: "Partner", PT: "Parceiro" },
  aac_clicks: { ES: "Clics", EN: "Clicks", PT: "Cliques" },
  aac_signups: { ES: "Registros", EN: "Sign-ups", PT: "Cadastros" },
  aac_deposits: { ES: "Depósitos", EN: "Deposits", PT: "Depósitos" },
  aac_expected: { ES: "Esperado", EN: "Expected", PT: "Esperado" },
  aac_reported: { ES: "Reportado", EN: "Reported", PT: "Reportado" },

  // ExportEngine
  ex_processing: { ES: "Procesando…", EN: "Processing…", PT: "Processando…" },
  ex_engine: { ES: "Export Engine · {n} filas", EN: "Export Engine · {n} rows", PT: "Export Engine · {n} linhas" },
  ex_err_xlsx: { ES: "Error exportando XLSX", EN: "Error exporting XLSX", PT: "Erro ao exportar XLSX" },
  ex_err_pdf: { ES: "Error exportando PDF", EN: "Error exporting PDF", PT: "Erro ao exportar PDF" },

  // GlobalMessageCenter
  gmc_title: { ES: "GLOBAL MESSAGE CENTER", EN: "GLOBAL MESSAGE CENTER", PT: "CENTRAL DE MENSAGENS GLOBAIS" },
  gmc_default_title: { ES: "¡Univision regala una suscripción a ViX+!", EN: "Univision is giving away a ViX+ subscription!", PT: "A Univision vai dar uma assinatura ViX+!" },
  gmc_default_body: { ES: "Al fan más activo de este minuto. ¡Participa ahora!", EN: "To the most active fan this minute. Join now!", PT: "Para o fã mais ativo deste minuto. Participe agora!" },
  gmc_ph_title: { ES: "Título", EN: "Title", PT: "Título" },
  gmc_ph_body: { ES: "Cuerpo del mensaje", EN: "Message body", PT: "Corpo da mensagem" },
  gmc_expires_in: { ES: "Expira en", EN: "Expires in", PT: "Expira em" },
  gmc_min: { ES: "min", EN: "min", PT: "min" },
  gmc_send: { ES: "Enviar a todos", EN: "Send to all", PT: "Enviar para todos" },
  gmc_sending: { ES: "Enviando…", EN: "Sending…", PT: "Enviando…" },
  gmc_perm_error: { ES: "Permisos: solo administradores pueden publicar. (Vista previa simulada)", EN: "Permissions: only admins can publish. (Simulated preview)", PT: "Permissões: apenas administradores podem publicar. (Visualização simulada)" },
  gmc_sent: { ES: "Mensaje enviado a todos los usuarios.", EN: "Message sent to all users.", PT: "Mensagem enviada a todos os usuários." },
  gmc_preview: { ES: "VISTA PREVIA", EN: "PREVIEW", PT: "PRÉ-VISUALIZAÇÃO" },
  gmc_no_title: { ES: "Sin título", EN: "No title", PT: "Sem título" },
  gmc_empty: { ES: "Sin mensajes recientes.", EN: "No recent messages.", PT: "Sem mensagens recentes." },
  gmc_pri_info: { ES: "INFO", EN: "INFO", PT: "INFO" },
  gmc_pri_promo: { ES: "PROMO", EN: "PROMO", PT: "PROMO" },
  gmc_pri_urgent: { ES: "URGENTE", EN: "URGENT", PT: "URGENTE" },

  // AdManager
  adm_title: { ES: "AD MANAGER · CAMPAÑAS PUBLICITARIAS", EN: "AD MANAGER · ADVERTISING CAMPAIGNS", PT: "AD MANAGER · CAMPANHAS PUBLICITÁRIAS" },
  adm_cancel: { ES: "Cancelar", EN: "Cancel", PT: "Cancelar" },
  adm_new: { ES: "Nueva campaña", EN: "New campaign", PT: "Nova campanha" },
  adm_ph_name: { ES: "Nombre interno", EN: "Internal name", PT: "Nome interno" },
  adm_ph_sponsor: { ES: "Patrocinador", EN: "Sponsor", PT: "Patrocinador" },
  adm_ph_logo: { ES: "Logo URL (https://...)", EN: "Logo URL (https://...)", PT: "URL do logo (https://...)" },
  adm_ph_landing: { ES: "Landing URL", EN: "Landing URL", PT: "URL de destino" },
  adm_ph_tagline: { ES: "Tagline", EN: "Tagline", PT: "Slogan" },
  adm_cpm: { ES: "CPM estimado", EN: "Estimated CPM", PT: "CPM estimado" },
  adm_cpa: { ES: "CPA estimado", EN: "Estimated CPA", PT: "CPA estimado" },
  adm_triggers: { ES: "DISPARADORES", EN: "TRIGGERS", PT: "GATILHOS" },
  adm_create: { ES: "Crear campaña", EN: "Create campaign", PT: "Criar campanha" },
  adm_no_perm_edit: { ES: "No tienes permisos de administrador para modificar campañas.", EN: "You don't have admin permissions to modify campaigns.", PT: "Você não tem permissões de administrador para modificar campanhas." },
  adm_no_perm_create: { ES: "No tienes permisos de administrador para crear campañas.", EN: "You don't have admin permissions to create campaigns.", PT: "Você não tem permissões de administrador para criar campanhas." },
  adm_select_trigger: { ES: "Selecciona al menos un disparador.", EN: "Select at least one trigger.", PT: "Selecione ao menos um gatilho." },
  adm_invalid: { ES: "Datos inválidos", EN: "Invalid data", PT: "Dados inválidos" },
  adm_active: { ES: "ACTIVA", EN: "ACTIVE", PT: "ATIVA" },
  adm_paused: { ES: "PAUSADA", EN: "PAUSED", PT: "PAUSADA" },
  adm_empty: { ES: "Sin campañas. Crea la primera para comenzar a monetizar.", EN: "No campaigns. Create the first one to start monetizing.", PT: "Sem campanhas. Crie a primeira para começar a monetizar." },
  adm_est: { ES: "est.", EN: "est.", PT: "est." },

  // AiCostIntelligence
  aci_title: { ES: "AI COST INTELLIGENCE", EN: "AI COST INTELLIGENCE", PT: "INTELIGÊNCIA DE CUSTOS DE IA" },
  aci_active_users: { ES: "Usuarios activos", EN: "Active users", PT: "Usuários ativos" },
  aci_tokens_today: { ES: "Tokens hoy", EN: "Tokens today", PT: "Tokens hoje" },
  aci_cost_today: { ES: "Costo hoy", EN: "Cost today", PT: "Custo hoje" },
  aci_cost_avg: { ES: "Costo prom./usuario", EN: "Avg cost/user", PT: "Custo méd./usuário" },
  aci_no_credits: { ES: "Sin créditos", EN: "No credits", PT: "Sem créditos" },
  aci_recommended: { ES: "RECOMMENDED AI LIMITS", EN: "RECOMMENDED AI LIMITS", PT: "LIMITES DE IA RECOMENDADOS" },
  aci_unlimited: { ES: "Ilimitado", EN: "Unlimited", PT: "Ilimitado" },
  aci_msg_day: { ES: "{n} msg/día", EN: "{n} msg/day", PT: "{n} msg/dia" },
  aci_tokens_cfg: { ES: "Tokens configurables", EN: "Configurable tokens", PT: "Tokens configuráveis" },
  aci_tokens_day: { ES: "{n} tokens/día", EN: "{n} tokens/day", PT: "{n} tokens/dia" },
  aci_loading: { ES: "Cargando consumo…", EN: "Loading usage…", PT: "Carregando consumo…" },
  aci_interactions: { ES: "{n} interacciones/partido", EN: "{n} interactions/match", PT: "{n} interações/jogo" },
  aci_tokens_match: { ES: "Tokens/partido", EN: "Tokens/match", PT: "Tokens/jogo" },
  aci_cost_user: { ES: "Costo/usuario", EN: "Cost/user", PT: "Custo/usuário" },
  aci_cost_day: { ES: "Costo/día", EN: "Cost/day", PT: "Custo/dia" },
  aci_cost_50k: { ES: "50K usuarios", EN: "50K users", PT: "50K usuários" },

  // SportsOracleAnalytics
  soa_title: { ES: "Sports AI Oracle · Analytics", EN: "Sports AI Oracle · Analytics", PT: "Sports AI Oracle · Analytics" },
  soa_desc: { ES: "Intents más consultados, preguntas fuera de contexto y oportunidades de upgrade.", EN: "Most queried intents, out-of-scope questions and upgrade opportunities.", PT: "Intents mais consultados, perguntas fora de contexto e oportunidades de upgrade." },
  soa_queries: { ES: "Consultas", EN: "Queries", PT: "Consultas" },
  soa_oos: { ES: "Fuera de alcance", EN: "Out of scope", PT: "Fora de alcance" },
  soa_limits: { ES: "Límites alcanzados", EN: "Limits reached", PT: "Limites atingidos" },
  soa_sponsored: { ES: "Sponsored Premium", EN: "Sponsored Premium", PT: "Sponsored Premium" },
  soa_top_intents: { ES: "Top Predicciones / Intents", EN: "Top Predictions / Intents", PT: "Top Previsões / Intents" },
  soa_oos_title: { ES: "Preguntas fuera de contexto", EN: "Out-of-Scope Questions", PT: "Perguntas fora de contexto" },
  soa_no_data: { ES: "Sin datos todavía.", EN: "No data yet.", PT: "Sem dados ainda." },
  soa_no_oos: { ES: "Ninguna pregunta fuera de contexto detectada.", EN: "No out-of-scope question detected.", PT: "Nenhuma pergunta fora de contexto detectada." },
  soa_upgrade_label: { ES: "Oportunidades de upgrade:", EN: "Upgrade Opportunities:", PT: "Oportunidades de upgrade:" },
  soa_upgrade_body: { ES: "{limits} usuarios alcanzaron el límite Free hoy → candidatos directos a Pro o Sponsored Premium. Analogías históricas usadas: {analogs} (alto valor editorial para Univision).", EN: "{limits} users hit the Free limit today → direct candidates for Pro or Sponsored Premium. Historical analogs used: {analogs} (high editorial value for Univision).", PT: "{limits} usuários atingiram o limite Free hoje → candidatos diretos para Pro ou Sponsored Premium. Análogos históricos usados: {analogs} (alto valor editorial para a Univision)." },

  // PlanOverrideManager
  pom_title: { ES: "Plan Overrides", EN: "Plan Overrides", PT: "Plan Overrides" },
  pom_super: { ES: "SUPER ADMIN", EN: "SUPER ADMIN", PT: "SUPER ADMIN" },
  pom_desc: { ES: "Otorga, suspende o revoca planes manualmente para usuarios, patrocinadores, socios y clientes.", EN: "Grant, suspend or revoke plans manually for users, sponsors, partners and clients.", PT: "Conceda, suspenda ou revogue planos manualmente para usuários, patrocinadores, parceiros e clientes." },
  pom_email: { ES: "Email", EN: "Email", PT: "E-mail" },
  pom_session: { ES: "Session/User ID", EN: "Session/User ID", PT: "Session/User ID" },
  pom_days: { ES: "Días (vacío = sin expirar)", EN: "Days (empty = no expiry)", PT: "Dias (vazio = sem expirar)" },
  pom_assign: { ES: "Asignar", EN: "Assign", PT: "Atribuir" },
  pom_notes: { ES: "Notas internas", EN: "Internal notes", PT: "Notas internas" },
  pom_search: { ES: "Buscar por email o session_id…", EN: "Search by email or session_id…", PT: "Buscar por e-mail ou session_id…" },
  pom_target: { ES: "Target", EN: "Target", PT: "Alvo" },
  pom_plan: { ES: "Plan", EN: "Plan", PT: "Plano" },
  pom_status: { ES: "Estado", EN: "Status", PT: "Status" },
  pom_expires: { ES: "Expira", EN: "Expires", PT: "Expira" },
  pom_notes_col: { ES: "Notas", EN: "Notes", PT: "Notas" },
  pom_actions: { ES: "Acciones", EN: "Actions", PT: "Ações" },
  pom_empty: { ES: "Sin overrides registrados todavía.", EN: "No overrides registered yet.", PT: "Sem overrides registrados ainda." },
  pom_required: { ES: "Email o target_id requerido", EN: "Email or target_id required", PT: "E-mail ou target_id obrigatório" },
  pom_q_7d: { ES: "+7d Pro", EN: "+7d Pro", PT: "+7d Pro" },
  pom_q_30d: { ES: "+30d Pro", EN: "+30d Pro", PT: "+30d Pro" },
  pom_q_90d: { ES: "+90d Sponsored", EN: "+90d Sponsored", PT: "+90d Sponsored" },
  pom_q_ent: { ES: "Enterprise", EN: "Enterprise", PT: "Enterprise" },
  pom_q_free: { ES: "Restaurar Free", EN: "Restore Free", PT: "Restaurar Free" },
  pom_act_suspend: { ES: "Suspender", EN: "Suspend", PT: "Suspender" },
  pom_act_resume: { ES: "Reactivar", EN: "Resume", PT: "Reativar" },
  pom_act_revoke: { ES: "Revocar", EN: "Revoke", PT: "Revogar" },
  pom_act_restore: { ES: "Restaurar", EN: "Restore", PT: "Restaurar" },

  // MetricTooltip
  mt_what: { ES: "Qué mide", EN: "What it measures", PT: "O que mede" },
  mt_why: { ES: "Por qué importa", EN: "Why it matters", PT: "Por que importa" },
  mt_impact: { ES: "Impacto", EN: "Impact", PT: "Impacto" },
  mt_info: { ES: "Info", EN: "Info", PT: "Info" },

  // CompetitivePositioning
  cp_title: { ES: "Inteligencia Competitiva", EN: "Competitive Intelligence", PT: "Inteligência Competitiva" },
  cp_subtitle: { ES: "POSICIONAMIENTO · ESTRATEGIA · NARRATIVA DE INVERSIÓN", EN: "POSITIONING · STRATEGY · INVESTMENT NARRATIVE", PT: "POSICIONAMENTO · ESTRATÉGIA · NARRATIVA DE INVESTIMENTO" },
  cp_intro: { ES: "Visualiza por qué VerseSport™ supera a OneFootball, FotMob y Peacock combinando experiencia inmersiva, monetización contextual y datos first-party de nivel enterprise.", EN: "See why VerseSport™ beats OneFootball, FotMob and Peacock by combining immersive experience, contextual monetization and enterprise-grade first-party data.", PT: "Veja por que VerseSport™ supera OneFootball, FotMob e Peacock combinando experiência imersiva, monetização contextual e dados first-party de nível enterprise." },
  cp_badge_leader: { ES: "Líder de Mercado", EN: "Market Leader", PT: "Líder de Mercado" },
  cp_badge_advantage: { ES: "Nuestra Ventaja", EN: "Our Advantage", PT: "Nossa Vantagem" },
  cp_badge_strategy: { ES: "Oportunidad Estratégica", EN: "Strategic Opportunity", PT: "Oportunidade Estratégica" },
  cp_matrix: { ES: "MATRIZ DE COMPETIDORES", EN: "COMPETITOR MATRIX", PT: "MATRIZ DE CONCORRENTES" },
  cp_feature: { ES: "Característica", EN: "Feature", PT: "Característica" },
  cp_partial: { ES: "PARCIAL", EN: "PARTIAL", PT: "PARCIAL" },
  cp_leader: { ES: "LÍDER", EN: "LEADER", PT: "LÍDER" },
  cp_opportunity_t: { ES: "Oportunidad Estratégica Mundial 2026", EN: "2026 World Cup Strategic Opportunity", PT: "Oportunidade Estratégica Copa 2026" },
  cp_opp_1: { ES: "Norteamérica albergará el mayor evento de fútbol de la historia.", EN: "North America will host the largest football event in history.", PT: "A América do Norte sediará o maior evento de futebol da história." },
  cp_opp_2: { ES: "Audiencia latina masiva en USA, México y Canadá.", EN: "Massive Latino audience across USA, Mexico and Canada.", PT: "Audiência latina massiva nos EUA, México e Canadá." },
  cp_opp_3: { ES: "Marcas, broadcasters y operadores de apuestas buscan engagement más profundo.", EN: "Brands, broadcasters and betting operators are seeking deeper engagement.", PT: "Marcas, broadcasters e operadores de apostas buscam engajamento mais profundo." },
  cp_opp_4: { ES: "VerseSport transforma espectadores pasivos en participantes activos.", EN: "VerseSport transforms passive viewers into active participants.", PT: "VerseSport transforma espectadores passivos em participantes ativos." },
  cp_opp_5: { ES: "Crea nuevo inventario publicitario y datos first-party.", EN: "Creates new advertising inventory and first-party data.", PT: "Cria novo inventário publicitário e dados first-party." },
  cp_opp_6: { ES: "Ofrece experiencia inmersiva de segunda pantalla que los competidores no proveen.", EN: "Offers an immersive second-screen experience competitors don't provide.", PT: "Oferece experiência imersiva de segunda tela que os concorrentes não oferecem." },
  cp_why_t: { ES: "Por qué gana VerseSport", EN: "Why VerseSport Wins", PT: "Por que a VerseSport vence" },
  cp_why_1: { ES: "La TV muestra el partido. VerseSport lo explica.", EN: "TV shows the match. VerseSport explains the match.", PT: "A TV mostra a partida. VerseSport a explica." },
  cp_why_2: { ES: "OneFootball informa. VerseSport sumerge.", EN: "OneFootball informs. VerseSport immerses.", PT: "OneFootball informa. VerseSport imerge." },
  cp_why_3: { ES: "FotMob mide. VerseSport visualiza.", EN: "FotMob measures. VerseSport visualizes.", PT: "FotMob mede. VerseSport visualiza." },
  cp_why_4: { ES: "Peacock transmite. VerseSport monetiza.", EN: "Peacock streams. VerseSport monetizes.", PT: "Peacock transmite. VerseSport monetiza." },
  cp_why_5: { ES: "Los fans ganan puntos, recompensas y experiencias exclusivas.", EN: "Fans earn points, rewards and exclusive experiences.", PT: "Os fãs ganham pontos, recompensas e experiências exclusivas." },
  cp_why_6: { ES: "Broadcasters obtienen datos first-party e inventario premium de patrocinio.", EN: "Broadcasters unlock first-party data and premium sponsorship inventory.", PT: "Broadcasters obtêm dados first-party e inventário premium de patrocínio." },
  cp_monet_t: { ES: "Benchmarks de Monetización", EN: "Monetization Benchmarks", PT: "Benchmarks de Monetização" },
  cp_moat_t: { ES: "Foso Tecnológico", EN: "Technology Moat", PT: "Fosso Tecnológico" },
  cp_patent: { ES: "ESTRATEGIA PATENT-PENDING LISTA", EN: "PATENT-PENDING STRATEGY READY", PT: "ESTRATÉGIA PATENT-PENDING PRONTA" },
  cp_thesis_t: { ES: "Tesis de Inversión", EN: "Investment Thesis", PT: "Tese de Investimento" },
  cp_thesis_b: { ES: "VerseSport no es otra app deportiva. Es un Experience Hub inmersivo que combina visualización táctica, IA, gamificación, AdTech y analítica enterprise en una plataforma escalable para deportes, medios y entretenimiento.", EN: "VerseSport is not another sports app. It is an immersive Experience Hub that combines tactical visualization, AI, gamification, advertising technology and enterprise analytics into a scalable platform for sports, media and entertainment.", PT: "VerseSport não é mais um app esportivo. É um Experience Hub imersivo que combina visualização tática, IA, gamificação, AdTech e analytics enterprise em uma plataforma escalável para esportes, mídia e entretenimento." },
  cp_pitch_t: { ES: "PITCH EJECUTIVO", EN: "EXECUTIVE TALKING POINTS", PT: "PITCH EXECUTIVO" },
  cp_pitch_1: { ES: "OneFootball informa. VerseSport transforma.", EN: "OneFootball informs. VerseSport transforms.", PT: "OneFootball informa. VerseSport transforma." },
  cp_pitch_2: { ES: "La TV muestra el juego; nosotros creamos la experiencia.", EN: "The TV shows the game; we create the experience.", PT: "A TV mostra o jogo; nós criamos a experiência." },
  cp_pitch_3: { ES: "Cada interacción se convierte en datos, engagement y monetización.", EN: "Every interaction becomes data, engagement and monetization.", PT: "Cada interação se torna dados, engajamento e monetização." },
  cp_pitch_4: { ES: "Construido para el Mundial 2026 y escalable a todos los deportes.", EN: "Built for the 2026 World Cup and scalable to every sport.", PT: "Construído para a Copa 2026 e escalável a todos os esportes." },
  cp_copy: { ES: "Copiar pitch ejecutivo", EN: "Copy Executive Pitch", PT: "Copiar pitch executivo" },
  cp_copied: { ES: "Copiado", EN: "Copied", PT: "Copiado" },
  cp_market_t: { ES: "Oportunidad de Mercado", EN: "Market Opportunity", PT: "Oportunidade de Mercado" },
  cp_market_global: { ES: "OPORTUNIDAD GLOBAL MASIVA", EN: "MASSIVE GLOBAL OPPORTUNITY", PT: "OPORTUNIDADE GLOBAL MASSIVA" },

  // Smart Bonus Admin
  sba_title: { ES: "Smart Bonus & Marketing Dinámico", EN: "Smart Bonus & Dynamic Marketing", PT: "Smart Bonus & Marketing Dinâmico" },
  sba_subtitle: { ES: "BETTING · MONETIZACIÓN CONTEXTUAL", EN: "BETTING · CONTEXTUAL MONETIZATION", PT: "BETTING · MONETIZAÇÃO CONTEXTUAL" },
  sba_bonuses: { ES: "Bonos activados", EN: "Bonuses activated", PT: "Bônus ativados" },
  sba_clicks: { ES: "Clics", EN: "Clicks", PT: "Cliques" },
  sba_ctr: { ES: "CTR", EN: "CTR", PT: "CTR" },
  sba_regions: { ES: "Regiones", EN: "Regions", PT: "Regiões" },
  sba_expired: { ES: "Ofertas expiradas", EN: "Expired offers", PT: "Ofertas expiradas" },
  sba_geo_imp: { ES: "Geo impresiones", EN: "Geo impressions", PT: "Impressões geo" },
  sba_geo_clk: { ES: "Geo clics", EN: "Geo clicks", PT: "Cliques geo" },
  sba_recent: { ES: "Bonos recientes", EN: "Recent bonuses", PT: "Bônus recentes" },
  sba_geo_camp: { ES: "Campañas Geo", EN: "Geo campaigns", PT: "Campanhas Geo" },
  sba_no_bonus: { ES: "Sin bonos registrados aún.", EN: "No bonuses registered yet.", PT: "Sem bônus registrados ainda." },
  sba_no_geo: { ES: "Sin campañas geo registradas aún.", EN: "No geo campaigns registered yet.", PT: "Sem campanhas geo registradas ainda." },
  sba_status_click: { ES: "CLIC", EN: "CLICK", PT: "CLIQUE" },
  sba_status_expired: { ES: "EXPIRADO", EN: "EXPIRED", PT: "EXPIRADO" },
  sba_status_active: { ES: "ACTIVO", EN: "ACTIVE", PT: "ATIVO" },
  sba_status_imp: { ES: "IMPRESIÓN", EN: "IMPRESSION", PT: "IMPRESSÃO" },
  sba_odds: { ES: "cuota", EN: "odds", PT: "odds" },
  sba_disclaimer: { ES: "Todas las ofertas son simuladas con fines demostrativos. Responsible Gaming activo: cooldown de ofertas, sin targeting por pérdidas y sin lenguaje de urgencia abusiva.", EN: "All offers are simulated for demo purposes. Responsible Gaming active: offer cooldown, no targeting by losses and no abusive urgency language.", PT: "Todas as ofertas são simuladas para demonstração. Responsible Gaming ativo: cooldown de ofertas, sem targeting por perdas e sem linguagem de urgência abusiva." },

  // FanInsights
  fi_title: { ES: "FAN INSIGHTS · FIRST-PARTY DATA", EN: "FAN INSIGHTS · FIRST-PARTY DATA", PT: "FAN INSIGHTS · FIRST-PARTY DATA" },
  fi_teams: { ES: "EQUIPOS FAVORITOS", EN: "FAVORITE TEAMS", PT: "TIMES FAVORITOS" },
  fi_brands: { ES: "MARCAS", EN: "BRANDS", PT: "MARCAS" },
  fi_food: { ES: "COMIDA Y BEBIDAS", EN: "FOOD & DRINKS", PT: "COMIDA E BEBIDAS" },
  fi_intent: { ES: "INTENCIÓN DE COMPRA", EN: "PURCHASE INTENT", PT: "INTENÇÃO DE COMPRA" },
  fi_intent_sponsor: { ES: "Compra patrocinador", EN: "Sponsor purchase", PT: "Compra patrocinador" },
  fi_intent_sub: { ES: "Suscripción premium", EN: "Premium subscription", PT: "Assinatura premium" },
  fi_intent_merch: { ES: "Merch", EN: "Merch", PT: "Merch" },
  fi_intent_events: { ES: "Eventos en vivo", EN: "Live events", PT: "Eventos ao vivo" },

  // Sentiment
  sd_title: { ES: "PANEL DE SENTIMIENTO", EN: "SENTIMENT DASHBOARD", PT: "PAINEL DE SENTIMENTO" },
  sd_euphoria: { ES: "Euforia", EN: "Euphoria", PT: "Euforia" },
  sd_tension: { ES: "Tensión", EN: "Tension", PT: "Tensão" },
  sd_frustration: { ES: "Frustración", EN: "Frustration", PT: "Frustração" },
  sd_surprise: { ES: "Sorpresa", EN: "Surprise", PT: "Surpresa" },
  sd_neutral: { ES: "Neutralidad", EN: "Neutrality", PT: "Neutralidade" },

  // Experience Reliability
  er_title: { ES: "Confiabilidad de Experiencia", EN: "Experience Reliability", PT: "Confiabilidade da Experiência" },
  er_desc: { ES: "VerseSport funciona con datos tácticos en vivo. Audio Sync es opcional y mejora la precisión cuando deseas alinear la app con tu TV.", EN: "VerseSport runs on live tactical data. Audio Sync is optional and improves accuracy when you want to align the app with your TV.", PT: "VerseSport funciona com dados táticos ao vivo. Audio Sync é opcional e melhora a precisão quando você quer alinhar o app com sua TV." },
  er_tracker: { ES: "Live Tracker", EN: "Live Tracker", PT: "Live Tracker" },
  er_audiosync: { ES: "Audio Sync", EN: "Audio Sync", PT: "Audio Sync" },
  er_offset: { ES: "Manual Offset", EN: "Manual Offset", PT: "Offset Manual" },
  er_alerts: { ES: "Edge Alerts", EN: "Edge Alerts", PT: "Edge Alerts" },
  er_feed: { ES: "Data Feed", EN: "Data Feed", PT: "Data Feed" },
  er_active: { ES: "Activo", EN: "Active", PT: "Ativo" },
  er_optional: { ES: "Opcional", EN: "Optional", PT: "Opcional" },
  er_available: { ES: "Disponible", EN: "Available", PT: "Disponível" },
  er_actives: { ES: "Activas", EN: "Active", PT: "Ativas" },
  er_operational: { ES: "Operativo", EN: "Operational", PT: "Operacional" },

  // Metrics Glossary terms
  mgt_cpa_k: { ES: "CPA · Costo por Adquisición", EN: "CPA · Cost Per Acquisition", PT: "CPA · Custo por Aquisição" },
  mgt_cpa_d: { ES: "Costo promedio para adquirir un usuario registrado.", EN: "Average cost to acquire a registered user.", PT: "Custo médio para adquirir um usuário cadastrado." },
  mgt_cpa_i: { ES: "Indicador clave de eficiencia de marketing y patrocinios.", EN: "Key indicator of marketing and sponsorship efficiency.", PT: "Indicador-chave de eficiência de marketing e patrocínios." },
  mgt_arpu_k: { ES: "ARPU · Ingreso por Usuario", EN: "ARPU · Average Revenue per User", PT: "ARPU · Receita por Usuário" },
  mgt_arpu_d: { ES: "Ingreso promedio por usuario activo en un periodo.", EN: "Average revenue per active user in a period.", PT: "Receita média por usuário ativo em um período." },
  mgt_arpu_i: { ES: "Mide cuánto monetiza cada fan; impulsa valoración del producto.", EN: "Measures how much each fan monetizes; drives product valuation.", PT: "Mede quanto cada fã monetiza; impulsiona a avaliação do produto." },
  mgt_ltv_k: { ES: "LTV · Lifetime Value", EN: "LTV · Lifetime Value", PT: "LTV · Lifetime Value" },
  mgt_ltv_d: { ES: "Valor total esperado de un usuario durante su ciclo de vida.", EN: "Expected total value of a user across their lifecycle.", PT: "Valor total esperado de um usuário ao longo do ciclo de vida." },
  mgt_ltv_i: { ES: "Define cuánto se puede invertir para adquirir un usuario rentable.", EN: "Defines how much can be invested to acquire a profitable user.", PT: "Define quanto se pode investir para adquirir um usuário rentável." },
  mgt_ctr_k: { ES: "CTR · Click-Through Rate", EN: "CTR · Click-Through Rate", PT: "CTR · Click-Through Rate" },
  mgt_ctr_d: { ES: "Porcentaje de impresiones que generan un clic.", EN: "Percentage of impressions that generate a click.", PT: "Porcentagem de impressões que geram um clique." },
  mgt_ctr_i: { ES: "Indica calidad creativa y relevancia del inventario publicitario.", EN: "Indicates creative quality and relevance of ad inventory.", PT: "Indica qualidade criativa e relevância do inventário publicitário." },
  mgt_cpm_k: { ES: "CPM · Costo por Mil Impresiones", EN: "CPM · Cost per Mille", PT: "CPM · Custo por Mil Impressões" },
  mgt_cpm_d: { ES: "Costo por cada mil impresiones de un anuncio.", EN: "Cost per thousand ad impressions.", PT: "Custo por mil impressões de um anúncio." },
  mgt_cpm_i: { ES: "Tarifa base del inventario; sube con engagement y data first-party.", EN: "Inventory base rate; rises with engagement and first-party data.", PT: "Tarifa base do inventário; sobe com engajamento e dados first-party." },
  mgt_rs_k: { ES: "Revenue Share", EN: "Revenue Share", PT: "Revenue Share" },
  mgt_rs_d: { ES: "Porcentaje de ingresos compartidos con partners (afiliados, patrocinadores).", EN: "Revenue percentage shared with partners (affiliates, sponsors).", PT: "Percentual de receita compartilhado com parceiros (afiliados, patrocinadores)." },
  mgt_rs_i: { ES: "Modelo central de monetización con casas de apuestas y media buyers.", EN: "Core monetization model with bookmakers and media buyers.", PT: "Modelo central de monetização com casas de apostas e media buyers." },
  mgt_eng_k: { ES: "Tasa de Engagement", EN: "Engagement Rate", PT: "Taxa de Engajamento" },
  mgt_eng_d: { ES: "Interacciones (votos, chats, predicciones) por sesión.", EN: "Interactions (votes, chats, predictions) per session.", PT: "Interações (votos, chats, previsões) por sessão." },
  mgt_eng_i: { ES: "Multiplica el CPM premium y la retención de fans.", EN: "Multiplies premium CPM and fan retention.", PT: "Multiplica o CPM premium e a retenção de fãs." },
  mgt_ret_k: { ES: "Tasa de Retención", EN: "Retention Rate", PT: "Taxa de Retenção" },
  mgt_ret_d: { ES: "Porcentaje de usuarios que regresan en un periodo.", EN: "Percentage of users returning in a period.", PT: "Porcentagem de usuários que retornam em um período." },
  mgt_ret_i: { ES: "Base de ingresos recurrentes y crecimiento orgánico.", EN: "Foundation of recurring revenue and organic growth.", PT: "Base de receita recorrente e crescimento orgânico." },
  mgt_conv_k: { ES: "Tasa de Conversión", EN: "Conversion Rate", PT: "Taxa de Conversão" },
  mgt_conv_d: { ES: "Porcentaje de usuarios que completan una acción objetivo.", EN: "Percentage of users completing a target action.", PT: "Porcentagem de usuários que completam uma ação alvo." },
  mgt_conv_i: { ES: "Mide el ROI directo de campañas y patrocinios.", EN: "Measures direct ROI of campaigns and sponsorships.", PT: "Mede o ROI direto de campanhas e patrocínios." },
  mgt_sproi_k: { ES: "ROI de Patrocinio", EN: "Sponsorship ROI", PT: "ROI de Patrocínio" },
  mgt_sproi_d: { ES: "Retorno publicitario basado en interacción + sentimiento.", EN: "Ad return based on interaction + sentiment.", PT: "Retorno publicitário baseado em interação + sentimento." },
  mgt_sproi_i: { ES: "Argumento de venta principal con marcas Fortune 500.", EN: "Primary sales argument with Fortune 500 brands.", PT: "Principal argumento de venda com marcas Fortune 500." },
  mgt_sent_k: { ES: "Sentiment Score", EN: "Sentiment Score", PT: "Sentiment Score" },
  mgt_sent_d: { ES: "Índice agregado del sentimiento del fan en tiempo real.", EN: "Aggregated real-time fan sentiment index.", PT: "Índice agregado do sentimento do fã em tempo real." },
  mgt_sent_i: { ES: "Detecta el momento óptimo para activar inventario premium.", EN: "Detects the optimal moment to activate premium inventory.", PT: "Detecta o momento ideal para ativar inventário premium." },
  // Halftime Engagement Hub
  hub_title: { ES: "Centro de Entretiempo", EN: "Halftime Hub", PT: "Centro de Intervalo" },
  hub_close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  hub_minimize: { ES: "Minimizar", EN: "Minimize", PT: "Minimizar" },
  hub_mute: { ES: "Silenciar promociones", EN: "Mute promotions", PT: "Silenciar promoções" },
  hub_unmute: { ES: "Activar promociones", EN: "Unmute promotions", PT: "Ativar promoções" },
  hub_betting_disclaimer: { ES: "Promociones simuladas con fines demostrativos. Juega con responsabilidad.", EN: "Simulated promotions for demo. Play responsibly.", PT: "Promoções simuladas para demonstração. Jogue com responsabilidade." },
  hub_trigger_halftime: { ES: "Medio tiempo", EN: "Halftime", PT: "Intervalo" },
  hub_trigger_commercial: { ES: "Pausa comercial", EN: "Commercial break", PT: "Pausa comercial" },
  hub_trigger_var: { ES: "Revisión VAR", EN: "VAR review", PT: "Revisão VAR" },
  hub_trigger_postmatch: { ES: "Post-partido", EN: "Post-match", PT: "Pós-jogo" },
  hub_trigger_timeout: { ES: "Tiempo muerto", EN: "Timeout", PT: "Tempo morto" },
  hub_trigger_manual: { ES: "Engagement", EN: "Engagement", PT: "Engagement" },
  hub_tab_promos: { ES: "Promos", EN: "Promos", PT: "Promos" },
  hub_tab_quiz: { ES: "Quiz", EN: "Quiz", PT: "Quiz" },
  hub_tab_ai: { ES: "IA", EN: "AI", PT: "IA" },
  hub_tab_stats: { ES: "Stats", EN: "Stats", PT: "Stats" },
  hub_tab_matches: { ES: "Otros", EN: "Other", PT: "Outros" },
  hub_tab_results: { ES: "Resultados", EN: "Results", PT: "Resultados" },
  hub_tab_rewards: { ES: "Premios", EN: "Rewards", PT: "Prêmios" },
  hub_tab_leaderboard: { ES: "Ranking", EN: "Ranking", PT: "Ranking" },
  hub_tab_highlights: { ES: "Highlights", EN: "Highlights", PT: "Highlights" },
  hub_tab_news: { ES: "Noticias", EN: "News", PT: "Notícias" },
  hub_promos_sponsored: { ES: "Patrocinadas", EN: "Sponsored", PT: "Patrocinadas" },
  hub_promos_redeem: { ES: "Canjeables", EN: "Redeemable", PT: "Resgatáveis" },
  hub_promos_muted: { ES: "Promociones silenciadas. Activa el sonido para verlas.", EN: "Promotions muted. Unmute to view.", PT: "Promoções silenciadas. Ative para ver." },
  hub_no_campaigns: { ES: "Sin campañas activas.", EN: "No active campaigns.", PT: "Sem campanhas ativas." },
  hub_no_rewards: { ES: "Sin recompensas disponibles.", EN: "No rewards available.", PT: "Sem prêmios disponíveis." },
  hub_invasion_label: { ES: "Oferta express", EN: "Flash offer", PT: "Oferta relâmpago" },
  hub_invasion_cta: { ES: "Aprovechar", EN: "Claim", PT: "Aproveitar" },
  hub_invasion_ends_in: { ES: "Termina en {s}s", EN: "Ends in {s}s", PT: "Termina em {s}s" },
  hub_invasion_expired: { ES: "Oferta expirada", EN: "Offer expired", PT: "Oferta expirada" },
  hub_kpis_title: { ES: "KPIs del Halftime Hub", EN: "Halftime Hub KPIs", PT: "KPIs do Halftime Hub" },
  hub_kpis_window: { ES: "Últimos 7 días", EN: "Last 7 days", PT: "Últimos 7 dias" },
  hub_kpi_opens: { ES: "Aperturas", EN: "Opens", PT: "Aberturas" },
  hub_kpi_avg_time: { ES: "Tiempo prom.", EN: "Avg. time", PT: "Tempo médio" },
  hub_kpi_tab_clicks: { ES: "Clics en tabs", EN: "Tab clicks", PT: "Cliques em abas" },
  hub_kpi_ai: { ES: "Preguntas IA", EN: "AI questions", PT: "Perguntas IA" },
  hub_kpi_quizzes: { ES: "Quizzes", EN: "Quizzes", PT: "Quizzes" },
  hub_kpi_promos: { ES: "Promos clic", EN: "Promo clicks", PT: "Promos cliques" },
  hub_kpi_vouchers_opened: { ES: "Vouchers abiertos", EN: "Vouchers opened", PT: "Vouchers abertos" },
  hub_kpi_vouchers_redeemed: { ES: "Vouchers canjeados", EN: "Vouchers redeemed", PT: "Vouchers resgatados" },
  hub_kpi_ad_imps: { ES: "Impresiones ad", EN: "Ad impressions", PT: "Impressões ad" },
  hub_kpi_ad_ctr: { ES: "CTR ad", EN: "Ad CTR", PT: "CTR ad" },
  hub_kpi_revenue: { ES: "Ingreso est.", EN: "Est. revenue", PT: "Receita est." },
  hub_kpi_retention: { ES: "Uplift retención", EN: "Retention uplift", PT: "Aumento retenção" },
  hub_quiz_title: { ES: "Mini Quiz", EN: "Mini Quiz", PT: "Mini Quiz" },
  hub_q_mvp: { ES: "¿Quién será el MVP del partido?", EN: "Who will be the MVP?", PT: "Quem será o MVP?" },
  hub_q_next_goal: { ES: "¿Quién marcará el próximo gol?", EN: "Who scores the next goal?", PT: "Quem marca o próximo gol?" },
  hub_q_no_goal: { ES: "Sin goles", EN: "No goal", PT: "Sem gol" },
  hub_q_comeback: { ES: "¿Habrá remontada?", EN: "Will there be a comeback?", PT: "Haverá virada?" },
  hub_q_draw: { ES: "Empate", EN: "Draw", PT: "Empate" },
  hub_q_trivia: { ES: "¿Año del primer Mundial?", EN: "Year of the first World Cup?", PT: "Ano da primeira Copa?" },
  hub_points_earned: { ES: "puntos ganados", EN: "points earned", PT: "pontos ganhos" },
  hub_ai_greeting: { ES: "¡Hola! Pregúntame sobre el partido, jugadores o tácticas.", EN: "Hi! Ask me about the match, players or tactics.", PT: "Olá! Pergunte sobre o jogo, jogadores ou táticas." },
  hub_ai_placeholder: { ES: "Escribe tu pregunta…", EN: "Type your question…", PT: "Escreva sua pergunta…" },
  hub_ai_send: { ES: "Enviar", EN: "Send", PT: "Enviar" },
  hub_ai_title: { ES: "Halftime AI · Analista táctico", EN: "Halftime AI · Tactical analyst", PT: "Halftime AI · Analista tático" },
  hub_ai_remaining: { ES: "{n}/{total} preguntas", EN: "{n}/{total} questions", PT: "{n}/{total} perguntas" },
  hub_ai_questions_today: { ES: "preguntas hoy", EN: "questions today", PT: "perguntas hoje" },
  hub_ai_limit_title: { ES: "Has alcanzado tu límite diario", EN: "You've hit your daily limit", PT: "Você atingiu o limite diário" },
  hub_ai_limit_guest: { ES: "Regístrate gratis para obtener 15 preguntas/día.", EN: "Sign up free to get 15 questions/day.", PT: "Cadastre-se grátis para obter 15 perguntas/dia." },
  hub_ai_limit_upgrade: { ES: "Mejora a Premium para 50 preguntas/día.", EN: "Upgrade to Premium for 50 questions/day.", PT: "Faça upgrade para Premium e tenha 50 perguntas/dia." },
  hub_ai_register_cta: { ES: "Crear cuenta", EN: "Create account", PT: "Criar conta" },
  hub_ai_upgrade_cta: { ES: "Mejorar plan", EN: "Upgrade plan", PT: "Fazer upgrade" },
  hub_ai_s1: { ES: "¿Quién marcará el próximo gol?", EN: "Who scores next?", PT: "Quem marca o próximo?" },
  hub_ai_s2: { ES: "¿Cuál es el MVP?", EN: "Who is the MVP?", PT: "Quem é o MVP?" },
  hub_ai_s3: { ES: "¿Habrá remontada?", EN: "Will there be a comeback?", PT: "Haverá virada?" },
  hub_ai_fallback: { ES: "Buena pregunta. Sigo analizando datos del partido.", EN: "Good question. I'm still analyzing match data.", PT: "Boa pergunta. Ainda estou analisando os dados." },
  hub_ai_intent_next_goal: { ES: "El xG sugiere que {home} tiene la próxima oportunidad clara.", EN: "xG suggests {home} has the next clear chance.", PT: "O xG sugere que {home} tem a próxima chance clara." },
  hub_ai_intent_final: { ES: "Modelo: {home} ligeramente favorito en los minutos finales.", EN: "Model: {home} slightly favored late.", PT: "Modelo: {home} ligeiramente favorito no fim." },
  hub_ai_intent_mvp: { ES: "Mediocampista creativo lidera ratings esperados.", EN: "Creative midfielder leads expected ratings.", PT: "Meio-campista criativo lidera as avaliações." },
  hub_ai_intent_scorer: { ES: "Delantero con mayor xG acumulado del partido.", EN: "Forward with the highest accumulated xG.", PT: "Atacante com maior xG do jogo." },
  hub_ai_intent_assister: { ES: "Volante creativo con más pases progresivos.", EN: "Creative winger with most progressive passes.", PT: "Meia criativo com mais passes progressivos." },
  hub_ai_intent_underperf: { ES: "Lateral con xG en contra elevado y duelos perdidos.", EN: "Fullback with high xGA and lost duels.", PT: "Lateral com xGA alto e duelos perdidos." },
  hub_ai_intent_comeback: { ES: "Quedan minutos suficientes ({minute}') para que cambie el marcador.", EN: "Enough minutes remain ({minute}') for the score to change.", PT: "Restam minutos suficientes ({minute}') para mudar o placar." },
  hub_stats_possession: { ES: "Posesión", EN: "Possession", PT: "Posse" },
  hub_stats_xg: { ES: "xG", EN: "xG", PT: "xG" },
  hub_stats_shots: { ES: "Tiros", EN: "Shots", PT: "Chutes" },
  hub_stats_pressure: { ES: "Presión", EN: "Pressure", PT: "Pressão" },
  hub_stats_fatigue: { ES: "Fatiga", EN: "Fatigue", PT: "Fadiga" },
  hub_stats_top_speed: { ES: "Vel. máx.", EN: "Top speed", PT: "Vel. máx." },
  hub_stats_top_performer: { ES: "Top performer", EN: "Top performer", PT: "Top performer" },
  hub_stats_xg_diff: { ES: "Δ xG", EN: "Δ xG", PT: "Δ xG" },
  hub_stats_lineup: { ES: "Esquema", EN: "Formation", PT: "Esquema" },
  hub_stats_heatmap: { ES: "Mapa de calor", EN: "Heatmap", PT: "Mapa de calor" },
  hub_matches_live: { ES: "En vivo ahora", EN: "Live now", PT: "Ao vivo agora" },
  hub_results_final: { ES: "Resultados finales", EN: "Final results", PT: "Resultados finais" },
  hub_rewards_yours: { ES: "Tus vouchers", EN: "Your vouchers", PT: "Seus vouchers" },
  hub_rewards_none: { ES: "Aún no tienes vouchers. Gana más puntos para canjearlos.", EN: "No vouchers yet. Earn points to redeem.", PT: "Sem vouchers ainda. Ganhe pontos para resgatar." },
  hub_rewards_expires: { ES: "Vence", EN: "Expires", PT: "Expira" },
  hub_rewards_open_center: { ES: "Abrir Mis Premios", EN: "Open My Rewards", PT: "Abrir Meus Prêmios" },
  hub_leader_top: { ES: "Top fans", EN: "Top fans", PT: "Top fãs" },
  hub_leader_you: { ES: "Tú", EN: "You", PT: "Você" },
  hub_hl_title: { ES: "Highlights", EN: "Highlights", PT: "Highlights" },
  hub_hl_goal: { ES: "Gol", EN: "Goal", PT: "Gol" },
  hub_hl_yellow: { ES: "Amarilla", EN: "Yellow card", PT: "Amarelo" },
  hub_hl_sub: { ES: "Cambio", EN: "Substitution", PT: "Substituição" },
  hub_news_title: { ES: "Noticias del torneo", EN: "Tournament news", PT: "Notícias do torneio" },
  hub_news_n1: { ES: "Récord de audiencia mundial en cuartos.", EN: "Global audience record in quarterfinals.", PT: "Recorde de audiência nas quartas." },
  hub_news_n2: { ES: "Nuevo líder histórico de asistencias.", EN: "New all-time assists leader.", PT: "Novo líder histórico em assistências." },
  hub_news_n3: { ES: "El xG total del torneo supera el de 2022.", EN: "Tournament total xG surpasses 2022.", PT: "xG total do torneio supera 2022." },
  hub_trivia_title: { ES: "Datos curiosos", EN: "Did you know?", PT: "Curiosidades" },
  hub_trivia_t1: { ES: "El primer Mundial fue en Uruguay 1930.", EN: "The first World Cup was Uruguay 1930.", PT: "A primeira Copa foi no Uruguai em 1930." },
  hub_trivia_t2: { ES: "Brasil es el único pentacampeón.", EN: "Brazil is the only five-time champion.", PT: "Brasil é o único pentacampeão." },
  hub_trivia_t3: { ES: "El gol más rápido en Mundiales: 11 segundos.", EN: "Fastest World Cup goal: 11 seconds.", PT: "Gol mais rápido em Copas: 11 segundos." },
  // Halftime Hub admin settings
  hhs_title: { ES: "Configuración del Hub de Entretiempo", EN: "Halftime Hub Settings", PT: "Configuração do Hub de Intervalo" },
  hhs_subtitle: { ES: "Controla disparadores, pestañas y promociones destacadas.", EN: "Control triggers, tabs and featured promotions.", PT: "Controle gatilhos, abas e promoções em destaque." },
  hhs_enabled: { ES: "Hub activo", EN: "Hub enabled", PT: "Hub ativo" },
  hhs_triggers: { ES: "Disparadores automáticos", EN: "Auto triggers", PT: "Gatilhos automáticos" },
  hhs_tabs: { ES: "Pestañas habilitadas", EN: "Enabled tabs", PT: "Abas habilitadas" },
  hhs_featured: { ES: "Promoción destacada", EN: "Featured promotion", PT: "Promoção em destaque" },
  hhs_none: { ES: "Sin destacar", EN: "None", PT: "Nenhuma" },
  hhs_rotation: { ES: "Rotación (segundos)", EN: "Rotation (seconds)", PT: "Rotação (segundos)" },
  hhs_save: { ES: "Guardar", EN: "Save", PT: "Salvar" },
  hhs_saving: { ES: "Guardando…", EN: "Saving…", PT: "Salvando…" },
  hhs_saved: { ES: "Configuración guardada", EN: "Settings saved", PT: "Configuração salva" },
  comm_tab_community: { ES: "Comunidad", EN: "Community", PT: "Comunidade" },
  comm_tab_oracle: { ES: "AI Oracle", EN: "AI Oracle", PT: "AI Oracle" },
  community_chat_title: { ES: "Chat de la Comunidad", EN: "Community Chat", PT: "Chat da Comunidade" },
  community_chat_empty: { ES: "Sé el primero en comentar el partido.", EN: "Be the first to comment.", PT: "Seja o primeiro a comentar." },
  community_chat_placeholder: { ES: "Escribe un mensaje…", EN: "Write a message…", PT: "Escreva uma mensagem…" },
  oracle_private_title: { ES: "Analista Privado", EN: "Private Analyst", PT: "Analista Privado" },
  oracle_private_badge: { ES: "Solo tú lo ves", EN: "Visible only to you", PT: "Visível apenas para você" },
  community_like: { ES: "Me gusta", EN: "Like", PT: "Curtir" },
  community_report: { ES: "Reportar", EN: "Report", PT: "Reportar" },
  community_send: { ES: "Enviar", EN: "Send", PT: "Enviar" },
  chat_avatar_ai: { ES: "VS", EN: "VS", PT: "VS" },
  chat_avatar_user: { ES: "YO", EN: "ME", PT: "EU" },
  match_switched_title: { ES: "Cambio de partido: {match}", EN: "Match switched: {match}", PT: "Partida trocada: {match}" },
  match_switched_body: { ES: "Radar, marcador y línea de tiempo reiniciados.", EN: "Radar, scoreboard and timeline reset.", PT: "Radar, placar e linha do tempo reiniciados." },
  loading_live_tracker: { ES: "Cargando Live Tracker…", EN: "Loading Live Tracker…", PT: "Carregando Live Tracker…" },
  demo_simulated_data: { ES: "DATOS SIMULADOS", EN: "SIMULATED DATA", PT: "DADOS SIMULADOS" },
  live_tracker: { ES: "LIVE TRACKER", EN: "LIVE TRACKER", PT: "LIVE TRACKER" },
  guest_label: { ES: "Invitado", EN: "Guest", PT: "Convidado" },
  pitch_home_label: { ES: "LOCAL", EN: "HOME", PT: "CASA" },
  pitch_away_label: { ES: "VISITANTE", EN: "AWAY", PT: "VISITANTE" },
  pitch_left_side: { ES: "Lado izquierdo", EN: "Left Side", PT: "Lado esquerdo" },
  pitch_right_side: { ES: "Lado derecho", EN: "Right Side", PT: "Lado direito" },
  pitch_attack_direction: { ES: "Dirección de ataque", EN: "Attack Direction", PT: "Direção de ataque" },
  pitch_identity_legend: { ES: "{leftLabel}: {home} · {rightLabel}: {away}", EN: "{leftLabel}: {home} · {rightLabel}: {away}", PT: "{leftLabel}: {home} · {rightLabel}: {away}" },
  // Multi-tenant white-label
  mt_title: { ES: "Multi-Tenant Command Center", EN: "Multi-Tenant Command Center", PT: "Multi-Tenant Command Center" },
  mt_subtitle: { ES: "Licencias white-label · super admin", EN: "White-label licensing · super admin", PT: "Licenças white-label · super admin" },
  mt_new_tenant: { ES: "Nuevo cliente", EN: "New tenant", PT: "Novo cliente" },
  mt_create: { ES: "Crear cliente", EN: "Create tenant", PT: "Criar cliente" },
  mt_field_name: { ES: "Nombre", EN: "Name", PT: "Nome" },
  mt_kpi_active: { ES: "Activos", EN: "Active", PT: "Ativos" },
  mt_kpi_mrr: { ES: "MRR", EN: "MRR", PT: "MRR" },
  mt_kpi_seats: { ES: "Asientos", EN: "Seats", PT: "Lugares" },
  mt_impersonate: { ES: "Impersonar", EN: "Impersonate", PT: "Impersonar" },
  mt_suspend: { ES: "Suspender", EN: "Suspend", PT: "Suspender" },
  mt_reactivate: { ES: "Reactivar", EN: "Reactivate", PT: "Reativar" },
  mt_delete: { ES: "Eliminar", EN: "Delete", PT: "Eliminar" },
  mt_empty: { ES: "Sin clientes aún", EN: "No tenants yet", PT: "Sem clientes ainda" },
  mt_select_hint: { ES: "Selecciona un cliente para ver detalles", EN: "Select a tenant to see details", PT: "Selecione um cliente para ver detalhes" },
  mt_users: { ES: "Usuarios", EN: "Users", PT: "Usuários" },
  mt_invite_user: { ES: "Invitar usuario", EN: "Invite user", PT: "Convidar usuário" },
  mt_invite_send: { ES: "Enviar invitación", EN: "Send invite", PT: "Enviar convite" },
  mt_branding: { ES: "Branding", EN: "Branding", PT: "Branding" },
  // Tenant portal
  tp_portal_subtitle: { ES: "Panel del cliente", EN: "Tenant portal", PT: "Painel do cliente" },
  tp_no_tenant_title: { ES: "Cliente no encontrado", EN: "Tenant not found", PT: "Cliente não encontrado" },
  tp_no_tenant_desc: { ES: "El identificador de cliente no es válido o ya no está activo.", EN: "The tenant identifier is invalid or no longer active.", PT: "O identificador de cliente é inválido ou não está mais ativo." },
  tp_impersonating: { ES: "Modo impersonación: {name}", EN: "Impersonation mode: {name}", PT: "Modo impersonação: {name}" },
  tp_end_impersonation: { ES: "Salir", EN: "End", PT: "Sair" },
  tp_kpi_campaigns: { ES: "Campañas", EN: "Campaigns", PT: "Campanhas" },
  tp_kpi_sessions: { ES: "Sesiones", EN: "Sessions", PT: "Sessões" },
  tp_kpi_conversions: { ES: "Conversiones", EN: "Conversions", PT: "Conversões" },
  tp_kpi_seats: { ES: "Asientos", EN: "Seats", PT: "Lugares" },
  tp_campaigns: { ES: "Campañas", EN: "Campaigns", PT: "Campanhas" },
  tp_campaigns_empty: { ES: "Aún no hay campañas activas para este cliente.", EN: "No active campaigns for this tenant yet.", PT: "Ainda não há campanhas ativas para este cliente." },
  tp_team: { ES: "Equipo", EN: "Team", PT: "Equipe" },
  tp_team_empty: { ES: "Sin usuarios invitados", EN: "No invited users", PT: "Sem usuários convidados" },
  tp_reports: { ES: "Reportes", EN: "Reports", PT: "Relatórios" },
  tp_reports_scope: { ES: "Solo se exportan los datos de este cliente.", EN: "Only this tenant's data is exported.", PT: "Somente os dados deste cliente são exportados." },
};

// Additional dynamic-context keys (cross-match toasts, demo controls, stats labels).
Object.assign(dict, {
  cross_match_goal_title: { ES: "⚽ GOL — {home} {hs}-{as} {away}", EN: "⚽ GOAL — {home} {hs}-{as} {away}", PT: "⚽ GOL — {home} {hs}-{as} {away}" },
  cross_match_penalty_title: { ES: "🔥 Penal para {team}", EN: "🔥 Penalty for {team}", PT: "🔥 Pênalti para {team}" },
  cross_match_watch_now: { ES: "Mira la jugada ahora", EN: "Watch the play now", PT: "Veja a jogada agora" },
  cross_match_score_subtitle: { ES: "{home} {hs}-{as} {away}", EN: "{home} {hs}-{as} {away}", PT: "{home} {hs}-{as} {away}" },
  demo_restarted: { ES: "🎬 Demo reiniciada", EN: "🎬 Demo restarted", PT: "🎬 Demo reiniciada" },
  demo_mode_activated_title: { ES: "🎬 Modo demo activado", EN: "🎬 Demo mode activated", PT: "🎬 Modo demo ativado" },
  demo_mode_activated_sub: { ES: "Simulación reiniciada", EN: "Simulation restarted", PT: "Simulação reiniciada" },
  participate_now_aria: { ES: "Participar ahora", EN: "Join now", PT: "Participar agora" },
  stat_possession: { ES: "Posesión", EN: "Possession", PT: "Posse" },
  stat_shots: { ES: "Tiros", EN: "Shots", PT: "Chutes" },
  stat_momentum: { ES: "Momentum", EN: "Momentum", PT: "Momentum" },
  stat_xg: { ES: "xG", EN: "xG", PT: "xG" },
  stat_vs: { ES: "vs", EN: "vs", PT: "vs" },
  stat_corners: { ES: "Córners", EN: "Corners", PT: "Escanteios" },
  stat_waiting_official:
    { ES: "Esperando estadísticas oficiales del partido",
      EN: "Waiting for official match statistics",
      PT: "Aguardando estatísticas oficiais da partida" },
  stat_prematch_none:
    { ES: "Sin estadísticas todavía",
      EN: "No statistics available yet",
      PT: "Sem estatísticas ainda" },
  // Real Data Phase 3 — Official Lineups module
  lineups_title: { ES: "Alineaciones oficiales", EN: "Official Lineups", PT: "Escalações oficiais" },
  lineups_not_announced: {
    ES: "Alineaciones oficiales aún no anunciadas",
    EN: "Official lineups not announced yet",
    PT: "Escalações oficiais ainda não anunciadas",
  },
  lineups_unavailable: {
    ES: "Alineaciones oficiales no disponibles",
    EN: "Official lineups unavailable",
    PT: "Escalações oficiais indisponíveis",
  },
  lineups_loading: { ES: "Cargando alineaciones oficiales…", EN: "Loading official lineups…", PT: "Carregando escalações oficiais…" },
  lineups_starting_xi: { ES: "Once titular", EN: "Starting XI", PT: "Time titular" },
  lineups_bench: { ES: "Suplentes", EN: "Bench", PT: "Reservas" },
  lineups_coach: { ES: "DT", EN: "Coach", PT: "Técnico" },
  lineups_formation: { ES: "Formación", EN: "Formation", PT: "Formação" },
  lineups_captain: { ES: "Capitán", EN: "Captain", PT: "Capitão" },
  lineups_source_api_football: {
    ES: "Fuente oficial · API-Football",
    EN: "Official source · API-Football",
    PT: "Fonte oficial · API-Football",
  },
  lineups_subs_in_timeline: {
    ES: "Los cambios se muestran en la línea de tiempo del partido",
    EN: "Substitutions appear in the match events timeline",
    PT: "As substituições aparecem na linha do tempo do jogo",
  },
  // Real Data Phase 4 — Official Player Statistics module
  player_stats_title: {
    ES: "Estadísticas oficiales de jugadores",
    EN: "Official player statistics",
    PT: "Estatísticas oficiais de jogadores",
  },
  player_stats_loading: {
    ES: "Cargando estadísticas oficiales…",
    EN: "Loading official statistics…",
    PT: "Carregando estatísticas oficiais…",
  },
  player_stats_pre_match: {
    ES: "Las estadísticas de jugadores estarán disponibles durante el partido",
    EN: "Player statistics will be available during the match",
    PT: "As estatísticas dos jogadores estarão disponíveis durante a partida",
  },
  player_stats_waiting_live: {
    ES: "Esperando estadísticas oficiales de jugadores",
    EN: "Waiting for official player statistics",
    PT: "Aguardando estatísticas oficiais dos jogadores",
  },
  player_stats_finished_unavailable: {
    ES: "Estadísticas oficiales de jugadores no disponibles",
    EN: "Official player statistics unavailable",
    PT: "Estatísticas oficiais de jogadores indisponíveis",
  },
  player_stats_provider_error: {
    ES: "No se pudieron obtener las estadísticas oficiales",
    EN: "Couldn’t load official statistics",
    PT: "Não foi possível carregar as estatísticas oficiais",
  },
  player_stats_col_player: { ES: "Jugador", EN: "Player", PT: "Jogador" },
  player_stats_col_pos:    { ES: "Pos",     EN: "Pos",    PT: "Pos" },
  player_stats_col_min:    { ES: "Min",     EN: "Min",    PT: "Min" },
  player_stats_col_rating: { ES: "Rating",  EN: "Rating", PT: "Rating" },
  player_stats_col_g:      { ES: "G",       EN: "G",      PT: "G" },
  player_stats_col_a:      { ES: "A",       EN: "A",      PT: "A" },
  player_stats_col_sh:     { ES: "Tir/Al",  EN: "Sh/On",  PT: "Ch/No" },
  player_stats_col_pass:   { ES: "Pases",   EN: "Passes", PT: "Passes" },
  player_stats_col_tkl:    { ES: "Ent",     EN: "Tkl",    PT: "Des" },
  player_stats_col_cards:  { ES: "Tarj",    EN: "Cards",  PT: "Cart" },
  player_stats_col_sv:     { ES: "Atj",     EN: "Sv",     PT: "Def" },
  // PR-32 — Quick Actions Dock
  qa_dock_rewards:  { ES: "Insights",      EN: "Insights",  PT: "Insights" },
  qa_dock_stats:    { ES: "Estadísticas",  EN: "Stats",     PT: "Estatísticas" },
  qa_dock_halftime: { ES: "Match Hub",     EN: "Match Hub", PT: "Match Hub" },
  qa_dock_polls:    { ES: "Pulse",         EN: "Pulse",     PT: "Pulse" },
  qa_dock_ai:       { ES: "IA",            EN: "AI",        PT: "IA" },
  // Advanced Stats Module
  adv_stats_title: { ES: "Estadísticas Avanzadas", EN: "Advanced Stats", PT: "Estatísticas Avançadas" },
  adv_stats_btn: { ES: "📊 Estadísticas", EN: "📊 Advanced Stats", PT: "📊 Estatísticas" },
  adv_match_insight: { ES: "Match Insight", EN: "Match Insight", PT: "Match Insight" },
  adv_help: { ES: "Ayuda", EN: "Help", PT: "Ajuda" },
  adv_example: { ES: "Ejemplo", EN: "Example", PT: "Exemplo" },
  adv_interpretation: { ES: "Interpretación", EN: "Interpretation", PT: "Interpretação" },
  adv_betting_tip: { ES: "Consejo para apuestas", EN: "Betting tip", PT: "Dica de apostas" },
  adv_learn_btn: { ES: "Aprender más", EN: "Learn more", PT: "Saiba mais" },
  adv_learn_title: { ES: "Aprende analítica deportiva", EN: "Learn Sports Analytics", PT: "Aprenda análise esportiva" },
  adv_learn_intro: {
    ES: "Una guía rápida para entender cada métrica avanzada y usarlas para análisis y apuestas inteligentes.",
    EN: "A quick guide to every advanced metric and how to use them for smart analysis and betting.",
    PT: "Um guia rápido para cada métrica avançada e como usá-las para análise e apostas inteligentes.",
  },
  adv_legend_title: { ES: "Cómo leerlo", EN: "How to read", PT: "Como ler" },
  adv_legend_bars: {
    ES: "Barras: más largo = mayor valor para ese equipo.",
    EN: "Bars: longer = higher value for that team.",
    PT: "Barras: mais longo = valor maior para a equipe.",
  },
  adv_legend_heatmap: {
    ES: "Más color = mayor actividad en esa zona del campo.",
    EN: "More color = higher activity in that pitch zone.",
    PT: "Mais cor = maior atividade nessa zona do campo.",
  },
  adv_tour_step: { ES: "Paso {n} de {total}", EN: "Step {n} of {total}", PT: "Passo {n} de {total}" },
  adv_skip: { ES: "Omitir", EN: "Skip", PT: "Pular" },
  adv_prev: { ES: "Anterior", EN: "Back", PT: "Voltar" },
  adv_next: { ES: "Siguiente", EN: "Next", PT: "Próximo" },
  adv_finish: { ES: "Listo", EN: "Done", PT: "Pronto" },
  // Insight templates
  adv_insight_balanced: { ES: "Partido muy equilibrado: ambos equipos generan oportunidades parecidas.", EN: "Very balanced match: both teams generate similar chances.", PT: "Jogo equilibrado: ambas equipes criam chances semelhantes." },
  adv_insight_dominant_possession: { ES: "{home} domina la posesión, pero {away} genera oportunidades similares.", EN: "{home} dominates possession, but {away} creates similar chances.", PT: "{home} domina a posse, mas {away} gera chances similares." },
  adv_insight_xg_lead: { ES: "{team} merece estar arriba según la calidad de sus oportunidades.", EN: "{team} deserves to be ahead based on chance quality.", PT: "{team} merece estar à frente pela qualidade das chances." },
  adv_insight_fatigue: { ES: "La fatiga acumulada podría influir en los últimos minutos.", EN: "Accumulated fatigue could be decisive in final minutes.", PT: "A fadiga acumulada pode influenciar nos minutos finais." },
  adv_insight_pressure: { ES: "{team} presiona con más intensidad y controla el ritmo.", EN: "{team} presses harder and controls the tempo.", PT: "{team} pressiona com mais intensidade e controla o ritmo." },
  // Tooltips per metric
  adv_tip_possession_title: { ES: "Posesión", EN: "Possession", PT: "Posse de bola" },
  adv_tip_possession_desc: { ES: "Porcentaje de tiempo que cada equipo controla la pelota.", EN: "Share of time each team controls the ball.", PT: "Tempo em que cada equipe controla a bola." },
  adv_tip_possession_ex: { ES: "65% indica un dominio claro del partido.", EN: "65% indicates clear control of the game.", PT: "65% indica claro domínio do jogo." },
  adv_tip_possession_interp: { ES: "Más posesión no siempre significa más peligro: depende de dónde se tenga la pelota.", EN: "More possession doesn't always mean more danger: it depends on where you hold the ball.", PT: "Mais posse nem sempre significa mais perigo." },
  adv_tip_possession_bet: { ES: "Combina posesión con xG para evaluar dominio real.", EN: "Combine possession with xG to gauge true dominance.", PT: "Combine posse com xG para avaliar domínio real." },

  adv_tip_xg_title: { ES: "xG (Goles Esperados)", EN: "xG (Expected Goals)", PT: "xG (Gols Esperados)" },
  adv_tip_xg_desc: { ES: "Indica cuántos goles debería haber marcado un equipo según la calidad de sus oportunidades.", EN: "Estimates how many goals a team should have scored based on chance quality.", PT: "Quantos gols a equipe deveria ter marcado pela qualidade das chances." },
  adv_tip_xg_ex: { ES: "xG 2.1 con 1 gol = el equipo debería ir ganando con más diferencia.", EN: "xG 2.1 with 1 goal = team should be winning by more.", PT: "xG 2.1 com 1 gol = a equipe deveria estar ganhando mais." },
  adv_tip_xg_interp: { ES: "Un xG alto sin goles indica mala definición o gran portero rival.", EN: "High xG without goals = poor finishing or great keeper.", PT: "xG alto sem gols = má finalização ou ótimo goleiro." },
  adv_tip_xg_bet: { ES: "Equipos con xG superior al rival suelen revertir resultados.", EN: "Teams with higher xG than rivals tend to flip results.", PT: "Equipes com xG maior tendem a virar o resultado." },

  adv_tip_shots_title: { ES: "Tiros", EN: "Shots", PT: "Chutes" },
  adv_tip_shots_desc: { ES: "Total de remates al arco rival.", EN: "Total shots taken at the opposing goal.", PT: "Total de chutes ao gol adversário." },
  adv_tip_shots_ex: { ES: "12 tiros con 0 goles = mala puntería o defensa sólida.", EN: "12 shots with 0 goals = poor aim or strong defense.", PT: "12 chutes sem gol = má pontaria ou defesa sólida." },
  adv_tip_shots_interp: { ES: "Mira la relación tiros/xG para detectar definición ineficaz.", EN: "Check shots-to-xG ratio to spot poor finishing.", PT: "Veja a relação chutes/xG para detectar má finalização." },
  adv_tip_shots_bet: { ES: "Muchos tiros sin gol pueden anticipar un gol tardío.", EN: "Many shots without a goal can anticipate a late goal.", PT: "Muitos chutes sem gol podem antecipar gol tardio." },

  adv_tip_pressure_title: { ES: "Presión", EN: "Pressure", PT: "Pressão" },
  adv_tip_pressure_desc: { ES: "Mide qué tan intensamente un equipo ataca y recupera la pelota.", EN: "Measures how intensely a team attacks and recovers the ball.", PT: "Mede o quão intensamente uma equipe ataca e recupera a bola." },
  adv_tip_pressure_ex: { ES: "85% de presión = pressing alto sostenido.", EN: "85% pressure = sustained high pressing.", PT: "85% de pressão = pressing alto sustentado." },
  adv_tip_pressure_interp: { ES: "Alta presión genera errores defensivos rivales.", EN: "High pressure forces opponent errors.", PT: "Alta pressão gera erros defensivos." },
  adv_tip_pressure_bet: { ES: "Si la presión cae, sube la probabilidad de gol rival.", EN: "If pressure drops, opponent goal probability rises.", PT: "Se a pressão cai, aumenta a chance de gol adversário." },

  adv_tip_fatigue_title: { ES: "Fatiga", EN: "Fatigue", PT: "Fadiga" },
  adv_tip_fatigue_desc: { ES: "Estima el nivel de desgaste físico acumulado en los jugadores.", EN: "Estimates accumulated physical fatigue across players.", PT: "Estima o desgaste físico acumulado dos jogadores." },
  adv_tip_fatigue_ex: { ES: "Fatiga >60% suele anticipar errores y goles tardíos.", EN: "Fatigue >60% often anticipates errors and late goals.", PT: "Fadiga >60% costuma antecipar erros e gols tardios." },
  adv_tip_fatigue_interp: { ES: "Cuanto mayor la fatiga, más probable un cambio o gol al cierre.", EN: "Higher fatigue raises chances of subs or late goals.", PT: "Mais fadiga = mais chance de substituição ou gol no fim." },
  adv_tip_fatigue_bet: { ES: "Apuestas a goles +85' suben con fatiga elevada en ambos equipos.", EN: "Late-goal bets favor games with high two-sided fatigue.", PT: "Apostas em gols +85' sobem com fadiga alta dos dois lados." },

  adv_tip_top_title: { ES: "Top Performer", EN: "Top Performer", PT: "Top Performer" },
  adv_tip_top_desc: { ES: "El jugador con mayor impacto tácticio en el partido.", EN: "Player with the biggest tactical impact this match.", PT: "Jogador com maior impacto tático na partida." },
  adv_tip_top_ex: { ES: "Marca al goleador, asistente o líder de presión.", EN: "Highlights scorer, assister or pressing leader.", PT: "Destaca artilheiro, assistente ou líder de pressão." },
  adv_tip_top_interp: { ES: "Se actualiza con xG, asistencias y recuperaciones.", EN: "Updates with xG, assists and recoveries.", PT: "Atualiza com xG, assistências e recuperações." },
  adv_tip_top_bet: { ES: "Los top performers concentran apuestas de jugador.", EN: "Top performers attract player-prop bets.", PT: "Top performers concentram apostas de jogador." },

  adv_tip_heatmap_title: { ES: "Mapa de calor", EN: "Heatmap", PT: "Mapa de calor" },
  adv_tip_heatmap_desc: { ES: "Muestra dónde el partido tiene más actividad sobre el campo.", EN: "Shows where the match has the most activity on the pitch.", PT: "Mostra onde a partida tem mais atividade no campo." },
  adv_tip_heatmap_ex: { ES: "Concentración en banda derecha = ataque por ese lado.", EN: "Right-side concentration = attack down that flank.", PT: "Concentração na direita = ataque por aquele lado." },
  adv_tip_heatmap_interp: { ES: "Útil para detectar el lado más débil de la defensa rival.", EN: "Useful to detect the weakest side of the rival defense.", PT: "Útil para detectar o lado mais fraco da defesa rival." },
  adv_tip_heatmap_bet: { ES: "Mucho calor cerca del área anticipa córners y tiros.", EN: "High heat near the box anticipates corners and shots.", PT: "Muito calor perto da área antecipa escanteios e chutes." },
  // Admin panel
  adv_admin_title: { ES: "Configuración de Estadísticas Avanzadas", EN: "Advanced Stats Settings", PT: "Configuração de Estatísticas Avançadas" },
  adv_admin_subtitle: { ES: "Activa el tour, los tooltips y la interpretación automática.", EN: "Toggle tour, tooltips and automatic insight.", PT: "Ative tour, tooltips e insight automático." },
  adv_admin_tour: { ES: "Activar tour educativo", EN: "Enable educational tour", PT: "Ativar tour educativo" },
  adv_admin_tooltips: { ES: "Activar tooltips de ayuda", EN: "Enable help tooltips", PT: "Ativar tooltips de ajuda" },
  adv_admin_insight: { ES: "Activar Match Insight", EN: "Enable Match Insight", PT: "Ativar Match Insight" },
  adv_admin_learn: { ES: "Activar modal Aprender Más", EN: "Enable Learn More modal", PT: "Ativar modal Aprenda Mais" },
  adv_admin_reset_tour: { ES: "Reiniciar tour para todos", EN: "Reset tour for everyone", PT: "Reiniciar tour para todos" },
  adv_admin_saved: { ES: "Configuración guardada", EN: "Settings saved", PT: "Configuração salva" },
  // Sponsored survey modal & shared promotion labels
  promo_label_sponsored: { ES: "Patrocinado", EN: "Sponsored", PT: "Patrocinado" },
  promo_label_claim: { ES: "Reclamar", EN: "Claim", PT: "Reivindicar" },
  promo_label_flash_offer: { ES: "Oferta relámpago", EN: "Flash Offer", PT: "Oferta relâmpago" },
  ssm_sponsored_survey: { ES: "ENCUESTA PATROCINADA", EN: "SPONSORED SURVEY", PT: "PESQUISA PATROCINADA" },
  ssm_close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  ssm_skip: { ES: "Saltar", EN: "Skip", PT: "Pular" },
  ssm_back: { ES: "Atrás", EN: "Back", PT: "Voltar" },
  ssm_next: { ES: "Siguiente", EN: "Next", PT: "Próximo" },
  ssm_redeem_coupon: { ES: "Canjear cupón", EN: "Redeem coupon", PT: "Resgatar cupom" },
  ssm_q_food: { ES: "¿Qué estás comiendo?", EN: "What are you eating?", PT: "O que está comendo?" },
  ssm_q_drink: { ES: "¿Qué bebida prefieres?", EN: "Which drink do you prefer?", PT: "Qual bebida prefere?" },
  ssm_q_brand: { ES: "¿Qué marca consumes más?", EN: "Which brand do you consume most?", PT: "Qual marca você mais consome?" },
  ssm_food_pizza: { ES: "Pizza", EN: "Pizza", PT: "Pizza" },
  ssm_food_tacos: { ES: "Tacos", EN: "Tacos", PT: "Tacos" },
  ssm_food_burger: { ES: "Hamburguesa", EN: "Burger", PT: "Hambúrguer" },
  ssm_food_snacks: { ES: "Snacks", EN: "Snacks", PT: "Snacks" },
  ssm_drink_soda: { ES: "Refresco", EN: "Soda", PT: "Refrigerante" },
  ssm_drink_beer: { ES: "Cerveza", EN: "Beer", PT: "Cerveja" },
  ssm_drink_water: { ES: "Agua", EN: "Water", PT: "Água" },
  ssm_drink_energy: { ES: "Energética", EN: "Energy drink", PT: "Energético" },
  ssm_other: { ES: "Otro", EN: "Other", PT: "Outro" },
  ssm_submit_response: { ES: "Enviar respuesta", EN: "Submit Response", PT: "Enviar resposta" },
  ssm_complete_survey: { ES: "Finalizar encuesta", EN: "Complete Survey", PT: "Finalizar pesquisa" },
  ssm_submitting: { ES: "Enviando…", EN: "Submitting…", PT: "Enviando…" },
  ssm_thanks_title: { ES: "¡Gracias por participar!", EN: "Thanks for participating!", PT: "Obrigado por participar!" },
  ssm_result_points: { ES: "Puntos otorgados", EN: "Points awarded", PT: "Pontos concedidos" },
  ssm_result_voucher: { ES: "Cupón desbloqueado", EN: "Voucher unlocked", PT: "Cupom desbloqueado" },
  ssm_result_sweepstakes: { ES: "Participación registrada en la rifa", EN: "Sweepstakes entry registered", PT: "Participação registrada no sorteio" },
  ssm_result_physical: { ES: "Premio físico reservado", EN: "Physical reward reserved", PT: "Prêmio físico reservado" },
  ssm_result_betting: { ES: "Bono de apuesta desbloqueado", EN: "Betting bonus unlocked", PT: "Bônus de aposta desbloqueado" },
  ssm_result_none: { ES: "¡Tu opinión cuenta!", EN: "Your feedback matters!", PT: "Sua opinião conta!" },
  ssm_result_none_desc: { ES: "No hay recompensa inmediata, pero tu respuesta ayuda a mejorar las experiencias.", EN: "No immediate reward, but your response helps improve experiences.", PT: "Sem recompensa imediata, mas sua resposta ajuda a melhorar as experiências." },
  ssm_expires_on: { ES: "Vence el", EN: "Expires on", PT: "Expira em" },
  ssm_redeem_instructions: { ES: "Instrucciones de canje", EN: "Redemption instructions", PT: "Instruções de resgate" },
  ssm_default_instructions: { ES: "Presenta este código en cualquier punto participante.", EN: "Show this code at any participating location.", PT: "Apresente este código em qualquer local participante." },
  ssm_view_offer: { ES: "Ver oferta", EN: "View offer", PT: "Ver oferta" },
  ssm_done: { ES: "Listo", EN: "Done", PT: "Pronto" },
  ssm_reward_code: { ES: "Código", EN: "Code", PT: "Código" },
  adm_reward_section: { ES: "Recompensa", EN: "Reward", PT: "Recompensa" },
  adm_reward_type: { ES: "Tipo de recompensa", EN: "Reward type", PT: "Tipo de recompensa" },
  adm_reward_value: { ES: "Valor / descripción", EN: "Value / description", PT: "Valor / descrição" },
  adm_reward_points: { ES: "Puntos a otorgar", EN: "Points awarded", PT: "Pontos concedidos" },
  adm_reward_sweepstakes: { ES: "Activar rifa", EN: "Enable sweepstakes", PT: "Ativar sorteio" },
  adm_reward_instant: { ES: "Entrega instantánea", EN: "Instant delivery", PT: "Entrega instantânea" },
  adm_reward_expiration: { ES: "Fecha de expiración", EN: "Expiration date", PT: "Data de expiração" },
  adm_reward_countries: { ES: "Países elegibles (coma)", EN: "Eligible countries (comma)", PT: "Países elegíveis (vírgula)" },
  adm_reward_locations: { ES: "Locales de canje (coma)", EN: "Redemption locations (comma)", PT: "Locais de resgate (vírgula)" },
  reward_type_instant_voucher: { ES: "Cupón instantáneo", EN: "Instant voucher", PT: "Cupom instantâneo" },
  reward_type_sweepstakes_entry: { ES: "Entrada a rifa", EN: "Sweepstakes entry", PT: "Entrada em sorteio" },
  reward_type_bonus_points: { ES: "Puntos bonus", EN: "Bonus points", PT: "Pontos bônus" },
  reward_type_physical_reward: { ES: "Premio físico", EN: "Physical reward", PT: "Prêmio físico" },
  reward_type_no_reward: { ES: "Sin recompensa", EN: "No reward", PT: "Sem recompensa" },
  reward_type_betting_bonus: { ES: "Bono de apuesta", EN: "Betting bonus", PT: "Bônus de aposta" },
  goal_celebration_label: { ES: "{homeFlag} {home} {hs} — {as} {away} {awayFlag}", EN: "{homeFlag} {home} {hs} — {as} {away} {awayFlag}", PT: "{homeFlag} {home} {hs} — {as} {away} {awayFlag}" },
  goal_celebration_shout: { ES: "¡GOOOOL!", EN: "GOOOOAL!", PT: "GOOOOL!" },
  pred_next_goal_2min: { ES: "¿Habrá gol en los próximos 2 minutos?", EN: "Will there be a goal in the next 2 minutes?", PT: "Haverá gol nos próximos 2 minutos?" },
  pred_corner_kick: { ES: "¿Habrá tiro de esquina pronto?", EN: "Will there be a corner soon?", PT: "Haverá escanteio em breve?" },
  pred_yellow_card: { ES: "¿Habrá tarjeta amarilla?", EN: "Will there be a yellow card?", PT: "Haverá cartão amarelo?" },
  pred_shot_on_target: { ES: "¿Habrá remate al arco?", EN: "Will there be a shot on target?", PT: "Haverá chute no gol?" },
  pred_sub_before_70: { ES: "¿Habrá un cambio antes del minuto 70?", EN: "Will there be a sub before minute 70?", PT: "Haverá substituição antes do minuto 70?" },
  pred_var_review: { ES: "¿Habrá revisión del VAR?", EN: "Will there be a VAR review?", PT: "Haverá revisão do VAR?" },
  // Match-aware intro & scheduled chat
  intro_msg_pressing: {
    ES: "¡{home} está presionando alto! El xG acumulado en los últimos 5' alcanza 0.84 — el ataque es real.",
    EN: "{home} is pressing high! Cumulative xG over the last 5' reaches 0.84 — the attack is real.",
    PT: "{home} está pressionando alto! O xG acumulado nos últimos 5' chega a 0.84 — o ataque é real.",
  },
  intro_msg_user_q: {
    ES: "¿Crees que llega el gol?",
    EN: "Do you think the goal is coming?",
    PT: "Você acha que o gol vem?",
  },
  intro_msg_momentum: {
    ES: "El momentum ofensivo es fuerte. Los extremos están encontrando espacios entre líneas.",
    EN: "Offensive momentum is strong. The wingers are finding pockets between the lines.",
    PT: "O momentum ofensivo é forte. Os pontas estão encontrando espaços entre linhas.",
  },
  sched_msg_retreat: {
    ES: "{away} retrocede su línea — espacio entre líneas para {player}.",
    EN: "{away} drops its line — space between the lines for {player}.",
    PT: "{away} recua a linha — espaço entre linhas para {player}.",
  },
  sched_msg_possession: {
    ES: "Posesión {home} 64% en los últimos 3 minutos. Tiro inminente.",
    EN: "{home} possession at 64% over the last 3 minutes. Shot imminent.",
    PT: "Posse de {home} em 64% nos últimos 3 minutos. Chute iminente.",
  },
  sched_msg_hot_zone: {
    ES: "Atención: balón en zona caliente. Remate probable en segundos.",
    EN: "Heads up: ball in the hot zone. Shot likely within seconds.",
    PT: "Atenção: bola em zona quente. Finalização provável em segundos.",
  },
  sched_msg_goal: {
    ES: "¡GOL! Conversión de la oportunidad esperada. xG del disparo: 0.41.",
    EN: "GOAL! Expected chance converted. Shot xG: 0.41.",
    PT: "GOL! Conversão da oportunidade esperada. xG do chute: 0.41.",
  },
  sched_msg_control: {
    ES: "{home} controla el ritmo. {away} necesita reaccionar.",
    EN: "{home} controls the tempo. {away} needs to react.",
    PT: "{home} controla o ritmo. {away} precisa reagir.",
  },
  sched_msg_added_time: {
    ES: "Tiempo añadido inminente, intensidad subiendo.",
    EN: "Added time imminent, intensity rising.",
    PT: "Tempo adicional iminente, intensidade subindo.",
  },
});

// Head-to-Head Intelligence
Object.assign(dict, {
  hub_tab_h2h: { ES: "H2H", EN: "H2H", PT: "H2H" },
  h2h_title: { ES: "Head-to-Head Intelligence", EN: "Head-to-Head Intelligence", PT: "Head-to-Head Intelligence" },
  h2h_loading: { ES: "Cargando historial…", EN: "Loading history…", PT: "Carregando histórico…" },
  h2h_vs: { ES: "vs", EN: "vs", PT: "vs" },
  h2h_refresh: { ES: "Actualizar", EN: "Refresh", PT: "Atualizar" },
  h2h_source: { ES: "Fuente", EN: "Source", PT: "Fonte" },
  h2h_cache_hit_label: { ES: "CACHE", EN: "CACHE", PT: "CACHE" },
  h2h_cache_fresh_label: { ES: "EN VIVO", EN: "FRESH", PT: "AO VIVO" },
  h2h_matches: { ES: "Partidos", EN: "Matches", PT: "Partidas" },
  h2h_avg_goals: { ES: "Goles prom.", EN: "Avg goals", PT: "Gols méd." },
  h2h_btts: { ES: "Ambos anotan", EN: "Both score", PT: "Ambas marcam" },
  h2h_over25: { ES: "Más de 2.5", EN: "Over 2.5", PT: "Mais de 2.5" },
  h2h_draws: { ES: "Empates", EN: "Draws", PT: "Empates" },
  h2h_recent_form: { ES: "Forma reciente", EN: "Recent form", PT: "Forma recente" },
  h2h_no_recent: { ES: "Sin historial reciente", EN: "No recent history", PT: "Sem histórico recente" },
  h2h_dominance: { ES: "Índice de dominio", EN: "Dominance index", PT: "Índice de domínio" },
  h2h_ai_insight: { ES: "Insight de IA", EN: "AI Insight", PT: "Insight da IA" },
  h2h_recent_results: { ES: "Resultados recientes", EN: "Recent results", PT: "Resultados recentes" },
  // Admin
  h2h_admin_title: { ES: "Head-to-Head Intelligence", EN: "Head-to-Head Intelligence", PT: "Head-to-Head Intelligence" },
  h2h_admin_subtitle: {
    ES: "Configura proveedor de datos deportivos, TTL de cache y refresca registros.",
    EN: "Configure sports data provider, cache TTL and refresh records.",
    PT: "Configure provedor de dados, TTL de cache e atualize registros.",
  },
  h2h_admin_enable: { ES: "Activar H2H Intelligence", EN: "Enable H2H Intelligence", PT: "Ativar H2H Intelligence" },
  h2h_admin_provider: { ES: "Proveedor", EN: "Provider", PT: "Provedor" },
  h2h_admin_ttl: { ES: "Cache TTL (horas)", EN: "Cache TTL (hours)", PT: "TTL do cache (horas)" },
  h2h_admin_api_status: { ES: "Estado API", EN: "API status", PT: "Status da API" },
  h2h_admin_api_ready: { ES: "API key configurada", EN: "API key configured", PT: "Chave da API configurada" },
  h2h_admin_api_missing: { ES: "Sin API key (usa Demo)", EN: "No API key (using Demo)", PT: "Sem chave (usando Demo)" },
  h2h_admin_refresh_cache: { ES: "Limpiar cache", EN: "Clear cache", PT: "Limpar cache" },
  h2h_admin_saved: { ES: "Configuración guardada", EN: "Settings saved", PT: "Configurações salvas" },
  h2h_admin_cache_cleared: { ES: "Cache limpiado", EN: "Cache cleared", PT: "Cache limpo" },
});

// Mobile parity / header actions
Object.assign(dict, {
  halftime_hub: { ES: "Halftime Hub", EN: "Halftime Hub", PT: "Halftime Hub" },
  mobile_parity_title: { ES: "Mobile Parity QA", EN: "Mobile Parity QA", PT: "QA de Paridade Mobile" },
  mobile_parity_subtitle: {
    ES: "Verificación automática de paridad móvil vs desktop",
    EN: "Automated mobile-vs-desktop parity verification",
    PT: "Verificação automática de paridade mobile vs desktop",
  },
  mobile_parity_score: { ES: "Parity Score", EN: "Parity Score", PT: "Parity Score" },
  mobile_parity_blockers: { ES: "Bloqueadores críticos", EN: "Critical blockers", PT: "Bloqueadores críticos" },
  mobile_parity_missing: { ES: "Funciones faltantes", EN: "Missing features", PT: "Recursos ausentes" },
  mobile_parity_present: { ES: "Presente", EN: "Present", PT: "Presente" },
  mobile_parity_absent: { ES: "Ausente", EN: "Missing", PT: "Ausente" },
  mobile_parity_run: { ES: "Ejecutar verificación", EN: "Run verification", PT: "Executar verificação" },
  mobile_parity_verified: { ES: "Verificación completada", EN: "Verification completed", PT: "Verificação concluída" },
});

// Security Threat Center
Object.assign(dict, {
  stc_title: { ES: "Centro de Amenazas", EN: "Security Threat Center", PT: "Centro de Ameaças" },
  stc_subtitle: {
    ES: "MONITOREO · HONEYTOKEN · RESPUESTA",
    EN: "MONITORING · HONEYTOKEN · RESPONSE",
    PT: "MONITORAMENTO · HONEYTOKEN · RESPOSTA",
  },
  stc_active_alerts: { ES: "Alertas activas", EN: "Active alerts", PT: "Alertas ativos" },
  stc_max_risk: { ES: "Riesgo máximo", EN: "Max risk", PT: "Risco máximo" },
  stc_total_24h: { ES: "Total recientes", EN: "Recent total", PT: "Total recente" },
  stc_loading: { ES: "Cargando alertas…", EN: "Loading alerts…", PT: "Carregando alertas…" },
  stc_empty: {
    ES: "Sin alertas. Sistema seguro.",
    EN: "No alerts. System secure.",
    PT: "Sem alertas. Sistema seguro.",
  },
  stc_risk: { ES: "Riesgo", EN: "Risk", PT: "Risco" },
  stc_suspend: { ES: "Suspender usuario", EN: "Suspend user", PT: "Suspender usuário" },
  stc_revoke: { ES: "Revocar sesiones", EN: "Revoke sessions", PT: "Revogar sessões" },
  stc_killswitch: { ES: "Kill Switch", EN: "Kill Switch", PT: "Kill Switch" },
  stc_reviewed: { ES: "Marcar revisado", EN: "Mark reviewed", PT: "Marcar revisado" },
  stc_kill_on: { ES: "Kill Switch ACTIVO", EN: "Kill Switch ACTIVE", PT: "Kill Switch ATIVO" },
  stc_kill_off: { ES: "Activar Kill Switch", EN: "Activate Kill Switch", PT: "Ativar Kill Switch" },
  stc_simulate: { ES: "Probar honeytoken", EN: "Probe honeytoken", PT: "Testar honeytoken" },
  stc_user_suspended: {
    ES: "Usuario marcado para suspensión.",
    EN: "User flagged for suspension.",
    PT: "Usuário marcado para suspensão.",
  },
  stc_sessions_revoked: {
    ES: "Sesiones revocadas.",
    EN: "Sessions revoked.",
    PT: "Sessões revogadas.",
  },
});

Object.assign(dict, {
  // Executive Intelligence Command Center
  eic_title: {
    ES: "AI Executive Intelligence",
    EN: "AI Executive Intelligence",
    PT: "AI Executive Intelligence",
  },
  eic_subtitle: {
    ES: "CONSULTA · REVENUE · MONETIZACIÓN",
    EN: "QUERY · REVENUE · MONETIZATION",
    PT: "CONSULTA · RECEITA · MONETIZAÇÃO",
  },
  eic_dataset_size: {
    ES: "{n} eventos analizados",
    EN: "{n} events analyzed",
    PT: "{n} eventos analisados",
  },
  eic_tab_chat: { ES: "Chat ejecutivo", EN: "Executive chat", PT: "Chat executivo" },
  eic_tab_kpis: { ES: "KPIs", EN: "KPIs", PT: "KPIs" },
  eic_tab_revenue: { ES: "Revenue", EN: "Revenue", PT: "Receita" },
  eic_tab_audience: { ES: "Audiencia", EN: "Audience", PT: "Audiência" },
  eic_tab_sponsors: { ES: "Patrocinios", EN: "Sponsors", PT: "Patrocínios" },
  eic_tab_reports: { ES: "Reportes", EN: "Reports", PT: "Relatórios" },
  eic_tab_opps: { ES: "Oportunidades", EN: "Opportunities", PT: "Oportunidades" },
  eic_chat_greeting: {
    ES: "Pregúntame por KPIs, ingresos, audiencia o pide un informe.",
    EN: "Ask me about KPIs, revenue, audience, or request a report.",
    PT: "Pergunte sobre KPIs, receita, audiência ou peça um relatório.",
  },
  eic_chat_placeholder: {
    ES: "Ej.: ¿Cuántos usuarios se registraron hoy?",
    EN: "E.g. How many users registered today?",
    PT: "Ex.: Quantos usuários se registraram hoje?",
  },
  eic_send: { ES: "Enviar", EN: "Send", PT: "Enviar" },
  eic_thinking: {
    ES: "Analizando datos…",
    EN: "Analyzing data…",
    PT: "Analisando dados…",
  },
  eic_err_rate: {
    ES: "Demasiadas solicitudes. Intenta de nuevo en un momento.",
    EN: "Too many requests. Please retry shortly.",
    PT: "Muitas requisições. Tente novamente em instantes.",
  },
  eic_err_credits: {
    ES: "Créditos AI agotados. Recarga el workspace.",
    EN: "AI credits exhausted. Top up the workspace.",
    PT: "Créditos AI esgotados. Recarregue o workspace.",
  },
  eic_err_generic: {
    ES: "No pude generar la respuesta.",
    EN: "Couldn't generate the answer.",
    PT: "Não foi possível gerar a resposta.",
  },
  eic_kpi_today: { ES: "Hoy", EN: "Today", PT: "Hoje" },
  eic_kpi_sessions: { ES: "Sesiones", EN: "Sessions", PT: "Sessões" },
  eic_kpi_votes: { ES: "Votos", EN: "Votes", PT: "Votos" },
  eic_kpi_chat: { ES: "Mensajes IA", EN: "AI messages", PT: "Mensagens IA" },
  eic_kpi_surveys: { ES: "Encuestas", EN: "Surveys", PT: "Pesquisas" },
  eic_kpi_rewards: { ES: "Recompensas", EN: "Rewards", PT: "Recompensas" },
  eic_kpi_shares: { ES: "Compartidos", EN: "Shares", PT: "Compartilhamentos" },
  eic_kpi_installs: { ES: "Instalaciones", EN: "Installs", PT: "Instalações" },
  eic_rev_ads: { ES: "Ingresos ads (est.)", EN: "Ad revenue (est.)", PT: "Receita ads (est.)" },
  eic_rev_sponsored: {
    ES: "Ingresos patrocinados (est.)",
    EN: "Sponsored revenue (est.)",
    PT: "Receita patrocinada (est.)",
  },
  eic_rev_total: { ES: "Total estimado", EN: "Total estimated", PT: "Total estimado" },
  eic_rev_disclaimer: {
    ES: "Estimaciones agregadas a partir de telemetría anonimizada.",
    EN: "Aggregated estimates from anonymized telemetry.",
    PT: "Estimativas agregadas de telemetria anonimizada.",
  },
  eic_audience_top_events: {
    ES: "Eventos principales",
    EN: "Top events",
    PT: "Principais eventos",
  },
  eic_sponsors_hint: {
    ES: "Métricas agregadas de campañas patrocinadas.",
    EN: "Aggregated metrics for sponsored campaigns.",
    PT: "Métricas agregadas de campanhas patrocinadas.",
  },
  eic_sponsor_surveys: { ES: "Respuestas encuestas", EN: "Survey responses", PT: "Respostas pesquisas" },
  eic_sponsor_rewards: { ES: "Recompensas activas", EN: "Active rewards", PT: "Recompensas ativas" },
  eic_sponsor_engagement: { ES: "Engagement total", EN: "Total engagement", PT: "Engajamento total" },
  eic_tpl_daily: {
    ES: "Resumen ejecutivo diario",
    EN: "Daily executive summary",
    PT: "Resumo executivo diário",
  },
  eic_tpl_sponsor: {
    ES: "Desempeño de patrocinadores",
    EN: "Sponsor performance report",
    PT: "Desempenho de patrocinadores",
  },
  eic_tpl_audience: {
    ES: "Inteligencia de audiencia",
    EN: "Audience intelligence",
    PT: "Inteligência de audiência",
  },
  eic_tpl_revenue: {
    ES: "Pronóstico de ingresos",
    EN: "Revenue forecast",
    PT: "Previsão de receita",
  },
  eic_tpl_monet: {
    ES: "Oportunidades de monetización",
    EN: "Monetization opportunities",
    PT: "Oportunidades de monetização",
  },
  eic_report_summary_intro: {
    ES: "Resumen ejecutivo basado en telemetría agregada de la plataforma.",
    EN: "Executive summary based on aggregated platform telemetry.",
    PT: "Resumo executivo baseado em telemetria agregada da plataforma.",
  },
  eic_insight_high_vote: {
    ES: "Engagement de votación por encima del benchmark.",
    EN: "Voting engagement above benchmark.",
    PT: "Engajamento de votação acima do benchmark.",
  },
  eic_insight_chat_active: {
    ES: "Conversaciones IA activas — oportunidad premium.",
    EN: "Active AI conversations — premium opportunity.",
    PT: "Conversas IA ativas — oportunidade premium.",
  },
  eic_insight_survey_signal: {
    ES: "Encuestas patrocinadas con señal positiva.",
    EN: "Sponsored surveys showing positive signal.",
    PT: "Pesquisas patrocinadas com sinal positivo.",
  },
  eic_insight_baseline: {
    ES: "Métricas dentro del rango esperado.",
    EN: "Metrics within expected range.",
    PT: "Métricas dentro do intervalo esperado.",
  },
  eic_rec_sponsor_upsell: {
    ES: "Activar upsell de inventario premium con marcas top.",
    EN: "Activate premium inventory upsell with top brands.",
    PT: "Ative upsell de inventário premium com marcas top.",
  },
  eic_rec_geo_targeting: {
    ES: "Segmentar campañas por ciudades de mayor conversión.",
    EN: "Segment campaigns by highest-converting cities.",
    PT: "Segmente campanhas pelas cidades de maior conversão.",
  },
  eic_rec_premium_chat: {
    ES: "Promover plan Pro a usuarios con alto uso de IA.",
    EN: "Promote Pro plan to high AI-usage users.",
    PT: "Promova plano Pro para usuários com alto uso de IA.",
  },
  eic_opp_upsell_title: {
    ES: "Upsell premium",
    EN: "Premium upsell",
    PT: "Upsell premium",
  },
  eic_opp_upsell_desc: {
    ES: "Convertir usuarios free de alto engagement a Pro.",
    EN: "Convert high-engagement free users to Pro.",
    PT: "Converter usuários free de alto engajamento para Pro.",
  },
  eic_opp_geo_title: {
    ES: "Geo-targeting de patrocinios",
    EN: "Sponsorship geo-targeting",
    PT: "Geo-targeting de patrocínios",
  },
  eic_opp_geo_desc: {
    ES: "Activar campañas locales en ciudades top.",
    EN: "Activate local campaigns in top cities.",
    PT: "Ative campanhas locais nas cidades top.",
  },
  eic_opp_brand_title: {
    ES: "Bundle de marcas",
    EN: "Brand bundle",
    PT: "Bundle de marcas",
  },
  eic_opp_brand_desc: {
    ES: "Empaquetar surveys + recompensas para sponsors top.",
    EN: "Bundle surveys + rewards for top sponsors.",
    PT: "Empacotar pesquisas + recompensas para sponsors top.",
  },
  eic_opp_impact: { ES: "Impacto", EN: "Impact", PT: "Impacto" },
});

const KEY = "ss2026:lang";

// FASE 2 — Role-separated auth UX (added strings translated for runtime i18n).
Object.assign(dict, {
  fan_badge_personal: {
    ES: "Fan · Cuenta personal",
    EN: "Fan · Personal account",
    PT: "Fã · Conta pessoal",
  },
  reg_fan_title: { ES: "Crear cuenta Fan", EN: "Create Fan account", PT: "Criar conta Fã" },
  reg_fan_sub: {
    ES: "Experiencia pública VerseSport: predicciones, recompensas y segunda pantalla en vivo.",
    EN: "Public VerseSport experience: predictions, rewards and live second screen.",
    PT: "Experiência pública VerseSport: previsões, recompensas e segunda tela ao vivo.",
  },
  reg_corporate_prompt: {
    ES: "¿Buscas acceso corporativo?",
    EN: "Looking for corporate access?",
    PT: "Procurando acesso corporativo?",
  },
  reg_corporate_link: {
    ES: "Solicita acceso enterprise aquí",
    EN: "Request enterprise access here",
    PT: "Solicite acesso enterprise aqui",
  },
  login_corporate_prompt: {
    ES: "¿Eres partner corporativo?",
    EN: "Are you a corporate partner?",
    PT: "Você é parceiro corporativo?",
  },
  login_corporate_portal: {
    ES: "Portal Corporativo",
    EN: "Corporate Portal",
    PT: "Portal Corporativo",
  },
  login_corporate_request: {
    ES: "Solicitar acceso enterprise",
    EN: "Request enterprise access",
    PT: "Solicitar acesso enterprise",
  },
  welcome_corporate_link: {
    ES: "Acceso Corporativo · Enterprise",
    EN: "Corporate Access · Enterprise",
    PT: "Acesso Corporativo · Enterprise",
  },
  welcome_corporate_sub: {
    ES: "¿Eres broadcaster, marca o sponsor? Solicita acceso enterprise.",
    EN: "Are you a broadcaster, brand or sponsor? Request enterprise access.",
    PT: "É broadcaster, marca ou sponsor? Solicite acesso enterprise.",
  },
});

export function getStoredLang(): Lang {
  if (typeof window === "undefined") return "ES";
  const v = window.localStorage.getItem(KEY) as Lang | null;
  return v && LANGS.includes(v) ? v : "ES";
}

export function setStoredLang(l: Lang) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, l);
  window.dispatchEvent(new CustomEvent("ss2026:lang", { detail: l }));
}

function interpolate(s: string, params?: Record<string, string | number>): string {
  if (!params) return s;
  return s.replace(/\{(\w+)\}/g, (_, k) => (params[k] != null ? String(params[k]) : `{${k}}`));
}

export function t(
  key: keyof typeof dict | string,
  lang: Lang,
  params?: Record<string, string | number>,
): string {
  const entry = dict[key as string];
  if (!entry) {
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("ss2026:i18n-fallback", { detail: { key: String(key), lang } }),
      );
      window.dispatchEvent(
        new CustomEvent("ss2026:i18n-missing", { detail: { key: String(key), lang } }),
      );
    }
    return interpolate(String(key), params);
  }
  const value = entry[lang];
  if (value) return interpolate(value, params);
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("ss2026:i18n-fallback", { detail: { key: String(key), lang } }),
    );
  }
  // Phase 3 — Fallback discipline: prefer ES when target lang missing, never auto-EN.
  return interpolate(entry.ES ?? entry.EN ?? String(key), params);
}

Object.assign(dict, {
  auth_password_label: {
    ES: "Contraseña (mínimo 6)",
    EN: "Password (minimum 6)",
    PT: "Senha (mínimo 6)",
  },
  auth_password_confirm_label: {
    ES: "Confirmar contraseña",
    EN: "Confirm password",
    PT: "Confirmar senha",
  },
  auth_password_new: {
    ES: "Nueva contraseña",
    EN: "New password",
    PT: "Nova senha",
  },
  auth_password_min: {
    ES: "Mínimo 6 caracteres",
    EN: "Minimum 6 characters",
    PT: "Mínimo 6 caracteres",
  },
  auth_passwords_no_match: {
    ES: "Las contraseñas no coinciden",
    EN: "Passwords do not match",
    PT: "As senhas não coincidem",
  },
  auth_password_updated: {
    ES: "Contraseña actualizada",
    EN: "Password updated",
    PT: "Senha atualizada",
  },
});

Object.assign(dict, {
  // Drill-down generic
  dd_close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  dd_metrics: { ES: "Métricas de respaldo", EN: "Supporting metrics", PT: "Métricas de apoio" },
  dd_recommendations: { ES: "Recomendaciones", EN: "Recommendations", PT: "Recomendações" },
  dd_actions: { ES: "Acciones sugeridas", EN: "Suggested actions", PT: "Ações sugeridas" },
  dd_source_data: { ES: "Datos fuente", EN: "Source data", PT: "Dados de origem" },
  dd_estimated_impact: { ES: "Impacto estimado", EN: "Estimated impact", PT: "Impacto estimado" },
  dd_execute_action: { ES: "Ejecutar acción", EN: "Execute action", PT: "Executar ação" },
  dd_create_campaign: { ES: "Crear campaña", EN: "Create campaign", PT: "Criar campanha" },
  dd_generate_report: { ES: "Generar reporte", EN: "Generate report", PT: "Gerar relatório" },
  dd_add_to_proposal: { ES: "Añadir a propuesta", EN: "Add to proposal", PT: "Adicionar à proposta" },
  dd_open_panel: { ES: "Abrir panel", EN: "Open panel", PT: "Abrir painel" },
  dd_export_csv: { ES: "Exportar CSV", EN: "Export CSV", PT: "Exportar CSV" },
  dd_export_pdf: { ES: "Exportar PDF", EN: "Export PDF", PT: "Exportar PDF" },
  dd_action_done: { ES: "Acción ejecutada", EN: "Action executed", PT: "Ação executada" },
  dd_navigated: { ES: "Navegando al módulo", EN: "Navigating to module", PT: "Navegando ao módulo" },

  // Readiness drill-down
  rd_score_title: { ES: "Detalle del Score Global", EN: "Global Score Breakdown", PT: "Detalhe do Score Global" },
  rd_score_sub: { ES: "Promedio ponderado de las 10 categorías de readiness.", EN: "Weighted average of the 10 readiness categories.", PT: "Média ponderada das 10 categorias de readiness." },
  rd_status_title: { ES: "Aprobación de Lanzamiento", EN: "Launch Approval", PT: "Aprovação de Lançamento" },
  rd_status_sub: { ES: "GO / HOLD basado en blockers críticos.", EN: "GO / HOLD based on critical blockers.", PT: "GO / HOLD com base em bloqueadores críticos." },
  rd_blockers_title: { ES: "Bloqueadores priorizados", EN: "Priority Blockers", PT: "Bloqueadores priorizados" },
  rd_category_title: { ES: "Detalle de categoría", EN: "Category breakdown", PT: "Detalhe da categoria" },
  rd_no_blockers: { ES: "No hay bloqueadores activos.", EN: "No active blockers.", PT: "Sem bloqueadores ativos." },
  rd_corrective: { ES: "Asignar al equipo responsable", EN: "Assign to owning team", PT: "Atribuir à equipa responsável" },
  rd_approve_go: { ES: "Aprobar GO", EN: "Approve GO", PT: "Aprovar GO" },
  rd_hold: { ES: "Mantener en HOLD", EN: "Keep on HOLD", PT: "Manter em HOLD" },

  // Executive Narrative drill-down
  en_detail_title: { ES: "Insight Ejecutivo", EN: "Executive Insight", PT: "Insight Executivo" },
  en_detail_sub: { ES: "Análisis, métricas de respaldo y acciones sugeridas.", EN: "Analysis, supporting metrics and suggested actions.", PT: "Análise, métricas de apoio e ações sugeridas." },
  en_metric_audience: { ES: "Audiencia activa", EN: "Active audience", PT: "Audiência ativa" },
  en_metric_intent: { ES: "Intención de compra", EN: "Purchase intent", PT: "Intenção de compra" },
  en_metric_arpu: { ES: "ARPU proyectado", EN: "Projected ARPU", PT: "ARPU projetado" },
  en_rec_1: { ES: "Activar inventario premium regional en las próximas 24h.", EN: "Activate regional premium inventory in the next 24h.", PT: "Ativar inventário premium regional nas próximas 24h." },
  en_rec_2: { ES: "Lanzar campaña dirigida a la audiencia identificada.", EN: "Launch campaign targeted to the identified audience.", PT: "Lançar campanha dirigida à audiência identificada." },
  en_rec_3: { ES: "Compartir insight con el sponsor más relevante.", EN: "Share insight with the most relevant sponsor.", PT: "Compartilhar insight com o patrocinador mais relevante." },

  // Business alert drill-down
  ba_detail_title: { ES: "Detalle de alerta", EN: "Alert detail", PT: "Detalhe do alerta" },
  ba_impact_high: { ES: "Impacto: ALTO", EN: "Impact: HIGH", PT: "Impacto: ALTO" },
  ba_impact_med: { ES: "Impacto: MEDIO", EN: "Impact: MEDIUM", PT: "Impacto: MÉDIO" },
  ba_impact_low: { ES: "Impacto: BAJO", EN: "Impact: LOW", PT: "Impacto: BAIXO" },
  ba_action_run: { ES: "Ejecutar ahora", EN: "Run now", PT: "Executar agora" },

  // KPI drill-down
  kpi_drill_title: { ES: "Detalle de KPI", EN: "KPI breakdown", PT: "Detalhe do KPI" },
  kpi_drill_trend: { ES: "Tendencia (últimos eventos)", EN: "Trend (recent events)", PT: "Tendência (eventos recentes)" },
  kpi_drill_filter: { ES: "Filtros disponibles próximamente", EN: "Filters coming soon", PT: "Filtros em breve" },
});

Object.assign(dict, {
  // Help / global help center
  help_btn: { ES: "Ayuda", EN: "Help", PT: "Ajuda" },
  help_title: { ES: "Centro de Ayuda", EN: "Help Center", PT: "Central de Ajuda" },
  help_tab_about: { ES: "Acerca de", EN: "About", PT: "Sobre" },
  help_tab_modules: { ES: "Módulos", EN: "Modules", PT: "Módulos" },
  help_tab_glossary: { ES: "Glosario", EN: "Glossary", PT: "Glossário" },
  help_tab_faq: { ES: "Preguntas frecuentes", EN: "FAQs", PT: "Perguntas frequentes" },
  help_tab_rewards: { ES: "Puntos y recompensas", EN: "Points & rewards", PT: "Pontos e recompensas" },
  help_tab_privacy: { ES: "Privacidad", EN: "Privacy", PT: "Privacidade" },
  help_about_body: {
    ES: "VerseSport™ es la experiencia premium de segunda pantalla para el Mundial 2026: radar 3D táctico, IA en vivo, predicciones, recompensas y más.",
    EN: "VerseSport™ is the premium second-screen experience for the 2026 World Cup: tactical 3D radar, live AI, predictions, rewards and more.",
    PT: "VerseSport™ é a experiência premium de segunda tela para a Copa de 2026: radar 3D tático, IA ao vivo, previsões, recompensas e muito mais.",
  },
  help_module_live: { ES: "Live Tracker — sigue cada acción del partido en 3D.", EN: "Live Tracker — follow every action of the match in 3D.", PT: "Live Tracker — acompanhe cada ação do jogo em 3D." },
  help_module_chat: { ES: "Community Chat — conversa con otros aficionados.", EN: "Community Chat — talk with other fans.", PT: "Chat da Comunidade — converse com outros torcedores." },
  help_module_ai: { ES: "Match AI — pregunta lo que quieras del partido.", EN: "Match AI — ask anything about the match.", PT: "Match AI — pergunte qualquer coisa sobre a partida." },
  help_module_stats: { ES: "Advanced Stats — estadísticas avanzadas en tiempo real.", EN: "Advanced Stats — real-time advanced metrics.", PT: "Advanced Stats — métricas avançadas em tempo real." },
  help_module_halftime: { ES: "Halftime Hub — juegos, retos y recompensas.", EN: "Halftime Hub — games, challenges and rewards.", PT: "Halftime Hub — jogos, desafios e recompensas." },
  help_module_rewards: { ES: "Rewards — canjea puntos por premios reales.", EN: "Rewards — redeem points for real prizes.", PT: "Rewards — troque pontos por prêmios reais." },
  help_module_oracle: { ES: "Global Oracle — asistente premium de fútbol mundial.", EN: "Global Oracle — premium worldwide football assistant.", PT: "Global Oracle — assistente premium do futebol mundial." },
  help_glossary_h2h: { ES: "H2H · Head-to-Head — historial entre los dos equipos.", EN: "H2H · Head-to-Head — history between both teams.", PT: "H2H · Head-to-Head — histórico entre os dois times." },
  help_glossary_highlights: { ES: "Highlights — jugadas destacadas del partido.", EN: "Highlights — key plays of the match.", PT: "Highlights — melhores momentos da partida." },
  help_glossary_stats: { ES: "Stats — estadísticas avanzadas (xG, posesión, presión).", EN: "Stats — advanced metrics (xG, possession, pressing).", PT: "Stats — métricas avançadas (xG, posse, pressão)." },
  help_glossary_match_ai: { ES: "Match AI — IA enfocada en el partido en vivo.", EN: "Match AI — AI focused on the live match.", PT: "Match AI — IA focada na partida ao vivo." },
  help_glossary_oracle: { ES: "Global Oracle — IA premium de fútbol mundial.", EN: "Global Oracle — premium worldwide football AI.", PT: "Global Oracle — IA premium de futebol mundial." },
  help_glossary_halftime: { ES: "Halftime Hub — centro interactivo del descanso.", EN: "Halftime Hub — interactive halftime center.", PT: "Halftime Hub — centro interativo do intervalo." },
  help_faq_q1: { ES: "¿Cómo gano puntos?", EN: "How do I earn points?", PT: "Como ganho pontos?" },
  help_faq_a1: { ES: "Participando en chats, predicciones, retos y juegos del Halftime Hub.", EN: "By chatting, predicting, completing challenges and Halftime games.", PT: "Participando dos chats, previsões, desafios e jogos do Halftime Hub." },
  help_faq_q2: { ES: "¿Necesito registrarme?", EN: "Do I need to register?", PT: "Preciso me registrar?" },
  help_faq_a2: { ES: "No es obligatorio, pero el registro desbloquea recompensas y personalización.", EN: "Not required, but registering unlocks rewards and personalization.", PT: "Não é obrigatório, mas o registro libera recompensas e personalização." },
  help_privacy_body: {
    ES: "Recopilamos solo datos necesarios para personalizar tu experiencia. Puedes controlar tus consentimientos en cualquier momento.",
    EN: "We only collect data needed to personalize your experience. You can manage your consents at any time.",
    PT: "Coletamos apenas os dados necessários para personalizar sua experiência. Você pode gerenciar seus consentimentos a qualquer momento.",
  },

  // Halftime FAB
  halftime_fab: { ES: "Halftime Hub", EN: "Halftime Hub", PT: "Halftime Hub" },

  // Welcome dashboard
  welcome_eyebrow: { ES: "Bienvenido a VerseSport™", EN: "Welcome to VerseSport™", PT: "Bem-vindo ao VerseSport™" },
  welcome_title: { ES: "PREDICE la próxima jugada del Mundial 2026", EN: "PREDICT the next play of the 2026 World Cup", PT: "PREVEJA a próxima jogada da Copa de 2026" },
  welcome_sub: {
    ES: "Radar 3D táctico, IA en vivo, predicciones, recompensas y comunidad global. Todo en un solo lugar.",
    EN: "Tactical 3D radar, live AI, predictions, rewards and global community. All in one place.",
    PT: "Radar 3D tático, IA ao vivo, previsões, recompensas e comunidade global. Tudo num só lugar.",
  },
  welcome_cta_register: { ES: "Registrarme", EN: "Register", PT: "Cadastrar-me" },
  welcome_cta_guest: { ES: "Continuar como invitado", EN: "Continue as guest", PT: "Continuar como convidado" },
  welcome_cta_demo: { ES: "Ver demo", EN: "Watch demo", PT: "Ver demo" },
  welcome_benefit_1_title: { ES: "Radar 3D en vivo", EN: "Live 3D radar", PT: "Radar 3D ao vivo" },
  welcome_benefit_1_body: { ES: "Sigue cada jugada con visión táctica profesional.", EN: "Follow every play with pro tactical vision.", PT: "Acompanhe cada jogada com visão tática profissional." },
  welcome_benefit_2_title: { ES: "Match AI contextual", EN: "Contextual Match AI", PT: "Match AI contextual" },
  welcome_benefit_2_body: { ES: "Pregunta cualquier cosa del partido y recibe análisis al instante.", EN: "Ask anything about the match and get instant analysis.", PT: "Pergunte qualquer coisa da partida e receba análise instantânea." },
  welcome_benefit_3_title: { ES: "Match Insights", EN: "Match Insights", PT: "Match Insights" },
  welcome_benefit_3_body: { ES: "Tactical signals, fan pulse y live intelligence en tiempo real.", EN: "Tactical signals, fan pulse and live intelligence in real time.", PT: "Sinais táticos, fan pulse e live intelligence em tempo real." },

  // Registration
  reg_title: { ES: "Crear cuenta", EN: "Create account", PT: "Criar conta" },
  reg_sub: { ES: "Personaliza tu experiencia y desbloquea recompensas.", EN: "Personalize your experience and unlock rewards.", PT: "Personalize sua experiência e libere recompensas." },
  reg_full_name: { ES: "Nombre completo", EN: "Full name", PT: "Nome completo" },
  reg_email: { ES: "Email", EN: "Email", PT: "E-mail" },
  reg_country: { ES: "País", EN: "Country", PT: "País" },
  reg_city: { ES: "Ciudad", EN: "City", PT: "Cidade" },
  reg_language: { ES: "Idioma", EN: "Language", PT: "Idioma" },
  reg_favorite_team: { ES: "Equipo favorito", EN: "Favorite team", PT: "Time favorito" },
  reg_favorite_players: { ES: "Jugadores favoritos (separados por coma)", EN: "Favorite players (comma-separated)", PT: "Jogadores favoritos (separados por vírgula)" },
  reg_dob: { ES: "Fecha de nacimiento (opcional)", EN: "Date of birth (optional)", PT: "Data de nascimento (opcional)" },
  reg_gender: { ES: "Género (opcional)", EN: "Gender (optional)", PT: "Gênero (opcional)" },
  reg_interests: { ES: "Intereses", EN: "Interests", PT: "Interesses" },
  reg_int_beverages: { ES: "Bebidas", EN: "Beverages", PT: "Bebidas" },
  reg_int_betting: { ES: "Apuestas deportivas", EN: "Sports betting", PT: "Apostas esportivas" },
  reg_int_travel: { ES: "Viajes", EN: "Travel", PT: "Viagens" },
  reg_int_fastfood: { ES: "Comida rápida", EN: "Fast food", PT: "Fast food" },
  reg_int_electronics: { ES: "Electrónicos", EN: "Electronics", PT: "Eletrônicos" },
  reg_int_banking: { ES: "Banca", EN: "Banking", PT: "Bancos" },
  reg_marketing_opt: { ES: "Quiero recibir promociones y novedades", EN: "I want to receive promotions and updates", PT: "Quero receber promoções e novidades" },
  reg_analytics_opt: { ES: "Permito el uso de analítica anónima para mejorar la experiencia", EN: "Allow anonymous analytics to improve the experience", PT: "Permitir analítica anônima para melhorar a experiência" },
  reg_terms_opt: { ES: "Acepto los Términos y la Política de Privacidad", EN: "I accept the Terms and Privacy Policy", PT: "Aceito os Termos e a Política de Privacidade" },
  reg_submit: { ES: "Crear cuenta", EN: "Create account", PT: "Criar conta" },
  reg_success: { ES: "¡Cuenta creada! Bienvenido.", EN: "Account created! Welcome.", PT: "Conta criada! Bem-vindo." },
  reg_error: { ES: "No pudimos guardar tu registro. Intenta de nuevo.", EN: "We couldn't save your registration. Please try again.", PT: "Não foi possível salvar seu cadastro. Tente novamente." },
  reg_required: { ES: "Campo obligatorio", EN: "Required", PT: "Obrigatório" },
  reg_invalid_email: { ES: "Email inválido", EN: "Invalid email", PT: "E-mail inválido" },
  reg_must_accept: { ES: "Debes aceptar los términos", EN: "You must accept the terms", PT: "Você precisa aceitar os termos" },
  legal_terms_link: { ES: "Términos", EN: "Terms", PT: "Termos" },
  legal_privacy_link: { ES: "Privacidad", EN: "Privacy", PT: "Privacidade" },
  btn_login: { ES: "Iniciar Sesión", EN: "Login", PT: "Entrar" },
  btn_logout: { ES: "Cerrar sesión", EN: "Log out", PT: "Sair" },
  btn_signup_free: { ES: "Registrarse Gratis", EN: "Sign Up Free", PT: "Criar Conta Grátis" },
  login_title: { ES: "Iniciar Sesión", EN: "Log In", PT: "Entrar" },
  login_sub: { ES: "Accede a tu cuenta para desbloquear todas las funciones.", EN: "Access your account to unlock all features.", PT: "Acesse sua conta para desbloquear todos os recursos." },
  login_email: { ES: "Email", EN: "Email", PT: "E-mail" },
  login_submit: { ES: "Ingresar", EN: "Sign In", PT: "Entrar" },
  login_success: { ES: "¡Bienvenido de vuelta!", EN: "Welcome back!", PT: "Bem-vindo de volta!" },
  login_error: { ES: "Ocurrió un error. Intenta de nuevo.", EN: "Something went wrong. Please try again.", PT: "Algo deu errado. Tente novamente." },
  login_not_found: { ES: "No encontramos una cuenta con ese email. Regístrate gratis.", EN: "We couldn't find an account with that email. Sign up for free.", PT: "Não encontramos uma conta com esse e-mail. Cadastre-se gratuitamente." },
});

Object.assign(dict, {
  // Term tooltips (H2H, Highlights, Stats, Match AI, Global Oracle, Halftime, Rewards)
  term_help_aria: { ES: "Más información", EN: "More info", PT: "Mais informações" },
  term_h2h_label: { ES: "H2H", EN: "H2H", PT: "H2H" },
  term_h2h_desc: {
    ES: "Head-to-Head. Historial de enfrentamientos entre ambos equipos.",
    EN: "Head-to-Head. History of past meetings between both teams.",
    PT: "Head-to-Head. Histórico de confrontos entre as duas equipes.",
  },
  term_highlights_label: { ES: "Highlights", EN: "Highlights", PT: "Highlights" },
  term_highlights_desc: {
    ES: "Jugadas y momentos más importantes del partido.",
    EN: "Most important plays and moments of the match.",
    PT: "Jogadas e momentos mais importantes da partida.",
  },
  term_stats_label: { ES: "Stats", EN: "Stats", PT: "Stats" },
  term_stats_desc: {
    ES: "Estadísticas avanzadas del encuentro.",
    EN: "Advanced match statistics.",
    PT: "Estatísticas avançadas da partida.",
  },
  term_match_ai_label: { ES: "Match AI", EN: "Match AI", PT: "Match AI" },
  term_match_ai_desc: {
    ES: "Análisis inteligente enfocado en el partido actual.",
    EN: "Intelligent analysis focused on the current match.",
    PT: "Análise inteligente focada na partida atual.",
  },
  term_global_oracle_label: { ES: "Global Oracle", EN: "Global Oracle", PT: "Global Oracle" },
  term_global_oracle_desc: {
    ES: "Asistente premium para consultas generales sobre fútbol mundial.",
    EN: "Premium assistant for general questions about world football.",
    PT: "Assistente premium para consultas gerais sobre futebol mundial.",
  },
  term_halftime_label: { ES: "Halftime Hub", EN: "Halftime Hub", PT: "Halftime Hub" },
  term_halftime_desc: {
    ES: "Centro interactivo con juegos, encuestas, recompensas y análisis.",
    EN: "Interactive hub with games, polls, rewards and analysis.",
    PT: "Hub interativo com jogos, enquetes, recompensas e análises.",
  },
  term_rewards_label: { ES: "Rewards", EN: "Rewards", PT: "Recompensas" },
  term_rewards_desc: {
    ES: "Puntos, cupones y premios obtenidos.",
    EN: "Points, coupons and prizes earned.",
    PT: "Pontos, cupons e prêmios obtidos.",
  },

  // Team Identity Bar expansion
  pitch_formation: { ES: "Formación", EN: "Formation", PT: "Formação" },
  pitch_top_performer: { ES: "Top performer", EN: "Top performer", PT: "Destaque" },
  pitch_minute: { ES: "min", EN: "min", PT: "min" },
});

// PR — Critical UX iteration: tooltips, back button, mobile toolbar, polls,
// halftime AI, goal clean mode, favorite match, language dropdown.
Object.assign(dict, {
  // Extended terminology tooltips
  term_heat_map_label: { ES: "Mapa de calor", EN: "Heat map", PT: "Mapa de calor" },
  term_heat_map_desc: {
    ES: "Muestra las zonas del campo donde se concentra la actividad.",
    EN: "Shows where most on-field action is occurring.",
    PT: "Mostra onde a atividade do jogo está mais concentrada.",
  },
  term_xg_label: { ES: "xG", EN: "xG", PT: "xG" },
  term_xg_desc: {
    ES: "Goles esperados: probabilidad de que un disparo termine en gol.",
    EN: "Expected goals: probability that a shot results in a goal.",
    PT: "Gols esperados: probabilidade de um chute resultar em gol.",
  },
  term_pressure_label: { ES: "Presión", EN: "Pressure", PT: "Pressão" },
  term_pressure_desc: {
    ES: "Intensidad con la que un equipo presiona al rival.",
    EN: "Intensity with which a team pressures the opponent.",
    PT: "Intensidade com que uma equipe pressiona o adversário.",
  },
  term_fatigue_label: { ES: "Fatiga", EN: "Fatigue", PT: "Fadiga" },
  term_fatigue_desc: {
    ES: "Nivel de cansancio acumulado por jugadores y equipos.",
    EN: "Accumulated fatigue level for players and teams.",
    PT: "Nível de cansaço acumulado por jogadores e equipes.",
  },
  term_odds_label: { ES: "Cuotas", EN: "Odds", PT: "Cotações" },
  term_odds_desc: {
    ES: "Probabilidades implícitas para cada resultado del partido.",
    EN: "Implied probabilities for each match outcome.",
    PT: "Probabilidades implícitas para cada resultado da partida.",
  },

  // Universal back button
  back_button_label: { ES: "Volver", EN: "Back", PT: "Voltar" },

  // Mobile language dropdown
  language_dropdown_label: { ES: "Idioma", EN: "Language", PT: "Idioma" },
  language_es: { ES: "Español", EN: "Spanish", PT: "Espanhol" },
  language_en: { ES: "Inglés", EN: "English", PT: "Inglês" },
  language_pt: { ES: "Portugués", EN: "Portuguese", PT: "Português" },

  // Mobile top action bar
  toolbar_rewards: { ES: "Insights", EN: "Insights", PT: "Insights" },
  toolbar_stats: { ES: "Estadísticas", EN: "Stats", PT: "Estatísticas" },
  toolbar_halftime: { ES: "Match Hub", EN: "Match Hub", PT: "Match Hub" },
  toolbar_polls: { ES: "Pulse", EN: "Pulse", PT: "Pulse" },
  toolbar_ai: { ES: "IA", EN: "AI", PT: "IA" },
  toolbar_matches: { ES: "Partidos", EN: "Matches", PT: "Partidas" },
  toolbar_language: { ES: "Idioma", EN: "Language", PT: "Idioma" },
  toolbar_profile: { ES: "Perfil", EN: "Profile", PT: "Perfil" },

  // Favorite match
  favorite_match_add: { ES: "Marcar favorito", EN: "Mark as favorite", PT: "Marcar favorito" },
  favorite_match_remove: { ES: "Quitar favorito", EN: "Remove favorite", PT: "Remover favorito" },

  // Goal clean mode
  goal_clean_mode_label: { ES: "Modo gol", EN: "Goal mode", PT: "Modo gol" },
});

// Interactive Product Tour, Registration Gate, Registration Intelligence,
// Onboarding admin panel and Help Center "Start Tour" CTA.
Object.assign(dict, {
  // Help Center
  help_start_tour: { ES: "Iniciar tour del producto", EN: "Start product tour", PT: "Iniciar tour do produto" },

  // Tour
  tour_eyebrow: { ES: "Tour del producto", EN: "Product tour", PT: "Tour do produto" },
  tour_step: { ES: "Paso", EN: "Step", PT: "Passo" },
  tour_back: { ES: "Atrás", EN: "Back", PT: "Voltar" },
  tour_next: { ES: "Siguiente", EN: "Next", PT: "Próximo" },
  tour_skip: { ES: "Saltar", EN: "Skip", PT: "Pular" },
  tour_finish: { ES: "Finalizar", EN: "Finish", PT: "Finalizar" },
  tour_benefit: { ES: "Beneficio", EN: "Benefit", PT: "Benefício" },

  tour_live_tracker_title: { ES: "Live Tracker", EN: "Live Tracker", PT: "Live Tracker" },
  tour_live_tracker_desc: {
    ES: "Sigue el partido con radar 3D, posiciones, balón y momentos clave en vivo.",
    EN: "Follow the match with 3D radar, positions, ball and key moments live.",
    PT: "Acompanhe a partida com radar 3D, posições, bola e momentos-chave ao vivo.",
  },
  tour_live_tracker_benefit: {
    ES: "Entiendes lo que pasa antes que nadie.",
    EN: "Understand what's happening before anyone else.",
    PT: "Entenda o que acontece antes de todos.",
  },

  tour_community_chat_title: { ES: "Community Chat", EN: "Community Chat", PT: "Community Chat" },
  tour_community_chat_desc: {
    ES: "Comenta el partido en tiempo real con fans de todo el mundo.",
    EN: "Comment the match in real time with fans from around the world.",
    PT: "Comente a partida em tempo real com fãs do mundo todo.",
  },
  tour_community_chat_benefit: {
    ES: "Vive la pasión colectiva sin perder de vista el partido.",
    EN: "Live the collective passion without losing sight of the match.",
    PT: "Viva a paixão coletiva sem perder a partida de vista.",
  },

  tour_match_ai_title: { ES: "Match AI", EN: "Match AI", PT: "Match AI" },
  tour_match_ai_desc: {
    ES: "Pregunta a la IA del partido sobre tácticas, jugadores y momentos.",
    EN: "Ask the match AI about tactics, players and moments.",
    PT: "Pergunte à IA da partida sobre táticas, jogadores e momentos.",
  },
  tour_match_ai_benefit: {
    ES: "Análisis táctico personalizado al instante.",
    EN: "Personalized tactical analysis on demand.",
    PT: "Análise tática personalizada na hora.",
  },

  tour_advanced_stats_title: { ES: "Advanced Stats", EN: "Advanced Stats", PT: "Stats Avançadas" },
  tour_advanced_stats_desc: {
    ES: "Posesión, xG, presión y métricas tácticas en tiempo real.",
    EN: "Possession, xG, pressing and tactical metrics in real time.",
    PT: "Posse, xG, pressão e métricas táticas em tempo real.",
  },
  tour_advanced_stats_benefit: {
    ES: "Datos pro para entender el rendimiento real.",
    EN: "Pro-level data to understand real performance.",
    PT: "Dados pro para entender o desempenho real.",
  },

  tour_halftime_hub_title: { ES: "Halftime Hub", EN: "Halftime Hub", PT: "Halftime Hub" },
  tour_halftime_hub_desc: {
    ES: "Juegos, encuestas, premios y análisis durante el descanso.",
    EN: "Games, polls, prizes and analysis during halftime.",
    PT: "Jogos, enquetes, prêmios e análises durante o intervalo.",
  },
  tour_halftime_hub_benefit: {
    ES: "Convierte el descanso en una experiencia única.",
    EN: "Turn halftime into a unique experience.",
    PT: "Transforme o intervalo em uma experiência única.",
  },

  tour_rewards_title: { ES: "Rewards", EN: "Rewards", PT: "Recompensas" },
  tour_rewards_desc: {
    ES: "Gana puntos, vouchers y experiencias exclusivas por participar.",
    EN: "Earn points, vouchers and exclusive experiences by participating.",
    PT: "Ganhe pontos, vouchers e experiências exclusivas participando.",
  },
  tour_rewards_benefit: {
    ES: "Tu participación construye tu Match Center personal.",
    EN: "Your participation builds your personal Match Center.",
    PT: "Sua participação constrói seu Match Center pessoal.",
  },

  tour_global_oracle_title: { ES: "Global Oracle", EN: "Global Oracle", PT: "Global Oracle" },
  tour_global_oracle_desc: {
    ES: "Pregunta sobre historia, ligas, récords y comparaciones de cualquier época.",
    EN: "Ask about history, leagues, records and comparisons from any era.",
    PT: "Pergunte sobre história, ligas, recordes e comparações de qualquer época.",
  },
  tour_global_oracle_benefit: {
    ES: "Una enciclopedia de fútbol mundial siempre disponible.",
    EN: "A worldwide football encyclopedia always available.",
    PT: "Uma enciclopédia mundial do futebol sempre disponível.",
  },

  // Registration Gate
  gate_eyebrow: { ES: "Acceso", EN: "Access", PT: "Acesso" },
  gate_title: { ES: "Crea tu cuenta para continuar", EN: "Create your account to continue", PT: "Crie sua conta para continuar" },
  gate_sub: {
    ES: "Regístrate para personalizar tu experiencia, ganar recompensas y acceder a funciones premium.",
    EN: "Register to personalize your experience, earn rewards and unlock premium features.",
    PT: "Cadastre-se para personalizar sua experiência, ganhar recompensas e desbloquear recursos premium.",
  },
  gate_cta_register: { ES: "Registrarme", EN: "Register", PT: "Cadastrar" },
  gate_cta_learn: { ES: "Saber más", EN: "Learn more", PT: "Saber mais" },
  gate_cta_guest: { ES: "Continuar como invitado", EN: "Continue as guest", PT: "Continuar como convidado" },

  // Registration Intelligence Dashboard
  ri_title: { ES: "Inteligencia de registros", EN: "Registration Intelligence", PT: "Inteligência de cadastros" },
  ri_total: { ES: "Registros", EN: "Registrations", PT: "Cadastros" },
  ri_countries: { ES: "Países", EN: "Countries", PT: "Países" },
  ri_marketing_rate: { ES: "Marketing opt-in", EN: "Marketing opt-in", PT: "Marketing opt-in" },
  ri_analytics_rate: { ES: "Analytics opt-in", EN: "Analytics opt-in", PT: "Analytics opt-in" },
  ri_by_country: { ES: "Por país", EN: "By country", PT: "Por país" },
  ri_by_city: { ES: "Por ciudad", EN: "By city", PT: "Por cidade" },
  ri_by_lang: { ES: "Por idioma", EN: "By language", PT: "Por idioma" },
  ri_teams: { ES: "Equipos favoritos", EN: "Favorite teams", PT: "Times favoritos" },
  ri_players: { ES: "Jugadores favoritos", EN: "Favorite players", PT: "Jogadores favoritos" },
  ri_interests: { ES: "Intereses", EN: "Interests", PT: "Interesses" },
  ri_consent: { ES: "Consentimiento", EN: "Consent", PT: "Consentimento" },
  ri_all_countries: { ES: "Todos los países", EN: "All countries", PT: "Todos os países" },
  ri_all_langs: { ES: "Todos los idiomas", EN: "All languages", PT: "Todos os idiomas" },

  // Onboarding admin panel
  onb_admin_title: { ES: "Onboarding y registro", EN: "Onboarding & Registration", PT: "Onboarding e cadastro" },
  onb_admin_saved: { ES: "Guardado", EN: "Saved", PT: "Salvo" },
  onb_admin_hint: {
    ES: "Estos ajustes controlan el tour, el welcome y el bloqueo de acceso.",
    EN: "These settings control the tour, welcome flow and access gate.",
    PT: "Estas configurações controlam o tour, o welcome e o bloqueio de acesso.",
  },
  onb_flag_enable_onboarding: { ES: "Activar onboarding", EN: "Enable onboarding", PT: "Ativar onboarding" },
  onb_flag_enable_product_tour: { ES: "Activar tour del producto", EN: "Enable product tour", PT: "Ativar tour do produto" },
  onb_flag_require_registration_before_access: {
    ES: "Requerir registro antes de acceder",
    EN: "Require registration before access",
    PT: "Exigir cadastro antes do acesso",
  },
  onb_flag_allow_guest_mode: { ES: "Permitir modo invitado", EN: "Allow guest mode", PT: "Permitir modo convidado" },
  // Real Sports Data Integration
  rsd_title: { ES: "Capa de datos deportivos reales", EN: "Real Sports Data Layer", PT: "Camada de dados esportivos reais" },
  rsd_desc: {
    ES: "Activa proveedores reales con caché y failover automático al simulador.",
    EN: "Enable real providers with cache and automatic failover to the simulator.",
    PT: "Ative provedores reais com cache e failover automático para o simulador.",
  },
  rsd_real_data: { ES: "Datos reales", EN: "Real data", PT: "Dados reais" },
  rsd_enabled: { ES: "Activado", EN: "Enabled", PT: "Ativado" },
  rsd_disabled: { ES: "Desactivado (usando mock)", EN: "Disabled (using mock)", PT: "Desativado (usando mock)" },
  rsd_provider: { ES: "Proveedor", EN: "Provider", PT: "Provedor" },
  rsd_cache_ttl: { ES: "TTL caché (min)", EN: "Cache TTL (min)", PT: "TTL cache (min)" },
  rsd_save: { ES: "Guardar", EN: "Save", PT: "Salvar" },
  rsd_saved: { ES: "Configuración guardada", EN: "Settings saved", PT: "Configurações salvas" },
  rsd_refresh: { ES: "Refrescar", EN: "Refresh", PT: "Atualizar" },
  rsd_refreshed: { ES: "Sincronizado", EN: "Synced", PT: "Sincronizado" },
  rsd_refresh_failed: { ES: "Falló la sincronización", EN: "Sync failed", PT: "Falha na sincronização" },
  rsd_health: { ES: "Estado del proveedor", EN: "Provider health", PT: "Saúde do provedor" },
  rsd_no_health: { ES: "Sin datos de salud aún.", EN: "No health data yet.", PT: "Sem dados de saúde ainda." },
  rsd_last_sync: { ES: "Última sync", EN: "Last sync", PT: "Última sync" },
  rsd_error_rate: { ES: "tasa de error", EN: "error rate", PT: "taxa de erro" },
  // Betting integration
  betting_widget_title: { ES: "Cuotas en vivo", EN: "Live odds", PT: "Cotações ao vivo" },
  betting_loading: { ES: "Cargando cuotas…", EN: "Loading odds…", PT: "Carregando cotações…" },
  betting_disclaimer: {
    ES: "Solo +18. Cuotas indicativas. Apuesta con responsabilidad.",
    EN: "18+ only. Odds are indicative. Bet responsibly.",
    PT: "Apenas +18. Cotações indicativas. Aposte com responsabilidade.",
  },
  betting_blocked_notice: {
    ES: "Apuestas no disponibles en tu región o requiere verificación.",
    EN: "Betting not available in your region or requires verification.",
    PT: "Apostas indisponíveis na sua região ou requer verificação.",
  },
  betting_claim_bonus: { ES: "Reclamar bono", EN: "Claim bonus", PT: "Resgatar bônus" },
  betting_cta_default: { ES: "Ir a la casa", EN: "Visit bookmaker", PT: "Ir à casa" },
  betting_admin_title: { ES: "Apuestas y revenue de afiliados", EN: "Betting & affiliate revenue", PT: "Apostas e receita de afiliados" },
  betting_admin_provider: { ES: "Proveedor", EN: "Provider", PT: "Provedor" },
  betting_kpi_clicks: { ES: "Clicks", EN: "Clicks", PT: "Cliques" },
  betting_kpi_conversions: { ES: "Conversiones", EN: "Conversions", PT: "Conversões" },
  betting_kpi_deposits: { ES: "Depósitos", EN: "Deposits", PT: "Depósitos" },
  betting_kpi_revenue: { ES: "Revenue share", EN: "Revenue share", PT: "Revenue share" },
  betting_top_bookmakers: { ES: "Top casas por clics", EN: "Top bookmakers by clicks", PT: "Top casas por cliques" },
  betting_no_data: { ES: "Sin datos aún", EN: "No data yet", PT: "Sem dados ainda" },
  btn_refresh: { ES: "Refrescar", EN: "Refresh", PT: "Atualizar" },
});

Object.assign(dict, {
  // Contract & NDA Automation Center
  contract_title: { ES: "Centro de contratos y NDAs", EN: "Contract & NDA Automation Center", PT: "Central de contratos e NDAs" },
  contract_subtitle: {
    ES: "Genera, versiona y exporta acuerdos legales en minutos.",
    EN: "Generate, version and export legal agreements in minutes.",
    PT: "Gere, versione e exporte acordos legais em minutos.",
  },
  contract_new: { ES: "Nuevo contrato", EN: "New contract", PT: "Novo contrato" },
  contract_templates: { ES: "Plantillas", EN: "Templates", PT: "Modelos" },
  contract_list: { ES: "Contratos", EN: "Contracts", PT: "Contratos" },
  contract_empty: { ES: "Sin contratos. Crea el primero.", EN: "No contracts yet. Create your first.", PT: "Sem contratos. Crie o primeiro." },
  contract_select_hint: { ES: "Selecciona un contrato para ver el detalle.", EN: "Select a contract to see details.", PT: "Selecione um contrato para ver os detalhes." },
  contract_generate: { ES: "Generar", EN: "Generate", PT: "Gerar" },
  contract_created: { ES: "Contrato generado", EN: "Contract generated", PT: "Contrato gerado" },
  contract_cancel: { ES: "Cancelar", EN: "Cancel", PT: "Cancelar" },
  contract_delete: { ES: "Eliminar", EN: "Delete", PT: "Excluir" },
  contract_confirm_delete: { ES: "¿Eliminar este contrato?", EN: "Delete this contract?", PT: "Excluir este contrato?" },
  contract_edit: { ES: "Editar", EN: "Edit", PT: "Editar" },
  contract_preview: { ES: "Previsualizar", EN: "Preview", PT: "Pré-visualizar" },
  contract_save_revision: { ES: "Guardar revisión", EN: "Save revision", PT: "Salvar revisão" },
  contract_revision_saved: { ES: "Revisión guardada", EN: "Revision saved", PT: "Revisão salva" },
  contract_versions: { ES: "Versiones", EN: "Versions", PT: "Versões" },
  contract_esign_prepare: { ES: "Preparar e-sign", EN: "Prepare e-sign", PT: "Preparar e-sign" },
  contract_esign_ready: { ES: "Listo para firma", EN: "Ready to sign", PT: "Pronto para assinar" },
  contract_ai_copilot: { ES: "AI Legal Copilot", EN: "AI Legal Copilot", PT: "AI Legal Copilot" },
  contract_ai_placeholder: {
    ES: "Ej.: Generar NDA para Univision",
    EN: "E.g.: Generate NDA for Univision",
    PT: "Ex.: Gerar NDA para Univision",
  },
  contract_ai_run: { ES: "Ejecutar", EN: "Run", PT: "Executar" },
  contract_ai_no_input: { ES: "Escribe un comando", EN: "Type a command", PT: "Digite um comando" },
  contract_ai_done: { ES: "Borrador generado por IA", EN: "AI draft generated", PT: "Rascunho gerado por IA" },
  contract_ai_examples: {
    ES: "Ejemplos: «Generar NDA para Univision» · «Crear contrato white-label con Televisa por 25000» · «Acuerdo revenue share 20% con DAZN»",
    EN: "Examples: \"Generate NDA for Univision\" · \"Create white-label license with Televisa for 25000\" · \"Revenue share agreement 20% with DAZN\"",
    PT: "Exemplos: \"Gerar NDA para Univision\" · \"Criar licença white-label com Televisa por 25000\" · \"Acordo revenue share 20% com DAZN\"",
  },
  // Field labels
  contract_field_type: { ES: "Tipo", EN: "Type", PT: "Tipo" },
  contract_field_tenant_autofill: { ES: "Auto-completar desde tenant", EN: "Autofill from tenant", PT: "Auto-preencher do tenant" },
  contract_field_counterparty_name: { ES: "Nombre de contraparte", EN: "Counterparty name", PT: "Nome da contraparte" },
  contract_field_counterparty_address: { ES: "Dirección de contraparte", EN: "Counterparty address", PT: "Endereço da contraparte" },
  contract_field_contact_name: { ES: "Contacto", EN: "Contact", PT: "Contato" },
  contract_field_contact_email: { ES: "Email", EN: "Email", PT: "Email" },
  contract_field_fee: { ES: "Tarifa", EN: "Fee", PT: "Tarifa" },
  contract_field_currency: { ES: "Moneda", EN: "Currency", PT: "Moeda" },
  contract_field_rev_share: { ES: "Revenue share %", EN: "Revenue share %", PT: "Revenue share %" },
  contract_field_term_months: { ES: "Plazo (meses)", EN: "Term (months)", PT: "Prazo (meses)" },
  contract_field_termination_days: { ES: "Aviso de término (días)", EN: "Termination notice (days)", PT: "Aviso de término (dias)" },
  contract_field_governing_law: { ES: "Ley aplicable", EN: "Governing law", PT: "Lei aplicável" },
  contract_field_scope: { ES: "Alcance", EN: "Scope", PT: "Escopo" },
  // Statuses
  contract_status_draft: { ES: "Borrador", EN: "Draft", PT: "Rascunho" },
  contract_status_review: { ES: "Revisión", EN: "Review", PT: "Revisão" },
  contract_status_approved: { ES: "Aprobado", EN: "Approved", PT: "Aprovado" },
  contract_status_sent: { ES: "Enviado", EN: "Sent", PT: "Enviado" },
  contract_status_signed: { ES: "Firmado", EN: "Signed", PT: "Assinado" },
  // Types
  contract_type_nda: { ES: "NDA", EN: "NDA", PT: "NDA" },
  contract_type_mutual_nda: { ES: "NDA mutuo", EN: "Mutual NDA", PT: "NDA mútuo" },
  contract_type_white_label_license: { ES: "Licencia white-label", EN: "White-Label License", PT: "Licença white-label" },
  contract_type_revenue_share: { ES: "Revenue share", EN: "Revenue share", PT: "Revenue share" },
  contract_type_msa: { ES: "MSA", EN: "MSA", PT: "MSA" },
  contract_type_sow: { ES: "SOW", EN: "SOW", PT: "SOW" },
  contract_type_sponsorship: { ES: "Patrocinio", EN: "Sponsorship", PT: "Patrocínio" },
  contract_type_dpa: { ES: "DPA", EN: "DPA", PT: "DPA" },
  // Templates editor
  contract_template_save: { ES: "Guardar plantilla", EN: "Save template", PT: "Salvar modelo" },
  contract_template_saved: { ES: "Plantilla guardada", EN: "Template saved", PT: "Modelo salvo" },
  contract_template_reset: { ES: "Plantilla restaurada", EN: "Template reset", PT: "Modelo restaurado" },
  contract_template_reset_btn: { ES: "Restaurar", EN: "Reset", PT: "Restaurar" },
});

Object.assign(dict, {
  // Common
  close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  loading: { ES: "Cargando…", EN: "Loading…", PT: "Carregando…" },

  // Push Pipeline
  push_pipeline_title: { ES: "Pipeline de Notificaciones", EN: "Push Notifications Pipeline", PT: "Pipeline de Notificações" },
  push_kpi_campaigns: { ES: "Campañas", EN: "Campaigns", PT: "Campanhas" },
  push_kpi_sent: { ES: "Enviados", EN: "Sent", PT: "Enviados" },
  push_kpi_opens: { ES: "Aperturas", EN: "Opens", PT: "Aberturas" },
  push_kpi_open_rate: { ES: "Tasa apertura", EN: "Open rate", PT: "Taxa abertura" },
  push_compose: { ES: "Nueva campaña", EN: "New campaign", PT: "Nova campanha" },
  push_title_ph: { ES: "Título de la notificación", EN: "Notification title", PT: "Título da notificação" },
  push_body_ph: { ES: "Cuerpo del mensaje", EN: "Message body", PT: "Corpo da mensagem" },
  push_save_campaign: { ES: "Guardar campaña", EN: "Save campaign", PT: "Salvar campanha" },
  push_send_now: { ES: "Enviar", EN: "Send", PT: "Enviar" },
  push_estimated_audience: { ES: "audiencia est.", EN: "est. audience", PT: "audiência est." },
  push_validation_required: { ES: "Título y mensaje obligatorios", EN: "Title and body required", PT: "Título e mensagem obrigatórios" },
  push_campaign_saved: { ES: "Campaña guardada", EN: "Campaign saved", PT: "Campanha salva" },
  push_campaign_sent_toast: { ES: "Campaña enviada", EN: "Campaign sent", PT: "Campanha enviada" },
  push_empty: { ES: "No hay campañas todavía", EN: "No campaigns yet", PT: "Sem campanhas ainda" },
  push_seg_all: { ES: "Todos", EN: "All", PT: "Todos" },
  push_seg_premium: { ES: "Premium", EN: "Premium", PT: "Premium" },
  push_seg_free: { ES: "Free", EN: "Free", PT: "Free" },
  push_seg_high_engagement: { ES: "Engagement alto", EN: "High engagement", PT: "Engajamento alto" },
  push_seg_halftime_active: { ES: "Halftime activos", EN: "Halftime active", PT: "Intervalo ativos" },
  push_seg_country: { ES: "Por país", EN: "By country", PT: "Por país" },
  push_seg_team: { ES: "Por equipo", EN: "By team", PT: "Por time" },
  push_ch_web: { ES: "Web", EN: "Web", PT: "Web" },
  push_ch_push: { ES: "Push", EN: "Push", PT: "Push" },
  push_ch_in_app: { ES: "In-app", EN: "In-app", PT: "In-app" },
  push_ch_email: { ES: "Email", EN: "Email", PT: "Email" },
  push_status_draft: { ES: "Borrador", EN: "Draft", PT: "Rascunho" },
  push_status_scheduled: { ES: "Programada", EN: "Scheduled", PT: "Agendada" },
  push_status_sent: { ES: "Enviada", EN: "Sent", PT: "Enviada" },
  push_status_cancelled: { ES: "Cancelada", EN: "Cancelled", PT: "Cancelada" },

  // Traditional Stats Center
  trad_stats_title: { ES: "Centro de Estadísticas Clásicas", EN: "Traditional Stats Center", PT: "Centro de Estatísticas Clássicas" },
  trad_tab_standings: { ES: "Tabla", EN: "Standings", PT: "Tabela" },
  trad_tab_scorers: { ES: "Goleadores", EN: "Top Scorers", PT: "Artilheiros" },
  trad_tab_assists: { ES: "Asistencias", EN: "Top Assists", PT: "Assistências" },
  trad_tab_fixtures: { ES: "Calendario", EN: "Fixtures", PT: "Calendário" },
  trad_col_team: { ES: "Equipo", EN: "Team", PT: "Time" },
  trad_stats_footer: { ES: "Datos demo · reemplazables por datos reales", EN: "Demo data · replaceable with real feeds", PT: "Dados demo · substituíveis por dados reais" },

  // Fantasy & Trivia
  fantasy_title: { ES: "Fantasy Diario & Trivia Battles", EN: "Daily Fantasy & Trivia Battles", PT: "Fantasy Diário & Trivia" },
  fantasy_tab_lineup: { ES: "Mi alineación", EN: "My lineup", PT: "Meu time" },
  fantasy_tab_trivia: { ES: "Trivia", EN: "Trivia", PT: "Trivia" },
  fantasy_budget: { ES: "Presupuesto", EN: "Budget", PT: "Orçamento" },
  fantasy_squad: { ES: "Plantilla", EN: "Squad", PT: "Elenco" },
  fantasy_predicted: { ES: "Puntos est.", EN: "Predicted pts", PT: "Pts est." },
  fantasy_save: { ES: "Guardar", EN: "Save", PT: "Salvar" },
  fantasy_play: { ES: "Simular puntos", EN: "Simulate score", PT: "Simular pontos" },
  fantasy_live_score: { ES: "Puntos en vivo", EN: "Live score", PT: "Pontos ao vivo" },
  fantasy_squad_full: { ES: "Plantilla completa", EN: "Squad full", PT: "Elenco cheio" },
  fantasy_over_budget: { ES: "Sobre presupuesto", EN: "Over budget", PT: "Acima do orçamento" },
  fantasy_pick_n: { ES: "Selecciona {n} jugadores", EN: "Pick {n} players", PT: "Escolha {n} jogadores" },
  fantasy_saved: { ES: "Alineación guardada", EN: "Lineup saved", PT: "Time salvo" },
  trivia_score: { ES: "Puntos", EN: "Score", PT: "Pontos" },
  trivia_result_msg: { ES: "Buen partido — gana puntos respondiendo bien.", EN: "Nice round — earn points by answering correctly.", PT: "Boa rodada — ganhe pontos acertando." },
  trivia_play_again: { ES: "Jugar de nuevo", EN: "Play again", PT: "Jogar de novo" },

  // Rewards Marketplace (extends existing rewards)
  rewards_marketplace_title: { ES: "Marketplace de Recompensas", EN: "Rewards Marketplace", PT: "Marketplace de Recompensas" },
  rewards_marketplace_my_rewards: { ES: "Mis premios", EN: "My rewards", PT: "Meus prêmios" },
  rewards_marketplace_featured: { ES: "Destacado para ti", EN: "Featured for you", PT: "Destaque para você" },
  rewards_marketplace_all: { ES: "Todas", EN: "All", PT: "Todas" },
  rewards_marketplace_redeem: { ES: "Canjear", EN: "Redeem", PT: "Resgatar" },
  rewards_marketplace_locked: { ES: "Bloqueado", EN: "Locked", PT: "Bloqueado" },
  rewards_marketplace_insufficient: { ES: "Puntos insuficientes", EN: "Insufficient points", PT: "Pontos insuficientes" },
  rewards_marketplace_redeemed: { ES: "Recompensa canjeada", EN: "Reward redeemed", PT: "Recompensa resgatada" },
  rewards_marketplace_full_catalog: { ES: "Ver catálogo completo", EN: "Open full catalog", PT: "Ver catálogo completo" },

  // Tactical Quick Prompts
  tactical_quick_prompts: { ES: "Sugerencias tácticas", EN: "Tactical suggestions", PT: "Sugestões táticas" },

  // Retention Orchestration
  home_feed_title: { ES: "Tu feed diario", EN: "Your daily feed", PT: "Seu feed diário" },
  retention_center_title: { ES: "Retention Orchestration Center", EN: "Retention Orchestration Center", PT: "Retention Orchestration Center" },
  retention_center_desc: { ES: "Coordina misiones, rachas, modos y campañas push 24/7.", EN: "Coordinate missions, streaks, modes and 24/7 push campaigns.", PT: "Coordena missões, sequências, modos e campanhas push 24/7." },
  mode_live: { ES: "En vivo", EN: "Live", PT: "Ao vivo" },
  mode_halftime: { ES: "Entretiempo", EN: "Halftime", PT: "Intervalo" },
  mode_no_match: { ES: "Sin partido", EN: "No-match day", PT: "Sem jogo" },
  mode_inactive: { ES: "Reactivar", EN: "Inactive", PT: "Inativo" },
  mode_priorities: { ES: "Prioridades por modo", EN: "Priorities by mode", PT: "Prioridades por modo" },
  missions_title: { ES: "Misiones diarias", EN: "Daily missions", PT: "Missões diárias" },
  missions_completed: { ES: "Misiones completadas", EN: "Missions completed", PT: "Missões concluídas" },
  mission_open_app: { ES: "Abre la app", EN: "Open the app", PT: "Abrir o app" },
  mission_answer_trivia: { ES: "Responde una trivia", EN: "Answer a trivia", PT: "Responder trivia" },
  mission_view_stats: { ES: "Consulta estadísticas", EN: "View stats", PT: "Ver estatísticas" },
  mission_talk_to_ai: { ES: "Habla con la IA", EN: "Talk to the AI", PT: "Falar com a IA" },
  mission_share_app: { ES: "Comparte la app", EN: "Share the app", PT: "Compartilhar o app" },
  streak_label: { ES: "Racha actual", EN: "Current streak", PT: "Sequência atual" },
  streak_longest: { ES: "Mejor racha", EN: "Best streak", PT: "Melhor sequência" },
  streak_next_in: { ES: "{n} días para premio", EN: "{n} days to next reward", PT: "{n} dias para prêmio" },
  streak_participants: { ES: "Usuarios con racha", EN: "Users with streak", PT: "Usuários com sequência" },
  streak_milestones: { ES: "Hitos de racha", EN: "Streak milestones", PT: "Marcos de sequência" },
  push_open_rate: { ES: "Tasa apertura push", EN: "Push open rate", PT: "Taxa abertura push" },
  feed_open: { ES: "Abrir", EN: "Open", PT: "Abrir" },
  feed_view: { ES: "Ver", EN: "View", PT: "Ver" },
  feed_play: { ES: "Jugar", EN: "Play", PT: "Jogar" },
  feed_watch: { ES: "Ver ahora", EN: "Watch", PT: "Ver agora" },
  feed_redeem: { ES: "Canjear", EN: "Redeem", PT: "Resgatar" },
  feed_streak_title: { ES: "Mantén tu racha", EN: "Keep your streak", PT: "Mantenha sua sequência" },
  feed_streak_to_next: { ES: "Sigue activo para el próximo premio.", EN: "Stay active to unlock the next reward.", PT: "Continue ativo para o próximo prêmio." },
  feed_streak_max: { ES: "Has alcanzado el tope. ¡Sigue así!", EN: "You hit the max — keep going!", PT: "Você atingiu o topo!" },
  feed_missions_title: { ES: "Misiones de hoy", EN: "Today's missions", PT: "Missões de hoje" },
  feed_missions_progress: { ES: "Completa todas para ganar puntos extra.", EN: "Complete them all for bonus points.", PT: "Conclua tudo para pontos extra." },
  feed_rec_live: { ES: "Hay un partido en vivo ahora", EN: "There's a live match now", PT: "Tem jogo ao vivo agora" },
  feed_rec_halftime: { ES: "Entretiempo: gana puntos jugando", EN: "Halftime: earn points playing", PT: "Intervalo: ganhe pontos" },
  feed_rec_fantasy: { ES: "Arma tu Fantasy diario", EN: "Build your daily Fantasy", PT: "Monte seu Fantasy diário" },
  feed_rec_oracle: { ES: "Pregúntale al Global Oracle", EN: "Ask the Global Oracle", PT: "Pergunte ao Global Oracle" },
  feed_rec_comeback: { ES: "Te extrañamos — vuelve por un premio", EN: "We miss you — come back for a reward", PT: "Sentimos sua falta — volte para um prêmio" },
  feed_trivia_invite: { ES: "Trivia rápida disponible", EN: "Quick trivia available", PT: "Trivia rápida disponível" },
  feed_upcoming_match: { ES: "Próximo partido cercano", EN: "Upcoming match nearby", PT: "Próximo jogo próximo" },
  feed_reward_title: { ES: "Recompensas listas", EN: "Rewards ready", PT: "Recompensas prontas" },

  // FASE 2 — Live overlays & polls
  sponsor_badge_sponsored_by: { ES: "Patrocinado por", EN: "Sponsored by", PT: "Patrocinado por" },
  sponsor_badge_aria: { ES: "Patrocinado por {sponsor}", EN: "Sponsored by {sponsor}", PT: "Patrocinado por {sponsor}" },
  poll_paused_danger_aria: { ES: "Encuesta pausada — jugada peligrosa", EN: "Poll paused — dangerous play", PT: "Enquete pausada — jogada perigosa" },
  poll_paused_badge: { ES: "Encuesta en pausa", EN: "Poll paused", PT: "Enquete pausada" },
  poll_completed_aria: { ES: "Encuesta completada", EN: "Poll completed", PT: "Enquete concluída" },
  poll_completed_badge: { ES: "🗳️ Encuesta completada", EN: "🗳️ Poll completed", PT: "🗳️ Enquete concluída" },
  poll_live_label: { ES: "Encuesta en vivo", EN: "Live poll", PT: "Enquete ao vivo" },
  poll_sponsor_label: { ES: "{sponsor} · Encuesta", EN: "{sponsor} · Poll", PT: "{sponsor} · Enquete" },
  poll_close_aria: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  poll_vote_toast_title: { ES: "🗳️ ¡Voto registrado!", EN: "🗳️ Vote recorded!", PT: "🗳️ Voto registrado!" },
  poll_vote_toast_desc: { ES: "Gracias por participar.", EN: "Thanks for taking part.", PT: "Obrigado por participar." },
  poll_thanks_voted: { ES: "¡Gracias por votar!", EN: "Thanks for voting!", PT: "Obrigado por votar!" },
  poll_reward_label: { ES: "Recompensa", EN: "Reward", PT: "Recompensa" },
  poll_reward_code: { ES: "Código", EN: "Code", PT: "Código" },
  poll_reward_expires: { ES: "Vence", EN: "Expires", PT: "Vence" },

  // Live narrative engine — emotional one-liners
  narrative_dominio_1: { ES: "🔥 {team} domina totalmente el ritmo.", EN: "🔥 {team} fully dominates the tempo.", PT: "🔥 {team} domina totalmente o ritmo." },
  narrative_dominio_2: { ES: "🎯 {team} controla cada metro del campo.", EN: "🎯 {team} controls every inch of the pitch.", PT: "🎯 {team} controla cada metro do campo." },
  narrative_presion_1: { ES: "⚠️ {team} pierde control del mediocampo.", EN: "⚠️ {team} loses control of midfield.", PT: "⚠️ {team} perde controle do meio-campo." },
  narrative_presion_2: { ES: "🌀 {team} se ve superado por la presión rival.", EN: "🌀 {team} is being overrun by the opposing press.", PT: "🌀 {team} é superado pela pressão adversária." },
  narrative_peligro_1: { ES: "🚨 Alta probabilidad de ataque peligroso.", EN: "🚨 High chance of a dangerous attack.", PT: "🚨 Alta chance de ataque perigoso." },
  narrative_peligro_2: { ES: "⚡ Se aproxima jugada de gol.", EN: "⚡ A goal-scoring play is coming.", PT: "⚡ Jogada de gol se aproxima." },
  narrative_momentum_1: { ES: "📈 {team} cambia el ritmo del partido.", EN: "📈 {team} shifts the match tempo.", PT: "📈 {team} muda o ritmo do jogo." },
  narrative_momentum_2: { ES: "🔁 Momentum gira hacia {team}.", EN: "🔁 Momentum swings to {team}.", PT: "🔁 Momentum vira para {team}." },
  narrative_caos_1: { ES: "💥 Caos absoluto en el área.", EN: "💥 Total chaos inside the box.", PT: "💥 Caos absoluto na área." },
  narrative_caos_2: { ES: "🌪️ Ambos equipos pierden la pelota una y otra vez.", EN: "🌪️ Both teams keep coughing up possession.", PT: "🌪️ Ambos perdem a bola repetidamente." },
  narrative_recup_1: { ES: "🛡️ {team} recupera el orden defensivo.", EN: "🛡️ {team} restores defensive order.", PT: "🛡️ {team} recupera a ordem defensiva." },
  narrative_recup_2: { ES: "🧊 {team} enfría el partido con posesión.", EN: "🧊 {team} cools the match down with possession.", PT: "🧊 {team} esfria o jogo com posse." },
  narrative_agot_1: { ES: "😮‍💨 {team} acusa el desgaste físico.", EN: "😮‍💨 {team} is feeling the fatigue.", PT: "😮‍💨 {team} sente o desgaste físico." },
  narrative_agot_2: { ES: "🥵 Cae el ritmo: piernas pesadas en {team}.", EN: "🥵 Tempo drops — heavy legs for {team}.", PT: "🥵 Cai o ritmo: pernas pesadas em {team}." },
  narrative_desesp_1: { ES: "😱 {team} ataca con desesperación.", EN: "😱 {team} attacks in desperation.", PT: "😱 {team} ataca com desespero." },
  narrative_desesp_2: { ES: "🆘 {team} se lanza al frente sin orden.", EN: "🆘 {team} throws bodies forward with no shape.", PT: "🆘 {team} se lança ao ataque sem ordem." },
  narrative_control_1: { ES: "🧠 {team} maneja los tiempos del partido.", EN: "🧠 {team} dictates the match tempo.", PT: "🧠 {team} controla os tempos do jogo." },
  narrative_control_2: { ES: "📊 {team} dicta el plan con autoridad.", EN: "📊 {team} runs the plan with authority.", PT: "📊 {team} dita o plano com autoridade." },
  narrative_tension_1: { ES: "⏳ Tensión máxima sobre la cancha.", EN: "⏳ Tension peaks on the pitch.", PT: "⏳ Tensão máxima em campo." },
  narrative_tension_2: { ES: "🫨 El estadio contiene la respiración.", EN: "🫨 The stadium holds its breath.", PT: "🫨 O estádio prende a respiração." },
  narrative_player_1: { ES: "🧠 {player} está explotando la banda {zone}.", EN: "🧠 {player} is tearing up the {zone} flank.", PT: "🧠 {player} está explorando a faixa {zone}." },
  narrative_player_2: { ES: "🌟 {player} aparece en zonas decisivas.", EN: "🌟 {player} appears in decisive zones.", PT: "🌟 {player} aparece em zonas decisivas." },
  narrative_player_3: { ES: "⚡ {player} encuentra espacio entre líneas.", EN: "⚡ {player} finds space between the lines.", PT: "⚡ {player} encontra espaço entre linhas." },
  narrative_zone_left: { ES: "izquierda", EN: "left", PT: "esquerda" },
  narrative_zone_right: { ES: "derecha", EN: "right", PT: "direita" },
  narrative_zone_center: { ES: "central", EN: "central", PT: "central" },
  narrative_community_excitement: { ES: "🔥 La comunidad siente que viene el gol.", EN: "🔥 The community senses a goal coming.", PT: "🔥 A comunidade sente que vem gol." },
  narrative_community_tension: { ES: "😬 La comunidad detecta nerviosismo en el equipo.", EN: "😬 The community senses jitters in the team.", PT: "😬 A comunidade percebe nervosismo na equipe." },
  narrative_community_frustration: { ES: "⚠️ La afición percibe debilidad defensiva.", EN: "⚠️ Fans sense defensive weakness.", PT: "⚠️ A torcida percebe fragilidade defensiva." },
});

Object.assign(dict, {
  // Hype meter (live radar)
  hype_meter_tap: { ES: "Apoyar a mi equipo", EN: "Support my team", PT: "Apoiar meu time" },
  hype_meter_intensity: { ES: "Apoyo colectivo", EN: "Collective support", PT: "Apoio coletivo" },

  // Spoiler sync slider
  spoiler_sync_title: { ES: "Sincronizar con mi pantalla", EN: "Sync with my screen", PT: "Sincronizar com minha tela" },
  spoiler_sync_off: { ES: "OFF", EN: "OFF", PT: "OFF" },
  spoiler_sync_desc: {
    ES: "Retrasa goles, alertas y trivia para evitar spoilers de tu TV.",
    EN: "Delay goals, alerts and trivia to avoid TV spoilers.",
    PT: "Atrasa gols, alertas e trivia para evitar spoilers da TV.",
  },
  tv_sync_setup: { ES: "Sincronizar TV", EN: "Sync TV", PT: "Sincronizar TV" },
  tv_sync_active: { ES: "TV Sync activo", EN: "TV Sync active", PT: "TV Sync ativo" },
  tv_sync_ultra: { ES: "Ultra Live", EN: "Ultra Live", PT: "Ultra Live" },
  tv_sync_collapse: { ES: "Colapsar", EN: "Collapse", PT: "Colapsar" },
  tv_sync_expand: { ES: "Ajustar", EN: "Adjust", PT: "Ajustar" },
  tv_sync_offset_label: { ES: "Retraso de TV", EN: "TV delay", PT: "Atraso de TV" },
  insights_pro_back: { ES: "Volver", EN: "Back", PT: "Voltar" },
  insights_pro_close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  heat_panel_title: { ES: "Apoyo de la afición", EN: "Fan support", PT: "Apoio da torcida" },
  heat_panel_no_window: { ES: "El partido está estable. Pulsa para mostrar tu apoyo cuando suba la tensión.", EN: "The match is calm. Tap to show your support when tension rises.", PT: "A partida está calma. Toque para mostrar apoio quando a tensão subir." },
  heat_panel_momentum: { ES: "Impulso de la afición", EN: "Fan momentum", PT: "Impulso da torcida" },
  heat_panel_pressure: { ES: "Presión de tribuna", EN: "Stand pressure", PT: "Pressão da arquibancada" },
  heat_panel_intensity: { ES: "Intensidad del apoyo", EN: "Support intensity", PT: "Intensidade do apoio" },
  heat_panel_explanation: { ES: "Cada pulso suma a tu equipo en la batalla mundial de aficionados.", EN: "Every tap adds to your team in the worldwide fan battle.", PT: "Cada toque soma ao seu time na batalha mundial de torcidas." },
  heat_panel_boost: { ES: "🔥 Impulsar a {team}", EN: "🔥 Boost {team}", PT: "🔥 Impulsionar {team}" },
  heat_panel_pulse_sent: { ES: "🔥 Apoyo enviado", EN: "🔥 Support sent", PT: "🔥 Apoio enviado" },
  heat_panel_reward: { ES: "+15 Fuerza de afición", EN: "+15 Fan strength", PT: "+15 Força da torcida" },
  heat_panel_impact: { ES: "{flag} Tu apoyo fortalece a {team}", EN: "{flag} Your support strengthens {team}", PT: "{flag} Seu apoio fortalece {team}" },
  heat_panel_cooldown: { ES: "Disponible nuevamente en {s}s", EN: "Available again in {s}s", PT: "Disponível novamente em {s}s" },
  heat_panel_contributes_title: { ES: "Tu apoyo fortalece:", EN: "Your support strengthens:", PT: "Seu apoio fortalece:" },
  heat_panel_contributes_storm: { ES: "Ola de apoyo", EN: "Support wave", PT: "Onda de apoio" },
  heat_panel_contributes_rivalry: { ES: "Batalla de aficiones", EN: "Fan battle", PT: "Batalha de torcidas" },
  heat_panel_contributes_momentum: { ES: "Impulso colectivo", EN: "Collective momentum", PT: "Impulso coletivo" },
  heat_panel_contributes_ranking: { ES: "Ranking de aficionados", EN: "Fan ranking", PT: "Ranking de torcedores" },
  // Fan Power first-use explainer + button + rivalry mini + progression
  fan_power_first_title: { ES: "🔥 APOYA A TU EQUIPO", EN: "🔥 SUPPORT YOUR TEAM", PT: "🔥 APOIE SEU TIME" },
  fan_power_first_body: { ES: "Tu apoyo ayuda a tu selección a dominar la batalla mundial de aficionados.", EN: "Your support helps your team dominate the worldwide fan battle.", PT: "Seu apoio ajuda seu time a dominar a batalha mundial de torcidas." },
  fan_power_first_strengthens: { ES: "Tu participación fortalece:", EN: "Your participation strengthens:", PT: "Sua participação fortalece:" },
  fan_power_first_cta: { ES: "ENTENDIDO", EN: "GOT IT", PT: "ENTENDI" },
  fan_power_button: { ES: "APOYO", EN: "SUPPORT", PT: "APOIO" },
  fan_power_rivalry_title: { ES: "Batalla de aficiones · ahora", EN: "Fan battle · live", PT: "Batalha de torcidas · ao vivo" },
  fan_power_level: { ES: "Tu nivel", EN: "Your level", PT: "Seu nível" },
  // Pride (was "Prestigio")
  fan_pride_label: { ES: "Orgullo de la afición", EN: "Fan pride", PT: "Orgulho da torcida" },
  fan_pride_unlocked: { ES: "Orgullo desbloqueado", EN: "Pride unlocked", PT: "Orgulho desbloqueado" },

  // Quinielas (World Cup bracket)
  quinielas_title: { ES: "Quinielas Mundialistas", EN: "World Cup Bracket", PT: "Bolão da Copa" },
  quinielas_upcoming: { ES: "Próximos partidos", EN: "Upcoming matches", PT: "Próximos jogos" },
  quinielas_loading: { ES: "Cargando…", EN: "Loading…", PT: "Carregando…" },
  quinielas_no_matches: {
    ES: "Aún no hay partidos cargados. El calendario aparecerá automáticamente cuando se sincronice la API oficial.",
    EN: "No matches loaded yet. The schedule will appear automatically once the official API syncs.",
    PT: "Ainda não há jogos carregados. O calendário aparecerá automaticamente quando a API oficial sincronizar.",
  },
  quinielas_leaderboard: { ES: "Leaderboard global", EN: "Global leaderboard", PT: "Ranking global" },
  quinielas_no_scores: { ES: "Aún sin puntuaciones.", EN: "No scores yet.", PT: "Ainda sem pontuações." },
  quinielas_pts: { ES: "pts", EN: "pts", PT: "pts" },
  quinielas_exact: { ES: "exactos", EN: "exact", PT: "exatos" },
  quinielas_status_final: { ES: "FINAL", EN: "FINAL", PT: "FINAL" },
  quinielas_status_locked: { ES: "BLOQUEADO", EN: "LOCKED", PT: "BLOQUEADO" },
  quinielas_status_open: { ES: "ABIERTO", EN: "OPEN", PT: "ABERTO" },
  quinielas_result: { ES: "Resultado", EN: "Result", PT: "Resultado" },
  quinielas_no_prediction: { ES: "sin predicción", EN: "no prediction", PT: "sem palpite" },
  quinielas_save: { ES: "Guardar", EN: "Save", PT: "Salvar" },
  // Guerrilla viral invite
  guerrilla_invite_cta: {
    ES: "🔥 Desafía a tus amigos en WhatsApp",
    EN: "🔥 Challenge your friends on WhatsApp",
    PT: "🔥 Desafie seus amigos no WhatsApp",
  },
  guerrilla_friends_joined: {
    ES: "amigos",
    EN: "joined",
    PT: "amigos",
  },
  guerrilla_share_message: {
    ES: "🔥 Te desafío a ganarme en la Quiniela interactiva 3D de VerseSport. Vive el Mundial en tiempo real, con predicciones, hype y comunidad. Regístrate gratis aquí: {url}",
    EN: "🔥 I'm challenging you to beat me in the VerseSport 3D Bracket. Live the World Cup in real time — predictions, hype and community. Sign up free here: {url}",
    PT: "🔥 Te desafio a me vencer no Bolão 3D interativo do VerseSport. Viva a Copa em tempo real, com palpites, hype e comunidade. Cadastre-se grátis aqui: {url}",
  },
  // Social Domination Layer
  social_hub_title: { ES: "Comunidad Mundial", EN: "World Community", PT: "Comunidade Mundial" },
  nation_wars_title: { ES: "Guerra de Naciones", EN: "Nation Wars", PT: "Guerra das Nações" },
  nation_wars_empty: { ES: "Aún no hay hype — sé el primero.", EN: "No hype yet — be the first.", PT: "Sem hype ainda — seja o primeiro." },
  nation_wars_fans: { ES: "fans", EN: "fans", PT: "fãs" },
  nation_pick_title: { ES: "Tu nación", EN: "Your nation", PT: "Sua nação" },
  nation_pick_desc: { ES: "Defiende tu bandera en el ranking global del Mundial.", EN: "Defend your flag in the global World Cup ranking.", PT: "Defenda sua bandeira no ranking global da Copa." },
  streaks_title: { ES: "Tus rachas", EN: "Your streaks", PT: "Suas sequências" },
  streaks_best: { ES: "Mejor:", EN: "Best:", PT: "Melhor:" },
  streak_prediction: { ES: "Predicciones", EN: "Predictions", PT: "Palpites" },
  streak_hype: { ES: "Hype", EN: "Hype", PT: "Hype" },
  streak_login: { ES: "Días seguidos", EN: "Day streak", PT: "Dias seguidos" },
  streak_referral: { ES: "Referidos", EN: "Referrals", PT: "Indicações" },
  fan_title_label: { ES: "Tu título", EN: "Your title", PT: "Seu título" },
  fan_title_exact: { ES: "Exactos", EN: "Exact", PT: "Exatos" },
  fan_title_points: { ES: "Puntos", EN: "Points", PT: "Pontos" },
  fan_title_referrals: { ES: "Amigos", EN: "Friends", PT: "Amigos" },
  title_goal_prophet: { ES: "Profeta del Gol", EN: "Goal Prophet", PT: "Profeta do Gol" },
  title_tactical_oracle: { ES: "Oráculo Táctico", EN: "Tactical Oracle", PT: "Oráculo Tático" },
  title_nation_defender: { ES: "Defensor de la Nación", EN: "Nation Defender", PT: "Defensor da Nação" },
  title_hype_commander: { ES: "Comandante del Hype", EN: "Hype Commander", PT: "Comandante do Hype" },
  title_world_cup_legend: { ES: "Leyenda del Mundial", EN: "World Cup Legend", PT: "Lenda da Copa" },
  title_pressure_reader: { ES: "Lector de Presión", EN: "Pressure Reader", PT: "Leitor de Pressão" },
  title_last_minute_hero: { ES: "Héroe del Último Minuto", EN: "Last Minute Hero", PT: "Herói do Último Minuto" },
  title_rising_fan: { ES: "Fan en Ascenso", EN: "Rising Fan", PT: "Fã em Ascensão" },
  victory_card_share: { ES: "Compartir mi victoria", EN: "Share my victory", PT: "Compartilhar minha vitória" },
  victory_cards_title: { ES: "Tarjetas de Victoria", EN: "Victory Cards", PT: "Cartões de Vitória" },
  victory_exact_headline: { ES: "Predije {n} marcadores exactos", EN: "I nailed {n} exact scores", PT: "Acertei {n} placares exatos" },
  victory_exact_sub: { ES: "Top 3% de predictores", EN: "Top 3% of predictors", PT: "Top 3% dos palpiteiros" },
  victory_points_headline: { ES: "Acumulé {n} puntos en el Mundial", EN: "I scored {n} World Cup points", PT: "Somei {n} pontos na Copa" },
  victory_points_sub: { ES: "Subiendo en el ranking global", EN: "Climbing the global ranking", PT: "Subindo no ranking global" },
  victory_referrals_headline: { ES: "{n} amigos se unieron por mí", EN: "{n} friends joined because of me", PT: "{n} amigos entraram por mim" },
  victory_referrals_sub: { ES: "Construyendo mi escuadra", EN: "Building my squad", PT: "Montando meu time" },
  victory_default_headline: { ES: "Vivo el Mundial en VerseSport", EN: "I'm living the World Cup on VerseSport", PT: "Vivo a Copa no VerseSport" },
  victory_default_sub: { ES: "Únete a la comunidad", EN: "Join the community", PT: "Entre na comunidade" },
  moment_nation_leads: { ES: "{nation} lidera el hype global 🔥", EN: "{nation} is leading global hype 🔥", PT: "{nation} lidera o hype global 🔥" },
  moment_hype_explosion: { ES: "💥 El hype acaba de explotar", EN: "💥 Hype just exploded", PT: "💥 O hype acabou de explodir" },
  moment_active_fans: { ES: "👀 {n} fans activos ahora mismo", EN: "👀 {n} fans active right now", PT: "👀 {n} fãs ativos agora" },
  moment_warming_up: { ES: "La comunidad está calentando motores…", EN: "The community is warming up…", PT: "A comunidade está esquentando…" },
  fomo_active: { ES: "activos", EN: "active", PT: "ativos" },
  fomo_burst: { ES: "hype/min", EN: "hype/min", PT: "hype/min" },
});

Object.assign(dict, {
  // Cinematic Moments Engine
  cm_share: { ES: "Compartir", EN: "Share", PT: "Compartilhar" },
  cm_copy: { ES: "Copiar", EN: "Copy", PT: "Copiar" },
  cm_copied: { ES: "Copiado al portapapeles", EN: "Copied to clipboard", PT: "Copiado para a área" },
  cm_copied_short: { ES: "Copiado", EN: "Copied", PT: "Copiado" },
  cm_copy_failed: { ES: "No se pudo copiar", EN: "Couldn't copy", PT: "Não foi possível copiar" },

  cm_hype_spike_h: { ES: "💥 El hype acaba de explotar", EN: "💥 Hype just exploded", PT: "💥 O hype acabou de explodir" },
  cm_hype_spike_s: { ES: "{n} pulsos en el último minuto", EN: "{n} pulses in the last minute", PT: "{n} pulsos no último minuto" },

  cm_nation_dominance_h: { ES: "🔥 {nation} domina el Hype Mundial", EN: "🔥 {nation} dominates global hype", PT: "🔥 {nation} domina o hype mundial" },
  cm_nation_dominance_s: { ES: "{pct}% del hype global ahora mismo", EN: "{pct}% of global hype right now", PT: "{pct}% do hype global agora" },

  cm_poll_consensus_h: { ES: "👀 El {pct}% predice lo mismo", EN: "👀 {pct}% are predicting the same", PT: "👀 {pct}% estão prevendo o mesmo" },
  cm_poll_consensus_s: { ES: "Consenso masivo de la comunidad", EN: "Massive community consensus", PT: "Consenso massivo da comunidade" },

  cm_prediction_explosion_h: { ES: "🎯 Explosión de predicciones", EN: "🎯 Prediction explosion", PT: "🎯 Explosão de palpites" },
  cm_prediction_explosion_s: { ES: "Miles de fans están jugando ahora", EN: "Thousands of fans are playing now", PT: "Milhares de fãs jogando agora" },

  cm_momentum_swing_h: { ES: "⚡ Cambio de momentum", EN: "⚡ Momentum swing", PT: "⚡ Virada de momentum" },
  cm_momentum_swing_s: { ES: "El partido acaba de girar", EN: "The match just turned", PT: "A partida acabou de virar" },

  cm_last_minute_h: { ES: "⏱️ Drama de último minuto", EN: "⏱️ Last-minute drama", PT: "⏱️ Drama nos minutos finais" },
  cm_last_minute_s: { ES: "Todo se decide ahora", EN: "It all comes down to this", PT: "Tudo se decide agora" },

  cm_shockwave_h: { ES: "🌎 Community shockwave", EN: "🌎 Community shockwave", PT: "🌎 Onda de choque global" },
  cm_shockwave_s: { ES: "{n} fans activos en VerseSport", EN: "{n} fans active on VerseSport", PT: "{n} fãs ativos no VerseSport" },
});

// Global Match Events Engine / World Stadium status
Object.assign(dict, {
  gw_energy_label: { ES: "Energía global", EN: "Global energy", PT: "Energia global" },
  gw_tension_label: { ES: "Tensión social", EN: "Social tension", PT: "Tensão social" },

  gw_region_latam: { ES: "Latinoamérica", EN: "Latin America", PT: "América Latina" },
  gw_region_europe: { ES: "Europa", EN: "Europe", PT: "Europa" },
  gw_region_africa: { ES: "África", EN: "Africa", PT: "África" },
  gw_region_asia: { ES: "Asia", EN: "Asia", PT: "Ásia" },
  gw_region_northam: { ES: "Norteamérica", EN: "North America", PT: "América do Norte" },
  gw_region_oceania: { ES: "Oceanía", EN: "Oceania", PT: "Oceania" },

  gw_status_calm: {
    ES: "🌎 El estadio digital está calentando",
    EN: "🌎 The digital stadium is warming up",
    PT: "🌎 O estádio digital está esquentando",
  },
  gw_status_warming_up: {
    ES: "🔥 El planeta empieza a reaccionar",
    EN: "🔥 The planet is starting to react",
    PT: "🔥 O planeta começa a reagir",
  },
  gw_status_planet_reacting: {
    ES: "👀 El planeta está reaccionando · {fans} fans en vivo",
    EN: "👀 The planet is reacting · {fans} fans live",
    PT: "👀 O planeta está reagindo · {fans} fãs ao vivo",
  },
  gw_status_max_tension: {
    ES: "⚠️ El Mundial está en máxima tensión",
    EN: "⚠️ The World Cup is at maximum tension",
    PT: "⚠️ A Copa está em tensão máxima",
  },
  gw_status_last_minute: {
    ES: "⏱️ El planeta espera el desenlace",
    EN: "⏱️ The planet waits for the final blow",
    PT: "⏱️ O planeta espera o desfecho",
  },
  gw_status_region_latam: {
    ES: "🔥 Latinoamérica domina el hype mundial ({pct}%)",
    EN: "🔥 Latin America dominates global hype ({pct}%)",
    PT: "🔥 América Latina domina o hype mundial ({pct}%)",
  },
  gw_status_region_europe: {
    ES: "🔥 Europa toma el control del Mundial ({pct}%)",
    EN: "🔥 Europe takes over the World Cup ({pct}%)",
    PT: "🔥 Europa assume o controle da Copa ({pct}%)",
  },
  gw_status_region_africa: {
    ES: "🔥 África lidera el hype global ({pct}%)",
    EN: "🔥 Africa leads the global hype ({pct}%)",
    PT: "🔥 África lidera o hype global ({pct}%)",
  },
  gw_status_region_asia: {
    ES: "🔥 Asia domina la conversación mundial ({pct}%)",
    EN: "🔥 Asia dominates the global conversation ({pct}%)",
    PT: "🔥 Ásia domina a conversa mundial ({pct}%)",
  },
  gw_status_region_northam: {
    ES: "🔥 Norteamérica enciende el Mundial ({pct}%)",
    EN: "🔥 North America lights up the World Cup ({pct}%)",
    PT: "🔥 América do Norte acende a Copa ({pct}%)",
  },
  gw_status_region_oceania: {
    ES: "🔥 Oceanía sorprende al planeta ({pct}%)",
    EN: "🔥 Oceania surprises the planet ({pct}%)",
    PT: "🔥 Oceania surpreende o planeta ({pct}%)",
  },
});

Object.assign(dict, {
  // World Cup Showcase Mode
  sc_title: { ES: "Showcase Mundial", EN: "World Cup Showcase", PT: "Showcase Mundial" },
  sc_intro: {
    ES: "Una experiencia cinematográfica del Mundial — hype global, naciones, momentos virales y comunidad en vivo.",
    EN: "A cinematic World Cup experience — global hype, nations, viral moments and live community.",
    PT: "Uma experiência cinematográfica da Copa — hype global, nações, momentos virais e comunidade ao vivo.",
  },
  sc_start: { ES: "Iniciar showcase", EN: "Start showcase", PT: "Iniciar showcase" },
  sc_play: { ES: "Reproducir", EN: "Play", PT: "Reproduzir" },
  sc_pause: { ES: "Pausar", EN: "Pause", PT: "Pausar" },
  sc_next: { ES: "Siguiente", EN: "Next", PT: "Próximo" },
  sc_prev: { ES: "Anterior", EN: "Previous", PT: "Anterior" },
  sc_stop: { ES: "Detener", EN: "Stop", PT: "Parar" },
  sc_creator: { ES: "Creator", EN: "Creator", PT: "Creator" },
  sc_controls_label: { ES: "Controles del showcase", EN: "Showcase controls", PT: "Controles do showcase" },

  // Scripted cinematic beats
  sc_beat_world_h: {
    ES: "🌎 Tu nación está peleando por el #1",
    EN: "🌎 Your nation is fighting for #1",
    PT: "🌎 Sua nação está lutando pelo #1",
  },
  sc_beat_world_s: {
    ES: "Defiende tu bandera y sube en el ranking mundial.",
    EN: "Defend your flag and climb the world ranking.",
    PT: "Defenda sua bandeira e suba no ranking mundial.",
  },
  sc_beat_mex_h: {
    ES: "🔥 {nation} domina el hype mundial ({pct}%)",
    EN: "🔥 {nation} dominates global hype ({pct}%)",
    PT: "🔥 {nation} domina o hype global ({pct}%)",
  },
  sc_beat_mex_s: {
    ES: "La afición empuja como nadie. Sentí el rugido.",
    EN: "The fans are pushing like no one else. Feel the roar.",
    PT: "A torcida empurra como ninguém. Sinta o rugido.",
  },
  sc_beat_shock_h: {
    ES: "💥 Community Shockwave",
    EN: "💥 Community Shockwave",
    PT: "💥 Community Shockwave",
  },
  sc_beat_shock_s: {
    ES: "Una onda de hype recorre toda la red en segundos.",
    EN: "A hype shockwave is racing across the network in seconds.",
    PT: "Uma onda de hype atravessa toda a rede em segundos.",
  },
  sc_beat_bra_h: {
    ES: "🏆 {nation} rompe récord social",
    EN: "🏆 {nation} breaks the social record",
    PT: "🏆 {nation} quebra o recorde social",
  },
  sc_beat_bra_s: {
    ES: "Más predicciones, más quinielas, más comunidad.",
    EN: "More predictions, more pools, more community.",
    PT: "Mais previsões, mais bolões, mais comunidade.",
  },
  sc_beat_pressure_h: {
    ES: "⚠️ Goal pressure extrema",
    EN: "⚠️ Extreme goal pressure",
    PT: "⚠️ Pressão de gol extrema",
  },
  sc_beat_pressure_s: {
    ES: "Últimos minutos. El estadio digital está al rojo vivo.",
    EN: "Final minutes. The digital stadium is red-hot.",
    PT: "Minutos finais. O estádio digital está em chamas.",
  },
  sc_beat_predict_h: {
    ES: "🎯 {n} predicciones en vivo",
    EN: "🎯 {n} live predictions",
    PT: "🎯 {n} previsões ao vivo",
  },
  sc_beat_predict_s: {
    ES: "Fans de todo el mundo están jugando ahora.",
    EN: "Fans around the world are playing right now.",
    PT: "Fãs do mundo todo estão jogando agora.",
  },
  sc_beat_poll_h: {
    ES: "👀 Consenso global: {pct}% de acuerdo",
    EN: "👀 Global consensus: {pct}% agree",
    PT: "👀 Consenso global: {pct}% concordam",
  },
  sc_beat_poll_s: {
    ES: "La comunidad votó. La afición habló.",
    EN: "The community voted. The fans have spoken.",
    PT: "A comunidade votou. A torcida falou.",
  },
  sc_beat_rivalry_h: {
    ES: "⚔️ Rivalidad global encendida",
    EN: "⚔️ Global rivalry ignited",
    PT: "⚔️ Rivalidade global acesa",
  },
  sc_beat_rivalry_s: {
    ES: "Naciones enfrentadas. Hype en máximos.",
    EN: "Nations clashing. Hype at maximum.",
    PT: "Nações em confronto. Hype no máximo.",
  },
});

Object.assign(dict, {
  // Live Reactions
  lrm_title: { ES: "Reacciones en vivo", EN: "Live reactions", PT: "Reações ao vivo" },
  lrm_chat: { ES: "🔥 El chat explotó", EN: "🔥 The chat is on fire", PT: "🔥 O chat explodiu" },
  lrm_goal: { ES: "⚠️ La comunidad predice gol", EN: "⚠️ Community predicts a goal", PT: "⚠️ A comunidade prevê gol" },
  lrm_mex: { ES: "👀 España domina las reacciones", EN: "👀 Spain dominates the reactions", PT: "👀 Espanha domina as reações" },
  lrm_shock: { ES: "💥 World Shockwave", EN: "💥 World Shockwave", PT: "💥 Onda mundial" },
  lrm_save: { ES: "🧤 Atajada épica viral", EN: "🧤 Epic save going viral", PT: "🧤 Defesa épica viralizando" },
  lrm_var: { ES: "🟡 VAR en revisión global", EN: "🟡 VAR under global review", PT: "🟡 VAR em revisão global" },

  // Viral Challenges
  ch_title: { ES: "Challenges del Mundial", EN: "World Cup challenges", PT: "Desafios da Copa" },
  ch_world_cup_edition: { ES: "Edición Mundial", EN: "World Cup edition", PT: "Edição Copa" },
  ch_play: { ES: "Jugar", EN: "Play", PT: "Jogar" },
  ch_done: { ES: "✓ Completado", EN: "✓ Done", PT: "✓ Concluído" },
  ch_predict_3_t: { ES: "Predice 3 goles seguidos", EN: "Predict 3 goals in a row", PT: "Acerte 3 gols seguidos" },
  ch_predict_3_d: { ES: "Acumula 3 aciertos exactos en el mismo partido.", EN: "Stack 3 exact predictions in one match.", PT: "Acumule 3 acertos exatos no mesmo jogo." },
  ch_hype_t: { ES: "Domina el Hype Mundial", EN: "Dominate Global Hype", PT: "Domine o Hype Global" },
  ch_hype_d: { ES: "Genera hype en el feed global del Mundial.", EN: "Push hype on the global World Cup feed.", PT: "Gere hype no feed global da Copa." },
  ch_beat_bra_t: { ES: "Supera a Brasil", EN: "Beat Brazil", PT: "Supere o Brasil" },
  ch_beat_bra_d: { ES: "Acumula más puntos que el promedio Brasil.", EN: "Beat Brazil's average score.", PT: "Supere a média de pontos do Brasil." },
  ch_top_t: { ES: "Conquista el Top 1%", EN: "Reach the Top 1%", PT: "Conquiste o Top 1%" },
  ch_top_d: { ES: "Escala al 1% mundial de la temporada.", EN: "Climb into the global top 1% this season.", PT: "Suba ao top 1% mundial da temporada." },

  // Countdown / Pulse
  wc_phase_pre: { ES: "Pre-partido", EN: "Pre-match", PT: "Pré-jogo" },
  wc_phase_anthem: { ES: "Himnos", EN: "Anthems", PT: "Hinos" },
  wc_phase_late: { ES: "Minutos finales", EN: "Late minutes", PT: "Minutos finais" },
  wc_phase_pen: { ES: "Penales", EN: "Penalties", PT: "Pênaltis" },

  // Clip Export
  clip_export: { ES: "Crear Clip Viral", EN: "Create Viral Clip", PT: "Criar Clipe Viral" },
  clip_ready: { ES: "Clip listo para compartir", EN: "Clip ready to share", PT: "Clipe pronto para compartilhar" },
  clip_failed: { ES: "No se pudo generar el clip", EN: "Clip could not be generated", PT: "Não foi possível gerar o clipe" },

  // === Onboarding (multi-language) ===
  onb_step_label: { ES: "Paso {current} de {total} · {label}", EN: "Step {current} of {total} · {label}", PT: "Passo {current} de {total} · {label}" },
  onb_step_account: { ES: "Cuenta", EN: "Account", PT: "Conta" },
  onb_step_fan: { ES: "Perfil de fan", EN: "Fan profile", PT: "Perfil de fã" },
  onb_step_prefs: { ES: "Preferencias", EN: "Preferences", PT: "Preferências" },
  onb_step_consumption: { ES: "Consumo", EN: "Consumption", PT: "Consumo" },
  onb_step_sponsors: { ES: "Patrocinadores", EN: "Sponsors", PT: "Patrocinadores" },
  onb_step_identity: { ES: "Identidad futbolística", EN: "Football identity", PT: "Identidade futebolística" },
  onb_step_consent: { ES: "Consentimiento", EN: "Consent", PT: "Consentimento" },
  onb_back: { ES: "Atrás", EN: "Back", PT: "Voltar" },
  onb_continue: { ES: "Continuar", EN: "Continue", PT: "Continuar" },
  onb_skip: { ES: "Saltar", EN: "Skip", PT: "Pular" },
  onb_finish: { ES: "Finalizar", EN: "Finish", PT: "Finalizar" },
  onb_title: { ES: "Onboarding", EN: "Onboarding", PT: "Onboarding" },

  // === Team picker / theme ===
  theme_search_placeholder: { ES: "Buscar tu equipo o selección…", EN: "Search your team or nation…", PT: "Buscar seu time ou seleção…" },
  theme_search_empty: { ES: "Sin coincidencias", EN: "No matches", PT: "Sem resultados" },
  theme_active: { ES: "activo", EN: "active", PT: "ativo" },

  // === Unlock Experience (guest → register) ===
  unlock_eyebrow: { ES: "Desbloquea VerseSport", EN: "Unlock VerseSport", PT: "Desbloqueie VerseSport" },
  unlock_title: { ES: "Desbloquea toda la experiencia Mundialista", EN: "Unlock the full World Cup experience", PT: "Desbloqueie toda a experiência da Copa" },
  unlock_sub: { ES: "Crea tu cuenta gratis y lleva la app al máximo.", EN: "Create your free account and take the app to the next level.", PT: "Crie sua conta grátis e leve o app ao próximo nível." },
  unlock_feature_1: { ES: "Todos los partidos en ultra-live", EN: "All matches in ultra-live", PT: "Todas as partidas em ultra-live" },
  unlock_feature_2: { ES: "Predicciones, quinielas y puntos", EN: "Predictions, brackets and points", PT: "Predições, bolões e pontos" },
  unlock_feature_3: { ES: "Chat global y comunidades", EN: "Global chat & communities", PT: "Chat global e comunidades" },
  unlock_feature_4: { ES: "Recompensas y experiencias premium", EN: "Premium rewards & experiences", PT: "Recompensas e experiências premium" },
  unlock_cta_register: { ES: "Crear mi cuenta gratis", EN: "Create my free account", PT: "Criar minha conta grátis" },
  unlock_cta_later: { ES: "Ahora no", EN: "Maybe later", PT: "Mais tarde" },

  // === QR entry ===
  qr_badge_eyebrow: { ES: "Entrada rápida", EN: "Quick entry", PT: "Entrada rápida" },
  qr_badge_title: { ES: "Escanéame con tu cámara", EN: "Scan me with your camera", PT: "Escaneie com sua câmera" },
  qr_badge_sub: { ES: "Abre VerseSport en segundos", EN: "Open VerseSport in seconds", PT: "Abra VerseSport em segundos" },

  // === Prediction Reputation ===
  reputation_level_label: { ES: "Nivel", EN: "Level", PT: "Nível" },
  reputation_points: { ES: "puntos", EN: "points", PT: "pontos" },
  reputation_streak: { ES: "racha", EN: "streak", PT: "sequência" },
  reputation_exact: { ES: "exactas", EN: "exact", PT: "exatas" },
  reputation_accuracy: { ES: "precisión", EN: "accuracy", PT: "precisão" },
  reputation_to_next: { ES: "{n} pts para {label}", EN: "{n} pts to {label}", PT: "{n} pts para {label}" },

  // === Featured Fans ===
  featured_fans_title: { ES: "Fans destacados", EN: "Featured fans", PT: "Fãs em destaque" },
  featured_fans_subtitle: { ES: "Top predictores", EN: "Top predictors", PT: "Top preditores" },
  featured_fans_empty: { ES: "Aún no hay predictores. Sé el primero en aparecer aquí.", EN: "No predictors yet. Be the first to land here.", PT: "Ainda não há preditores. Seja o primeiro a aparecer aqui." },

  // === Help Center (full page) ===
  help_open_full_guide: { ES: "Ver guía completa", EN: "Open full guide", PT: "Ver guia completo" },
  help_page_title: { ES: "Centro de ayuda", EN: "Help center", PT: "Centro de ajuda" },
  help_page_subtitle: { ES: "Todo lo que necesitas para dominar VerseSport.", EN: "Everything you need to master VerseSport.", PT: "Tudo o que você precisa para dominar o VerseSport." },
  help_search_placeholder: { ES: "Buscar en ayuda…", EN: "Search help…", PT: "Pesquisar na ajuda…" },
  help_empty_results: { ES: "No encontramos resultados. Prueba con otra palabra.", EN: "No results. Try another term.", PT: "Sem resultados. Tente outro termo." },
  help_more_legal: { ES: "Consulta también:", EN: "See also:", PT: "Veja também:" },
  legal_terms: { ES: "Términos", EN: "Terms", PT: "Termos" },
  legal_privacy: { ES: "Privacidad", EN: "Privacy", PT: "Privacidade" },
  help_cat_all: { ES: "Todo", EN: "All", PT: "Tudo" },
  help_cat_tv: { ES: "Sincronizar TV", EN: "TV sync", PT: "Sincronizar TV" },
  help_cat_polls: { ES: "Encuestas", EN: "Polls", PT: "Enquetes" },
  help_cat_predictions: { ES: "Predicciones", EN: "Predictions", PT: "Predições" },
  help_cat_points: { ES: "Puntos", EN: "Points", PT: "Pontos" },
  help_cat_pulse: { ES: "Pulse", EN: "Pulse", PT: "Pulse" },
  help_cat_insights: { ES: "Insights", EN: "Insights", PT: "Insights" },
  help_cat_privacy: { ES: "Privacidad", EN: "Privacy", PT: "Privacidade" },
  help_cat_trouble: { ES: "Solución de problemas", EN: "Troubleshooting", PT: "Solução de problemas" },
  help_tv_q: { ES: "¿Cómo sincronizo con mi TV?", EN: "How do I sync with my TV?", PT: "Como sincronizar com minha TV?" },
  help_tv_a: { ES: "Abre un partido en vivo y usa el botón de sincronización de audio. Puedes ajustar el offset manualmente si la transmisión va adelantada o atrasada.", EN: "Open a live match and tap the audio-sync button. Adjust the offset manually if your stream is ahead or behind.", PT: "Abra uma partida ao vivo e use o botão de sincronização de áudio. Ajuste o offset manualmente se a transmissão estiver adiantada ou atrasada." },
  help_polls_q: { ES: "¿Cómo funcionan las encuestas?", EN: "How do polls work?", PT: "Como funcionam as enquetes?" },
  help_polls_a: { ES: "Aparece una pill compacta durante el partido. Toca para expandir, vota en un toque y obtén una insignia. Puedes minimizarla o cerrarla con un swipe.", EN: "A compact pill appears during the match. Tap to expand, vote with one tap, and earn a badge. Minimize or swipe to dismiss.", PT: "Uma pill compacta aparece durante a partida. Toque para expandir, vote com um toque e ganhe uma insígnia. Minimize ou deslize para dispensar." },
  help_pred_q: { ES: "¿Cómo funcionan las predicciones?", EN: "How do predictions work?", PT: "Como funcionam as predições?" },
  help_pred_a: { ES: "Predice el marcador antes del kickoff. Acierto exacto: 5 pts. Resultado + diferencia: 3 pts. Solo resultado: 1 pt. Tu racha sube si aciertas el ganador.", EN: "Predict the score before kickoff. Exact: 5 pts. Result + goal difference: 3 pts. Result only: 1 pt. Your streak grows when you call the winner.", PT: "Preveja o placar antes do kickoff. Exato: 5 pts. Resultado + diferença: 3 pts. Só resultado: 1 pt. Sua sequência cresce ao acertar o vencedor." },
  help_points_q: { ES: "¿Cómo gano puntos?", EN: "How do I earn points?", PT: "Como ganho pontos?" },
  help_points_a: { ES: "Predicciones, encuestas, login diario, compartir, completar onboarding e invitar amigos suman puntos. Los puntos suben tu nivel y desbloquean recompensas.", EN: "Predictions, polls, daily logins, sharing, onboarding and referrals earn points. Points raise your level and unlock rewards.", PT: "Predições, enquetes, login diário, compartilhamentos, onboarding e indicações somam pontos. Pontos elevam seu nível e liberam recompensas." },
  help_pulse_q: { ES: "¿Qué es Pulse?", EN: "What is Pulse?", PT: "O que é o Pulse?" },
  help_pulse_a: { ES: "Pulse es el latido social del partido: encuestas en vivo, hype meter, sentimiento de la comunidad y reacciones del público.", EN: "Pulse is the social heartbeat of the match: live polls, hype meter, community sentiment and crowd reactions.", PT: "Pulse é o pulso social da partida: enquetes ao vivo, medidor de hype, sentimento da comunidade e reações do público." },
  help_insights_q: { ES: "¿Qué encuentro en Insights?", EN: "What's inside Insights?", PT: "O que tem em Insights?" },
  help_insights_a: { ES: "IA táctica, análisis, momentum, predicciones y probabilidades calculadas en tiempo real para entender mejor el partido.", EN: "Tactical AI, analysis, momentum, predictions and probabilities computed live to help you read the match.", PT: "IA tática, análises, momentum, predições e probabilidades calculadas ao vivo para entender melhor a partida." },
  help_privacy_q: { ES: "¿Qué hacen con mis datos?", EN: "What do you do with my data?", PT: "O que vocês fazem com meus dados?" },
  help_privacy_a: { ES: "Usamos tus datos para personalizar la experiencia, medir engagement de forma agregada y mejorar el producto. Puedes ajustar tus preferencias en Ajustes › Privacidad.", EN: "We use your data to personalize the experience, measure engagement in aggregate, and improve the product. Manage preferences in Settings › Privacy.", PT: "Usamos seus dados para personalizar a experiência, medir o engagement de forma agregada e melhorar o produto. Ajuste em Configurações › Privacidade." },
  help_trouble_q: { ES: "El partido no carga o se ve raro, ¿qué hago?", EN: "Match doesn't load or looks broken — what now?", PT: "A partida não carrega ou parece quebrada — o que faço?" },
  help_trouble_a: { ES: "Refresca la página, verifica tu conexión y prueba el botón de modo seguro si lo ves. Si persiste, vuelve más tarde o repórtalo desde el menú de perfil.", EN: "Refresh the page, check your connection, and try Safe Mode if visible. If it persists, try again later or report it from the profile menu.", PT: "Atualize a página, verifique sua conexão e tente o Modo Seguro se aparecer. Se persistir, tente mais tarde ou reporte pelo menu de perfil." },
});

// =============================================================
// PASS — I18N FINAL AUDIT (auth + recovery + verify polish)
// =============================================================
Object.assign(dict, {
  login_password_label: { ES: "Contraseña", EN: "Password", PT: "Senha" },
  login_verify_required: {
    ES: "Verifica tu email para continuar",
    EN: "Verify your email to continue",
    PT: "Verifique seu e-mail para continuar",
  },
  login_resend_verification: {
    ES: "Reenviar verificación",
    EN: "Resend verification",
    PT: "Reenviar verificação",
  },
  login_resend_sending: { ES: "Enviando…", EN: "Sending…", PT: "Enviando…" },

  forgot_title: { ES: "Recuperar acceso", EN: "Recover access", PT: "Recuperar acesso" },
  forgot_desc: {
    ES: "Te enviaremos un enlace para restablecer tu contraseña.",
    EN: "We'll send a link to reset your password.",
    PT: "Enviaremos um link para redefinir sua senha.",
  },
  forgot_sent_inbox: {
    ES: "Revisa tu bandeja de entrada en",
    EN: "Check your inbox at",
    PT: "Confira sua caixa de entrada em",
  },
  forgot_submit: { ES: "Enviar enlace", EN: "Send link", PT: "Enviar link" },
  forgot_toast_sent: {
    ES: "Te enviamos un email con instrucciones",
    EN: "We've emailed you instructions",
    PT: "Enviamos um e-mail com instruções",
  },
  forgot_back_login: { ES: "Volver al login", EN: "Back to sign in", PT: "Voltar ao login" },
  forgot_email_placeholder: { ES: "tu@email.com", EN: "you@email.com", PT: "voce@email.com" },

  reset_title: { ES: "Nueva contraseña", EN: "New password", PT: "Nova senha" },
  reset_desc: {
    ES: "Crea una contraseña segura para tu cuenta.",
    EN: "Create a strong password for your account.",
    PT: "Crie uma senha forte para sua conta.",
  },
  reset_validating: { ES: "Validando enlace…", EN: "Validating link…", PT: "Validando link…" },
  reset_submit: { ES: "Actualizar contraseña", EN: "Update password", PT: "Atualizar senha" },

  verify_title: { ES: "Verifica tu email", EN: "Verify your email", PT: "Verifique seu e-mail" },
  verify_desc_with_email: {
    ES: "Te enviamos un enlace a {email}. Ábrelo para activar tu cuenta.",
    EN: "We sent a link to {email}. Open it to activate your account.",
    PT: "Enviamos um link para {email}. Abra-o para ativar sua conta.",
  },
  verify_desc_no_email: {
    ES: "Te enviamos un enlace de verificación. Ábrelo para activar tu cuenta.",
    EN: "We sent a verification link. Open it to activate your account.",
    PT: "Enviamos um link de verificação. Abra-o para ativar sua conta.",
  },
  verify_resend: { ES: "Reenviar email", EN: "Resend email", PT: "Reenviar e-mail" },
  verify_goto_login: {
    ES: "Ya verifiqué — ir al login",
    EN: "Already verified — go to sign in",
    PT: "Já verifiquei — ir ao login",
  },
  verify_email_unavailable: {
    ES: "Email no disponible",
    EN: "Email unavailable",
    PT: "E-mail indisponível",
  },
  verify_resent_ok: { ES: "Email reenviado", EN: "Email resent", PT: "E-mail reenviado" },
  verify_resent_fail: {
    ES: "No se pudo reenviar",
    EN: "Could not resend",
    PT: "Não foi possível reenviar",
  },

  common_loading_dots: { ES: "…", EN: "…", PT: "…" },
});

Object.assign(dict, {
  // Prediction Hub Sheet
  pred_hub_title: { ES: "Predicciones en vivo", EN: "Live predictions", PT: "Previsões ao vivo" },
  pred_hub_subtitle: {
    ES: "Acierta, gana reputación y sube en Featured Fans.",
    EN: "Predict, earn reputation and climb Featured Fans.",
    PT: "Acerte, ganhe reputação e suba no Featured Fans.",
  },
  pred_hub_eyebrow: {
    ES: "Social · Reputación · Comunidad",
    EN: "Social · Reputation · Community",
    PT: "Social · Reputação · Comunidade",
  },
  hub_identity_eyebrow: {
    ES: "Pausa · Entretenimiento · Sponsors",
    EN: "Break · Entertainment · Sponsors",
    PT: "Pausa · Entretenimento · Sponsors",
  },
  help_identity_eyebrow: {
    ES: "Orientación · IA ligera",
    EN: "Guidance · Lightweight AI",
    PT: "Orientação · IA leve",
  },
  help_identity_subtitle: {
    ES: "Soporte contextual, no otra capa competitiva.",
    EN: "Contextual support, not another competitive layer.",
    PT: "Suporte contextual, não outra camada competitiva.",
  },
  insights_pro_eyebrow: {
    ES: "Insights Pro · Broadcast Analytics",
    EN: "Insights Pro · Broadcast Analytics",
    PT: "Insights Pro · Broadcast Analytics",
  },
  pred_hub_reputation_strip: {
    ES: "Cada acierto suma a tu reputación",
    EN: "Every correct pick boosts your reputation",
    PT: "Cada acerto soma à sua reputação",
  },
  pred_hub_view_ranking: {
    ES: "Ver ranking de fans destacados",
    EN: "View Featured Fans ranking",
    PT: "Ver ranking de fãs destacados",
  },
  pred_hub_vote_registered: {
    ES: "Voto registrado · suma a tu reputación",
    EN: "Vote recorded · adds to your reputation",
    PT: "Voto registrado · soma à sua reputação",
  },
  pred_hub_toast_reward: {
    ES: "Sumaste puntos a tu reputación.",
    EN: "You earned reputation points.",
    PT: "Você ganhou pontos de reputação.",
  },

  // Markets
  pred_hub_q_winner: { ES: "¿Quién gana el partido?", EN: "Who wins the match?", PT: "Quem vence a partida?" },
  pred_hub_q_goal_75: { ES: "¿Habrá gol antes del minuto 75?", EN: "Goal before the 75th minute?", PT: "Gol antes do minuto 75?" },
  pred_hub_q_next_scorer: { ES: "¿Quién marca el próximo gol?", EN: "Who scores next?", PT: "Quem marca o próximo gol?" },
  pred_hub_q_more_shots: { ES: "¿Quién tira más al arco?", EN: "Who takes more shots?", PT: "Quem chuta mais ao gol?" },
  pred_hub_q_next_card: { ES: "¿Próxima tarjeta para…?", EN: "Next card for…?", PT: "Próximo cartão para…?" },
  pred_hub_q_dominance: { ES: "¿Quién domina los próximos 10 min?", EN: "Who dominates the next 10 min?", PT: "Quem domina os próximos 10 min?" },

  // Options
  pred_hub_opt_home: { ES: "Local", EN: "Home", PT: "Casa" },
  pred_hub_opt_away: { ES: "Visita", EN: "Away", PT: "Fora" },
  pred_hub_opt_draw: { ES: "Empate", EN: "Draw", PT: "Empate" },
  pred_hub_opt_even: { ES: "Parejo", EN: "Even", PT: "Equilibrado" },
  pred_hub_opt_home_scorer: { ES: "Local", EN: "Home", PT: "Casa" },
  pred_hub_opt_away_scorer: { ES: "Visita", EN: "Away", PT: "Fora" },
  pred_hub_opt_no_scorer: { ES: "Ninguno", EN: "None", PT: "Nenhum" },
  pred_hub_opt_no_card: { ES: "Ninguno", EN: "None", PT: "Nenhum" },

  // Rewards
  pred_hub_reward_winner: { ES: "+15 rep", EN: "+15 rep", PT: "+15 rep" },
  pred_hub_reward_goal: { ES: "+8 rep", EN: "+8 rep", PT: "+8 rep" },
  pred_hub_reward_scorer: { ES: "+12 rep", EN: "+12 rep", PT: "+12 rep" },
  pred_hub_reward_shots: { ES: "+6 rep", EN: "+6 rep", PT: "+6 rep" },
  pred_hub_reward_card: { ES: "+5 rep", EN: "+5 rep", PT: "+5 rep" },
  pred_hub_reward_dominance: { ES: "+10 rep", EN: "+10 rep", PT: "+10 rep" },

  close: { ES: "Cerrar", EN: "Close", PT: "Fechar" },
});

// P1-I18N-01 — Welcome / WCBlitz visible copy.
Object.assign(dict, {
  wcb_hero_eyebrow: {
    ES: "Mundial 2026 · En vivo",
    EN: "2026 World Cup · Live",
    PT: "Copa 2026 · Ao vivo",
  },
  wcb_hero_title_a: {
    ES: "Predice la próxima jugada",
    EN: "Predict the next play",
    PT: "Preveja a próxima jogada",
  },
  wcb_hero_title_b: {
    ES: "antes que ocurra",
    EN: "before it happens",
    PT: "antes que aconteça",
  },
  wcb_hero_sub: {
    ES: "Únete a miles de fanáticos compitiendo en tiempo real durante el Mundial 2026.",
    EN: "Join thousands of fans competing in real time during the 2026 World Cup.",
    PT: "Junte-se a milhares de fãs competindo em tempo real durante a Copa 2026.",
  },
  wcb_feature_live_predictions: {
    ES: "Predicciones en vivo",
    EN: "Live predictions",
    PT: "Previsões ao vivo",
  },
  wcb_feature_world_ranking: {
    ES: "Ranking mundial",
    EN: "World ranking",
    PT: "Ranking mundial",
  },
  wcb_feature_daily_rewards: {
    ES: "Recompensas diarias",
    EN: "Daily rewards",
    PT: "Recompensas diárias",
  },
  wcb_feature_tactical_radar: {
    ES: "Radar táctico 3D",
    EN: "3D tactical radar",
    PT: "Radar tático 3D",
  },
  wcb_cta_start_free: {
    ES: "Empezar Gratis",
    EN: "Start Free",
    PT: "Começar Grátis",
  },
  wcb_cta_disclaimer: {
    ES: "Gratis · Sin tarjeta · 1 toque para empezar",
    EN: "Free · No card · 1 tap to start",
    PT: "Grátis · Sem cartão · 1 toque para começar",
  },
  wcb_countdown_label: {
    ES: "Próxima predicción cierra en",
    EN: "Next prediction closes in",
    PT: "Próxima previsão fecha em",
  },
  wcb_live_fans_playing: {
    ES: "fanáticos jugando ahora",
    EN: "fans playing now",
    PT: "fãs jogando agora",
  },
  wcb_referral_title: {
    ES: "Gana 50 puntos por cada amigo",
    EN: "Earn 50 points for each friend",
    PT: "Ganhe 50 pontos por cada amigo",
  },
  wcb_referral_sub: {
    ES: "Invítalos por WhatsApp y suma a tu nación.",
    EN: "Invite them on WhatsApp and boost your nation.",
    PT: "Convide pelo WhatsApp e some para sua nação.",
  },
  wcb_referral_share_button: {
    ES: "Invitar por WhatsApp",
    EN: "Invite on WhatsApp",
    PT: "Convidar pelo WhatsApp",
  },
  wcb_referral_share_text: {
    ES: "Estoy jugando VerseSport durante el Mundial. Predice la próxima jugada conmigo. https://versesport.com",
    EN: "I'm playing VerseSport during the World Cup. Predict the next play with me. https://versesport.com",
    PT: "Estou jogando VerseSport durante a Copa. Preveja a próxima jogada comigo. https://versesport.com",
  },
  wcb_trust_free_start: {
    ES: "Gratis para empezar",
    EN: "Free to start",
    PT: "Grátis para começar",
  },
  wcb_trust_no_card: {
    ES: "Sin tarjeta requerida",
    EN: "No card required",
    PT: "Sem cartão necessário",
  },
  wcb_trust_realtime: {
    ES: "Predicciones en tiempo real",
    EN: "Real-time predictions",
    PT: "Previsões em tempo real",
  },
  wcb_trust_global: {
    ES: "Comunidad global",
    EN: "Global community",
    PT: "Comunidade global",
  },
  welcome_nw_title: {
    ES: "Nation Wars™",
    EN: "Nation Wars™",
    PT: "Nation Wars™",
  },
  welcome_nw_body: {
    ES: "Representa a tu país en la batalla mundial. Cada predicción correcta suma puntos a tu nación y escala el ranking global.",
    EN: "Represent your country in the global battle. Every correct prediction adds points to your nation and climbs the world ranking.",
    PT: "Represente seu país na batalha mundial. Cada previsão correta soma pontos para sua nação e sobe no ranking global.",
  },
  welcome_nw_cta: {
    ES: "Entrar a Nation Wars",
    EN: "Enter Nation Wars",
    PT: "Entrar em Nation Wars",
  },
  welcome_have_account: {
    ES: "Ya tengo cuenta",
    EN: "I already have an account",
    PT: "Já tenho conta",
  },
  welcome_qr_scan: {
    ES: "Escanea para entrar",
    EN: "Scan to enter",
    PT: "Escaneie para entrar",
  },
});

Object.assign(dict, {
  // Nation Wars share — landing + CTAs
  nw_share_landing_title: {
    ES: "{name} pelea por el #1 Mundial",
    EN: "{name} fights for the World #1",
    PT: "{name} luta pelo #1 Mundial",
  },
  nw_share_landing_join: {
    ES: "Únete a {name}",
    EN: "Join {name}",
    PT: "Junte-se a {name}",
  },
  nw_share_landing_blurb: {
    ES: "Cada predicción correcta suma puntos a tu nación. Defiende los colores y escala el ranking mundial en tiempo real.",
    EN: "Every correct prediction scores points for your nation. Defend your colors and climb the global ranking in real time.",
    PT: "Cada palpite certo soma pontos para sua nação. Defenda as cores e suba no ranking mundial em tempo real.",
  },
  nw_share_cta: {
    ES: "Compartir reto {name}",
    EN: "Share {name} challenge",
    PT: "Compartilhar desafio {name}",
  },
});

/* ───────── P0-OLA1 — Timeline 2.0 i18n keys ─────────
 * Visible timeline ribbon (EventTimeline + modal). Adds the missing
 * EN/PT copy so the timeline no longer mixes Spanish into other locales.
 * Does NOT alter scoring, predictions, Nation Wars or attention scheduling.
 */
Object.assign(dict, {
  tl_goal_title:            { ES: "España marca y suma 25 puntos", EN: "Goal scored — +25 pts", PT: "Gol marcado — +25 pts" },
  tl_goal_desc:             { ES: "Gol confirmado. Tus puntos se actualizan en tiempo real.", EN: "Goal confirmed. Your points update in real time.", PT: "Gol confirmado. Seus pontos atualizam em tempo real." },
  tl_danger_title:          { ES: "Se aproxima ataque peligroso", EN: "Dangerous attack incoming", PT: "Ataque perigoso a caminho" },
  tl_danger_desc:           { ES: "Jugada de alto riesgo en el área rival.", EN: "High-risk play in the rival box.", PT: "Jogada de alto risco na área rival." },
  tl_shot_title:            { ES: "Tiro al arco", EN: "Shot on goal", PT: "Chute a gol" },
  tl_shot_desc:             { ES: "Disparo directo a portería: sube la expectativa de gol.", EN: "Direct shot on target: goal expectancy rises.", PT: "Chute direto ao gol: expectativa de gol sobe." },
  tl_probability_up_title:  { ES: "Sube la presión del ataque", EN: "Attack pressure rising", PT: "Pressão de ataque subindo" },
  tl_probability_up_desc:   { ES: "La probabilidad de gol sube al 82%.", EN: "Goal probability rises to 82%.", PT: "A probabilidade de gol sobe para 82%." },
  tl_ai_predict_goal_title: { ES: "La IA anticipó el gol", EN: "AI predicted the goal", PT: "A IA antecipou o gol" },
  tl_ai_predict_goal_desc:  { ES: "Predicción IA: gol probable en los próximos 3 minutos.", EN: "AI prediction: goal likely in the next 3 minutes.", PT: "Previsão IA: gol provável nos próximos 3 minutos." },
  tl_points_won_title:      { ES: "Ganaste 25 puntos", EN: "You won 25 points", PT: "Você ganhou 25 pontos" },
  tl_points_won_desc:       { ES: "Acertaste una predicción reciente.", EN: "You nailed a recent prediction.", PT: "Você acertou uma previsão recente." },
  tl_coupon_unlocked_title: { ES: "Nike libera cupón del 15%", EN: "Nike unlocks a 15% coupon", PT: "Nike libera cupom de 15%" },
  tl_coupon_unlocked_desc:  { ES: "Cupón disponible en tu billetera.", EN: "Coupon available in your wallet.", PT: "Cupom disponível na sua carteira." },
  tl_top_fan_title:         { ES: "Eres Top 10 del partido", EN: "You're in the match Top 10", PT: "Você está no Top 10 da partida" },
  tl_top_fan_desc:          { ES: "Sigues escalando posiciones en el ranking de fans.", EN: "You keep climbing the fan ranking.", PT: "Você continua subindo no ranking de fãs." },
  tl_community_trend_title: { ES: "Tendencia de la comunidad", EN: "Community trend", PT: "Tendência da comunidade" },
  tl_community_trend_desc:  { ES: "El 71% predice un cambio táctico.", EN: "71% predict a tactical change.", PT: "71% preveem mudança tática." },
  tl_sponsor_offer_title:   { ES: "Oferta del patrocinador", EN: "Sponsor offer", PT: "Oferta do patrocinador" },
  tl_sponsor_offer_desc:    { ES: "2x1 en bebidas hasta el final del primer tiempo.", EN: "2-for-1 on drinks until half time.", PT: "Compre 1 leve 2 em bebidas até o intervalo." },
  tl_tactical_change_title: { ES: "Cambio táctico detectado", EN: "Tactical change detected", PT: "Mudança tática detectada" },
  tl_tactical_change_desc:  { ES: "El equipo local pasa a 4-3-3 ofensivo.", EN: "Home side switches to an attacking 4-3-3.", PT: "O time da casa passa para um 4-3-3 ofensivo." },
  tl_red_card_title:        { ES: "TARJETA ROJA", EN: "RED CARD", PT: "CARTÃO VERMELHO" },
  tl_red_card_desc:         { ES: "Expulsión confirmada. El partido cambia.", EN: "Sending-off confirmed. The match shifts.", PT: "Expulsão confirmada. A partida muda." },
  tl_penalty_title:         { ES: "PENAL señalado", EN: "PENALTY awarded", PT: "PÊNALTI marcado" },
  tl_penalty_desc:          { ES: "El árbitro marca penal. Momento decisivo.", EN: "Referee points to the spot. Decisive moment.", PT: "Árbitro marca pênalti. Momento decisivo." },
  tl_ai_predict_hit_title:  { ES: "La IA acertó el gol", EN: "AI nailed the goal", PT: "A IA acertou o gol" },
  tl_ai_predict_hit_desc:   { ES: "La predicción IA se cumplió. Sigue su pista.", EN: "AI prediction came true. Keep tracking it.", PT: "A previsão IA se confirmou. Siga sua pista." },
  tl_badge_unlocked_title:  { ES: "Badge desbloqueado", EN: "Badge unlocked", PT: "Badge desbloqueado" },
  tl_badge_unlocked_title_named: { ES: "Badge desbloqueado: {label}", EN: "Badge unlocked: {label}", PT: "Badge desbloqueado: {label}" },
  tl_badge_unlocked_desc:   { ES: "Toca para ver el logro.", EN: "Tap to view the achievement.", PT: "Toque para ver a conquista." },
  tl_badge_unlocked_desc_rarity: { ES: "Rareza: {rarity}. Toca para ver el logro.", EN: "Rarity: {rarity}. Tap to view the achievement.", PT: "Raridade: {rarity}. Toque para ver a conquista." },
  tl_ranking_up_title:      { ES: "Subiste en el ranking mundial", EN: "You moved up the world ranking", PT: "Você subiu no ranking mundial" },
  tl_ranking_up_desc:       { ES: "Tu posición global mejora. Mantén el ritmo.", EN: "Your global position improves. Keep the pace.", PT: "Sua posição global melhora. Mantenha o ritmo." },
  tl_nation_up_title:       { ES: "Tu nación sube posiciones", EN: "Your nation climbs the ranking", PT: "Sua nação sobe no ranking" },
  tl_nation_up_desc:        { ES: "El equipo nacional escala en el Nation Leaderboard.", EN: "Your national side climbs the Nation Leaderboard.", PT: "Sua seleção sobe no Nation Leaderboard." },
  tl_creator_pro_title:     { ES: "Creator Pro desbloqueado", EN: "Creator Pro unlocked", PT: "Creator Pro desbloqueado" },
  tl_creator_pro_desc:      { ES: "Entraste al Top 10% de creadores.", EN: "You entered the Top 10% of creators.", PT: "Você entrou no Top 10% dos criadores." },

  // Poll FOMO variants (rotated by attention engine).
  tl_poll_v0_title: { ES: "📊 78% cree que el local ganará", EN: "📊 78% think the home side will win", PT: "📊 78% acham que o mandante vai ganhar" },
  tl_poll_v0_desc:  { ES: "Vota antes de que cierre la encuesta.", EN: "Vote before the poll closes.", PT: "Vote antes que a enquete feche." },
  tl_poll_v1_title: { ES: "📊 El visitante pierde apoyo de la afición", EN: "📊 The away side is losing fan support", PT: "📊 O visitante perde apoio da torcida" },
  tl_poll_v1_desc:  { ES: "La opinión cambia minuto a minuto.", EN: "Opinion shifts minute by minute.", PT: "A opinião muda minuto a minuto." },
  tl_poll_v2_title: { ES: "📊 Local 51% | Visitante 49%", EN: "📊 Home 51% | Away 49%", PT: "📊 Mandante 51% | Visitante 49%" },
  tl_poll_v2_desc:  { ES: "Empate técnico. Tu voto puede inclinar la balanza.", EN: "Statistical tie. Your vote can tip the balance.", PT: "Empate técnico. Seu voto pode pesar." },
  tl_poll_v3_title: { ES: "📊 La comunidad predice cambio táctico", EN: "📊 The community predicts a tactical change", PT: "📊 A comunidade prevê mudança tática" },
  tl_poll_v3_desc:  { ES: "71% espera un giro en los próximos 5 min.", EN: "71% expect a shift in the next 5 minutes.", PT: "71% esperam uma virada nos próximos 5 min." },

  // Timeline modal chrome.
  tl_modal_live_event:   { ES: "Evento en vivo", EN: "Live event", PT: "Evento ao vivo" },
  tl_modal_min:          { ES: "Min {n}'", EN: "Min {n}'", PT: "Min {n}'" },
  tl_modal_reward_label: { ES: "Recompensa", EN: "Reward", PT: "Recompensa" },
  tl_modal_coupon_label: { ES: "Cupón", EN: "Coupon", PT: "Cupom" },
  tl_modal_close:        { ES: "Cerrar", EN: "Close", PT: "Fechar" },
  tl_aria_min:           { ES: "minuto {n}", EN: "minute {n}", PT: "minuto {n}" },
});
